import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useImperativeHandle,
  useLayoutEffect,
} from "react"
import { createPortal } from "react-dom"
import {
  Container,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Label,
  Input,
  Form,
  FormFeedback,
} from "reactstrap"

import "react-multi-carousel/lib/styles.css"

import { Link, useParams, useLocation, useNavigate } from "react-router-dom"
import classnames from "classnames"

import awicon from "../../../assets/images/services-icon/coin.png"
import correctIcon from "../../../assets/images/profile-avatars/correct.png"
import correct2ndIcon from "../../../assets/images/profile-avatars/correct2nd.png"
import incorrectIcon from "../../../assets/images/profile-avatars/incorrect.png"
import skippedIcon from "../../../assets/images/profile-avatars/Skipped.png"
import ks2CorrectIcon from "../../../assets/images/profile-avatars/ks2 correct.png"
import ks2Correct2ndIcon from "../../../assets/images/profile-avatars/ks2 correct2nd.png"
import ks2IncorrectIcon from "../../../assets/images/profile-avatars/ks2 incorrect.png"
import Select from "react-select"
import { SECURITY_KEY, BASE_URL } from "../../../global"
import dsmile from "../../../assets/images/services-icon/dog_smile.png"

import piratemale from "../../../assets/images/profile-avatars/avatar1/piratemale.png"

import piratefemale from "../../../assets/images/profile-avatars/avatar2/piratefemale.png"

//i18n
import axios from "axios"
// import { BASE_URL } from "../../global";

import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"

import moment from "moment"

import Loader from "react-spinner-loader"

import { MathJax, MathJaxContext } from "better-react-mathjax"
import { Popover, UncontrolledPopover, PopoverBody } from "reactstrap"
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap"
import { Table } from "reactstrap"

import {
  SpeakerButton,
  useSpeaker,
  htmlToText,
  ResultSpeakButton,
  isYearOneToThree,
} from "../../Utility/Usespeaker"
import {
  useOverlayOptions,
  OverlayUI,
  OverlayToggleButton,
  OVERLAY_FONTS,
  getKeyStage,
  getFontFamily,
} from "../../Utility/OverlayOptions"
// import { fontFamily } from "html2canvas/dist/types/css/property-descriptors/font-family"

const WritingAnswerInput = React.forwardRef(function WritingAnswerInput(
  { initialText, answerId, partId, disabled, className, autoFocus, onText },
  ref
) {
  const [text, setText] = useState(initialText ?? "")
  const textRef = useRef(initialText ?? "")
  const initialRef = useRef(initialText ?? "")
  const editedRef = useRef(false)
  const inputRef = useRef(null)

  useImperativeHandle(ref, () => ({
    getText: () => textRef.current,
    answerId,
    partId,
  }))

  useEffect(() => {
    if (editedRef.current) return
    const next = initialText ?? ""
    initialRef.current = next
    textRef.current = next
    setText(next)
  }, [initialText])

  useLayoutEffect(() => {
    const el = inputRef.current
    if (!el || !editedRef.current) return
    if (el.value !== textRef.current) el.value = textRef.current
  })

  useEffect(() => {
    const restore = () => {
      const el = inputRef.current
      if (!el || !editedRef.current) return
      if (
        el.value === initialRef.current &&
        textRef.current !== initialRef.current
      ) {
        el.value = textRef.current
      }
    }
    const id = setInterval(restore, 50)
    return () => clearInterval(id)
  }, [])

  return (
    <input
      ref={inputRef}
      type="text"
      value={text}
      disabled={disabled}
      className={className}
      autoFocus={autoFocus}
      autoComplete="off"
      autoCorrect="off"
      spellCheck="false"
      onChange={e => {
        const next = e.target.value
        if (
          editedRef.current &&
          textRef.current !== initialRef.current &&
          next === initialRef.current
        ) {
          return
        }
        if (next !== initialRef.current) editedRef.current = true
        textRef.current = next
        setText(next)
        if (onText) onText(next)
      }}
    />
  )
})

const Comprehension = React.memo(
  ({
    triggerFunction,
    data,
    part,
    triggerSubmitFunction,
    responceData,
    skipQuestionData,
    activitykey,
    activityLevel,
    setReTrySkipQuestion,
  }) => {
    //console.log(skipQuestionData)
    //console.log(activitykey)
    const authUser = JSON.parse(localStorage.getItem("authStudentUser")) || null

    const navigate = useNavigate()
    const { speak, stop, activeId } = useSpeaker()

    const CountTotalCoins = question => {
      let total_coins = 0

      if (question && question.length > 0) {
        question.forEach(activity => {
          if (activity.fk_sub_id === "1") {
            total_coins += activity.english_question?.reduce(
              (acc, question) =>
                acc + question.english_question_parts.length * 2,
              0
            )
          } else if (activity.fk_sub_id === "2" || activity.fk_sub_id === "3") {
            total_coins += activity.question?.reduce(
              (acc, question) => acc + question.question_parts.length * 2,
              0
            )
          }
        })
      }
      // setTotalCoins(total_coins);
      return total_coins
    }

    const [isValuefield, setValuefield] = useState(false)

    const [selectedAnswer, setselectedAnswer] = useState(null)
    const [selectedAnswerText, setselectedAnswerText] = useState([])
    const [writingBoxText, setWritingBoxText] = useState({})
    const [writingLocked, setWritingLocked] = useState(false)
    const writingTries = useRef(0)
    const writingPartKeyRef = useRef("")
    const writingEditedRef = useRef(false)
    const writingSeedRef = useRef({})
    const writingLiveRef = useRef({})
    const writingInputRefs = useRef({})

    const [nextQuestion, setnextQuestion] = useState(true)
    const [resultData, setresultData] = useState(null)
    const [IsSubmited, setIsSubmited] = useState(false)

    const [modal_standard, setmodal_standard] = useState(false)
    const [modal_standard1, setmodal_standard1] = useState(false)

    const [isFlagReport, setFlagReport] = useState(false)
    const [isQuestionReport, setQuestionReport] = useState(false)

    const [selectedGroup, setselectedGroup] = useState(null)

    const [SummryView, setSummryView] = useState(false)

    // ===== Overlay Options (color tint / font-size / intensity) — self-contained =====
    const [overlayPanelOpen, setOverlayPanelOpen] = useState(false)
    const overlayAnchorRef = useRef(null)
    const [overlayPanelPos, setOverlayPanelPos] = useState({ top: 0, right: 0 })
    const [isDarkMode, setIsDarkMode] = useState(false)
    useEffect(() => {
      if (!overlayPanelOpen) return
      function handleResize() {
        if (overlayAnchorRef.current) {
          const rect = overlayAnchorRef.current.getBoundingClientRect()
          setOverlayPanelPos({
            top: rect.bottom - 60,
            right: window.innerWidth - rect.right,
            maxHeight: window.innerHeight - (rect.bottom - 60) - 16,
          })
        }
      }
      window.addEventListener("resize", handleResize)
      return () => window.removeEventListener("resize", handleResize)
    }, [overlayPanelOpen])
    const overlayOptions = useOverlayOptions({      storageKey: "ov",
      initialFontStep: getKeyStage(activityLevel), // 0=Small  1=Medium  2=Large
      initialFontFamily: getFontFamily(activityLevel),
    })
    const keyStageIndex = getKeyStage(activityLevel)
    const keyStage =
      keyStageIndex === 0 ? "KS1" : keyStageIndex === 1 ? "KS2" : "KS3"
    function getOverlayCardStyle() {
      return overlayOptions.cardStyle
    }
    function getAnswerInputStyle() {
      const { fontFamily, fontSize, fontWeight } =
        overlayOptions.cardStyle || {}
      return {
        ...(fontFamily && { fontFamily }),
        ...(fontSize && { fontSize }),
        ...(fontWeight && { fontWeight }),
      }
    }
    const feedbackCorrectIcon =
      keyStage === "KS2" ? ks2CorrectIcon : correctIcon
    const feedbackCorrect2ndIcon =
      keyStage === "KS2" ? ks2Correct2ndIcon : correct2ndIcon
    const feedbackIncorrectIcon =
      keyStage === "KS2" ? ks2IncorrectIcon : incorrectIcon
    function renderFeedbackIcon(resultData, activePartData = null) {
      const hasAutomark =
        !activePartData ||
        activePartData.some(
          p =>
            parseInt(p.english_question_part_automark) === 1 &&
            p.StudentQusSkip?.length === 0
        )
      const isCorrect =
        hasAutomark && resultData && parseInt(resultData.is_correct) === 1
      const is2nd = isCorrect && parseInt(resultData.attempCount) >= 2
      const isSkipped = !isCorrect && resultData && !resultData.studentAnswer

      // KS3 — mdi icons only
      if (keyStage === "KS3") {
        if (is2nd)
          return (
            <i
              className="mdi mdi-check-circle-outline"
              style={{ fontSize: 60, color: "#fb8c00" }}
            />
          )
        if (isCorrect)
          return (
            <i
              className="mdi mdi-check-circle"
              style={{ fontSize: 60, color: "#34a853" }}
            />
          )
        if (isSkipped)
          return (
            <i
              className="mdi mdi-skip-next-circle"
              style={{ fontSize: 60, color: "#2563eb" }}
            />
          )
        return (
          <i
            className="mdi mdi-close-circle"
            style={{ fontSize: 60, color: "#e53935" }}
          />
        )
      }

      // KS1 + KS2 — use PNG images
      const src = is2nd
        ? feedbackCorrect2ndIcon
        : isCorrect
        ? feedbackCorrectIcon
        : isSkipped
        ? skippedIcon
        : feedbackIncorrectIcon
      const alt = isCorrect ? "Correct" : isSkipped ? "Skipped" : "Incorrect"
      return (
        <img
          src={src}
          alt={alt}
          style={keyStage === "KS2" ? { animation: "none" } : undefined}
        />
      )
    }
    function renderOverlayToggle() {
      return (
        <div className="mg-ov-anchor" ref={overlayAnchorRef}>
          <OverlayToggleButton
            onClick={() => {
              if (overlayAnchorRef.current) {
                const rect = overlayAnchorRef.current.getBoundingClientRect()
                setOverlayPanelPos({
                  top: rect.bottom - 60,
                  right: window.innerWidth - rect.right,
                  maxHeight: window.innerHeight - (rect.bottom - 60) - 16,
                })
              }
              setOverlayPanelOpen(o => !o)
            }}
          />
          <OverlayUI
            {...overlayOptions}
            panelOpen={overlayPanelOpen}
            setPanelOpen={setOverlayPanelOpen}
            onReset={overlayOptions.resetDefaults}
            panelPos={overlayPanelPos}
            isDarkMode={isDarkMode}
          />
        </div>
      )
    }

    function renderDarkModeToggle() {
      if (keyStage !== "KS3") return null
      return (
        <button
          type="button"
          onClick={() => setIsDarkMode(d => !d)}
          title={isDarkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 7,
            padding: "8px 16px",
            borderRadius: 999,
            border: isDarkMode ? "1px solid #4f6aad" : "1px solid #D1D9E6",
            background: isDarkMode ? "#1e2a45" : "#fff",
            color: isDarkMode ? "#c9d6f0" : "#1E293B",
            fontWeight: 700,
            fontSize: 14,
            cursor: "pointer",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            transition: "all 0.2s ease",
          }}
        >
          <i
            className={`mdi ${
              isDarkMode ? "mdi-weather-sunny" : "mdi-weather-night"
            }`}
            style={{ fontSize: 18 }}
          />
          {isDarkMode ? "Light" : "Dark"}
        </button>
      )
    }

    // // ===== end Overlay Options =====

    // Rendered OUTSIDE the scrollable .question_container so it stays visible
    // instead of getting clipped/scrolled away with the question content.
    function renderNextButton() {
      if (!(!nextQuestion && resultData && !resultData.LastQuestion))
        return null
      return (
        <div className="nv-next-btn-anchor">
          <Button
            className="next-btn-question btn btn-danger cs-btn-danger nv-mini-next-btn"
            onClick={() => {
              triggerFunction()
              setnextQuestion(false)
              setActivePartData([])
              setIsSubmited(false)
              setresultData(null)
            }}
          >
            <span className="nv-next-btn-text">Next</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-fast-forward-icon lucide-fast-forward"
            >
              <path d="M12 6a2 2 0 0 1 3.414-1.414l6 6a2 2 0 0 1 0 2.828l-6 6A2 2 0 0 1 12 18z" />
              <path d="M2 6a2 2 0 0 1 3.414-1.414l6 6a2 2 0 0 1 0 2.828l-6 6A2 2 0 0 1 2 18z" />
            </svg>
          </Button>
        </div>
      )
    }

    //const ActivePartData = part;
    const [ActivePartData, setActivePartData] = useState([])
    const [ActivityData1, setActivityData1] = useState(null)
    //console.log(ActivityData1)
    const [SkipQuestionCount, setSkipQuestionCount] = useState(skipQuestionData)

    // Reading comp / passage textareas: grow with typed content; keep user drag height
    useEffect(() => {
      const MIN_H = 91
      const isPassageTextarea = el =>
        el instanceof HTMLTextAreaElement &&
        el.closest(".question-container-custom")

      const growTextarea = ta => {
        if (!isPassageTextarea(ta)) return
        const dragFloor = Number(ta.dataset.dragHeight) || 0
        ta.style.height = "auto"
        const next = Math.max(ta.scrollHeight, dragFloor, MIN_H)
        ta.style.height = `${next}px`
      }

      const onInput = e => growTextarea(e.target)
      const onPointerUp = e => {
        if (!isPassageTextarea(e.target)) return
        e.target.dataset.dragHeight = String(e.target.offsetHeight)
      }

      document.addEventListener("input", onInput, true)
      document.addEventListener("pointerup", onPointerUp, true)

      document
        .querySelectorAll(".question-container-custom textarea")
        .forEach(growTextarea)

      return () => {
        document.removeEventListener("input", onInput, true)
        document.removeEventListener("pointerup", onPointerUp, true)
      }
    }, [ActivityData1])

    useEffect(() => {
      // console.log(data)
      // console.log(part)
      if (part && part != "" && data && data != "") {
        const partKey = `${data?.fk_question_id || ""}:${
          part?.[0]?.english_question_part_id || part?.[0]?.part_id || ""
        }`
        if (writingPartKeyRef.current === partKey) {
          setActivityData1(data)
          return
        }
        writingPartKeyRef.current = partKey
        writingEditedRef.current = false
        writingSeedRef.current = {}
        writingLiveRef.current = {}
        writingInputRefs.current = {}
        setActivityData1(data)
        setActivePartData(part)
        setValuefield(false)
        setselectedAnswer(null)
        setselectedAnswerText([])
        const seededBoxes = {}
        for (const questionPart of part) {
          for (const attempt of questionPart.StudentAnsAttempts || []) {
            let items = []
            try {
              items = JSON.parse(attempt.student_answer)
            } catch (error) {
              items = []
            }
            if (!Array.isArray(items)) continue
            for (const item of items) {
              if (
                item == null ||
                item.answer_id == null ||
                item.text == null ||
                String(item.text) === ""
              )
                continue
              seededBoxes[String(item.answer_id)] = item.text
            }
          }
        }
        writingSeedRef.current = seededBoxes
        writingLiveRef.current = { ...seededBoxes }
        setWritingBoxText(seededBoxes)
        const attemptRows = Array.isArray(part)
          ? Math.max(
              0,
              ...part.map(p => (p.StudentAnsAttempts || []).length),
              0
            )
          : 0
        writingTries.current = attemptRows
        setWritingLocked(attemptRows >= 2)

        setnextQuestion(true)
        setresultData(null)
        setIsSubmited(false)

        setmodal_standard(false)
        setmodal_standard1(false)
        setFlagReport(false)
        setQuestionReport(false)
        setselectedGroup(null)

        setSummryView(false)
        setSkipQuestionCount(skipQuestionData)
        } else {
        writingPartKeyRef.current = ""
        if (activitykey && activitykey != "") {
          setActivityData1(null)
          setActivePartData([])
          setSkipQuestionCount(skipQuestionData)
        }
        // setSkipQuestionCount(skipQuestionData)
      }
    }, [part, data])

    const isReadingOrWritingQuestion = () => {
      const cat = parseInt(
        ActivityData1?.english_question?.[0]?.english_question_category_id,
        10
      )
      return [2, 8, 12, 10, 13].includes(cat)
    }

    const readingWritingIds = () => {
      const partId =
        ActivePartData?.[0]?.english_question_part_id ??
        ActivePartData?.[0]?.part_id ??
        ""
      const questionId = ActivityData1?.fk_question_id ?? ""
      const activityId =
        activitykey || ActivityData1?.fk_lesson_activity_key || ""
      return { partId, questionId, activityId }
    }

    const isExpiredStudentToken = error =>
      (error?.response?.status === 403 || error?.response?.status === 401) &&
      (error?.response?.data?.error === "jwt expired" ||
        error?.response?.data?.error === "invalid algorithm" ||
        error?.response?.data?.error === "invalid token")

    const savingDraftRef = useRef(false)

    // Put a saved answer back. A first submitted attempt stays on the question,
    // so the draft must replace that attempt's text. A finished second attempt
    // does not.
    useEffect(() => {
      if (!ActivityData1 || !ActivePartData?.length) return
      if (!isReadingOrWritingQuestion()) return
      const attemptRows = Math.max(
        0,
        ...ActivePartData.map(p => (p.StudentAnsAttempts || []).length)
      )
      if (attemptRows >= 2) return
      const { partId, questionId, activityId } = readingWritingIds()
      if (!authUser || !activityId || questionId === "" || partId === "") return

      let cancelled = false
      axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
      axios
        .post(BASE_URL + "studentAnswer/getAnswerDraft", {
          lesson_activity_key: activityId,
          question_id: questionId,
          part_id: partId,
        })
        .then(response => {
          if (cancelled) return
          const drafts = Array.isArray(response.data) ? response.data : []
          const match =
            drafts.find(
              item =>
                String(item.part_id) === String(partId) &&
                String(item.question_id) === String(questionId)
            ) || null
          const answer =
            match && Array.isArray(match.answer_text) ? match.answer_text : []
          if (answer.length > 0) {
            const cat = parseInt(
              ActivityData1?.english_question?.[0]?.english_question_category_id,
              10
            )
            if (cat === 10 || cat === 13) {
              if (writingEditedRef.current) return
              const map = {}
              for (const item of answer) {
                if (item == null || item.answer_id == null || item.text == null)
                  continue
                map[String(item.answer_id)] = item.text
              }
              writingSeedRef.current = map
              writingLiveRef.current = { ...map }
              setWritingBoxText(map)
            }
            setselectedAnswerText(prev =>
              prev && prev.length > 0 ? prev : answer
            )
            setValuefield(true)
          }
        })
        .catch(error => {
          if (cancelled) return
          if (isExpiredStudentToken(error)) {
            localStorage.clear()
            navigate("/login")
          }
        })

      return () => {
        cancelled = true
      }
    }, [ActivityData1, ActivePartData, activitykey])

    const writingAnswersFromBoxes = partId => {
      const answers = []
      for (const handle of Object.values(writingInputRefs.current || {})) {
        if (!handle || typeof handle.getText !== "function") continue
        const ticked = (selectedAnswerText || []).some(
          item =>
            item &&
            String(item.answer_id) === String(handle.answerId) &&
            item.text === "✔"
        )
        answers.push({
          answer_id: handle.answerId,
          part_id: handle.partId ?? partId,
          text: ticked ? "✔" : handle.getText(),
          is_skip: 0,
        })
      }
      return answers
    }

    const handleSaveAndExit = async e => {
      if (e) {
        e.preventDefault()
        e.stopPropagation()
      }
      if (!isReadingOrWritingQuestion() || savingDraftRef.current) return
      const { partId, questionId, activityId } = readingWritingIds()
      if (!authUser || !activityId || questionId === "" || partId === "") {
        toast.error("Unable to save progress.", { autoClose: 1000 })
        return
      }
      savingDraftRef.current = true
      const cat = parseInt(
        ActivityData1?.english_question?.[0]?.english_question_category_id,
        10
      )
      let answerText = Array.isArray(selectedAnswerText) ? selectedAnswerText : []
      if (cat === 10 || cat === 13) {
        answerText = writingAnswersFromBoxes(partId)
      }
      try {
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        await axios.post(BASE_URL + "studentAnswer/saveAnswerDraft", {
          lesson_activity_key: activityId,
          question_id: questionId,
          part_id: partId,
          answer_text: answerText,
        })
        toast.success("Progress saved.", { autoClose: 1000 })
        window.history.back()
      } catch (error) {
        savingDraftRef.current = false
        if (isExpiredStudentToken(error)) {
          localStorage.clear()
          navigate("/login")
          return
        }
        toast.error("Unable to save progress.", { autoClose: 1000 })
      }
    }

    const submitReadingWriting = () => {
      const writingCat = parseInt(
        ActivityData1?.english_question?.[0]?.english_question_category_id,
        10
      )
      if (writingCat === 10 || writingCat === 13) {
        const partId =
          ActivePartData?.[0]?.english_question_part_id ??
          ActivePartData?.[0]?.part_id ??
          null
        const answers = writingAnswersFromBoxes(partId)
        if (!answers.length) return
        writingSeedRef.current = Object.fromEntries(
          answers.map(item => [String(item.answer_id), item.text])
        )
        writingTries.current += 1
        if (writingTries.current >= 2) setWritingLocked(true)
        setselectedAnswerText(answers)
        triggerSubmitFunction(answers)
        setIsSubmited(true)
        return
      }
      const byId = new Map()
      for (const item of latestWritingBoxValues()) {
        byId.set(String(item.answer_id), { ...item })
      }
      for (const item of selectedAnswerText || []) {
        if (item == null || item.answer_id == null) continue
        const key = String(item.answer_id)
        byId.set(key, { ...(byId.get(key) || {}), ...item })
      }
      // Reading boxes never write their typed text into writingBoxText (it
      // only holds the first attempt / draft), so it must never override
      // what was typed; use it only for boxes that have no value at all.
      for (const [key, text] of Object.entries(writingBoxText)) {
        if (byId.has(key)) continue
        byId.set(key, { answer_id: key, part_id: null, is_skip: 0, text })
      }
      const answers = Array.from(byId.values())
      writingTries.current += 1
      if (writingTries.current >= 2) setWritingLocked(true)
      const map = {}
      for (const item of answers) {
        if (item == null || item.answer_id == null || item.text == null) continue
        map[String(item.answer_id)] = item.text
      }
      if (Object.keys(map).length) setWritingBoxText(map)
      setselectedAnswerText(answers)
      triggerSubmitFunction(answers)
      setIsSubmited(true)
    }

    useEffect(() => {
      if (activitykey && activitykey != "") {
        setSkipQuestionCount(skipQuestionData)
      }
    }, [skipQuestionData])

    // Skip Question is built deep inside the answer-options loop (it needs
    // that loop's `qusAns`/`quspart` closure to know what it's skipping), but
    // it must render outside the bordered question card, not nested inside
    // it. A portal lets it stay written where the loop's data lives while
    // actually mounting into `skipAnchorEl`, a plain sibling div rendered
    // right after the card closes (see .skip-anchor usages below).
    const [skipAnchorEl, setSkipAnchorEl] = useState(null)

    // Skip/Submit are pinned via `position: fixed` to the viewport bottom so
    // they stay reachable when a tall/image-heavy question forces the card
    // to scroll (see .skip-button / .submit-btn-question in index.css), but
    // that leaves a large empty gap under a short question. When the
    // rendered card is under 80% of the viewport height, flag it via a body
    // class that lets those buttons fall into normal flow instead.
    useEffect(() => {
      let observedEl = null
      let rafId = null
      // Applying the class change is deferred to the next animation frame
      // (rather than done inline in the observer callback) because toggling
      // it flips Skip/Submit between fixed and static, which changes the
      // observed element's own height — mutating the observed target inside
      // its own callback re-triggers the observer in the same frame and
      // trips the browser's "ResizeObserver loop" guard.
      const applyCompactState = () => {
        rafId = null
        if (!observedEl) return
        let height = observedEl.getBoundingClientRect().height
        // Skip/Submit switch between `position: fixed` (out of flow, no
        // contribution here) and `position: static` (in flow, adding their
        // own height into this box) based on the class toggled below. If
        // that in-flow height is left in the measurement, going compact
        // grows the box back over the threshold, which flips it non-compact
        // again, which shrinks it back under the threshold — flickering
        // every frame. Subtract their current in-flow contribution so the
        // height being compared stays the same regardless of which mode
        // they're already in.
        observedEl
          .querySelectorAll(".skip-button, .submit-actions-fixed")
          .forEach(btn => {
            const style = getComputedStyle(btn)
            if (style.position === "static") {
              height -=
                btn.getBoundingClientRect().height +
                parseFloat(style.marginTop || 0) +
                parseFloat(style.marginBottom || 0)
            }
          })
        observedEl.querySelectorAll(".submit-btn-question").forEach(btn => {
          if (btn.closest(".submit-actions-fixed")) return
          const style = getComputedStyle(btn)
          if (style.position === "static") {
            height -=
              btn.getBoundingClientRect().height +
              parseFloat(style.marginTop || 0) +
              parseFloat(style.marginBottom || 0)
          }
        })
        document.body.classList.toggle(
          "mg-compact-question",
          height > 0 && height < window.innerHeight * 0.8
        )
      }
      const scheduleCheck = () => {
        if (rafId) cancelAnimationFrame(rafId)
        rafId = requestAnimationFrame(applyCompactState)
      }
      const ro = new ResizeObserver(scheduleCheck)
      // Measure the question's own content <li>, not the surrounding
      // .question_container <ul> — that ul has `max-height` + `overflow-y:
      // auto`, so its rendered box is clamped well under most viewports'
      // 80% mark even when the actual content is long enough to need
      // scrolling (which made every question register as "compact"). The
      // <li> itself is never clamped — only its ancestor scrolls it — so
      // its rendered height always reflects the true, un-clamped content.
      const hwList = document.querySelector(".hw-list")
      const el =
        (hwList && hwList.querySelector(".question_container > li")) ||
        hwList
      if (el) {
        observedEl = el
        ro.observe(el)
      }
      window.addEventListener("resize", scheduleCheck)
      return () => {
        if (rafId) cancelAnimationFrame(rafId)
        window.removeEventListener("resize", scheduleCheck)
        ro.disconnect()
        document.body.classList.remove("mg-compact-question")
      }
    }, [ActivePartData, ActivityData1, resultData, nextQuestion, SummryView])

    function handleSelectGroup(selectedGroup) {
      setselectedGroup(selectedGroup)
    }

    const tog_standard1 = () => {
      setmodal_standard1(!modal_standard1)
    }

    const optionGroup = [
      // {
      // label: "Select Subject",
      // options: [
      { label: "Spelling error / Typo", value: "Spelling error / Typo" },
      { label: "The solution is wrong", value: "The solution is wrong" },
      {
        label: "The question is not relevant to the topic",
        value: "The question is not relevant to the topic",
      },
      {
        label: "The question cannot be solved",
        value: "The question cannot be solved",
      },
      {
        label: "The question is incomplete",
        value: "The question is incomplete",
      },
      { label: "Others", value: "Others" },
      // ],
      // },
    ]
    const [ResonTextData, setResonText] = useState("")
    function textareachange(event) {
      const text = event.target.value
      // if (count > 0) {
      setResonText(text)
      // }
      //settextcount(event.target.value.length)
    }

    const validation = useFormik({
      // enableReinitialize : use this flag when initial values needs to be changed
      enableReinitialize: true,
      initialValues: {
        reson: "",
        reson_text: "",
      },
      validationSchema: Yup.object({
        reson: Yup.mixed().required("Select a reason is required."),
        reson_text: Yup.string()
          .min(2, "Minimum 2 characters is required.")
          .max(250, "Maximum 250 characters is required.")
          .required("Reason is required.")
          .test(
            "not-empty-spaces",
            "Reason cannot be empty or just spaces.",
            value => value && value.trim().length > 0
          ),
      }),
      onSubmit: async values => {
        // console.log(values);

        if (authUser && authUser != "" && authUser != null) {
          setFlagReport(true)
          axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
          axios
            .post(BASE_URL + "studentSession/flagReport", {
              fk_lesson_activity_key: ActivityData1.fk_lesson_activity_key,
              fk_lesson_activity_question_key:
                ActivityData1.pk_lesson_activity_question_key,
              fk_sub_id: ActivityData1.fk_sub_id,
              question_id: ActivityData1.fk_question_id,
              // reson_text: ResonTextData,
              // reson: selectedGroup
              ...values,
            })
            .then(responseFlag => {
              //console.log(responseSessionEnd.data);
              // Assuming the API response is an array of objects with 'id' and 'value' properties
              if (parseInt(responseFlag.data) === 1) {
                tog_standard()
                setFlagReport(false)
                toast.success(
                  "Thank you! Our Curriculum team will review and add 5 coins if the issue reported is correct.",
                  {
                    autoClose: 3000, // 3 seconds in this example
                  }
                )
              } else if (parseInt(responseFlag.data) === 2) {
                tog_standard()
                setFlagReport(false)
                toast.error("Already submitted a report on this question", {
                  autoClose: 3000, // 3 seconds in this example
                })
              } else {
                tog_standard()
                setFlagReport(false)
                toast.error("Failure! Unable to insert data. Try again later", {
                  autoClose: 3000, // 3 seconds in this example
                })
              }
            })
            .catch(error => {
              //console.log(error)
              tog_standard()
              setFlagReport(false)
              if (
                (error?.response?.status === 403 ||
                  error?.response?.status === 401) &&
                (error?.response?.data?.error === "jwt expired" ||
                  error?.response?.data?.error === "invalid algorithm" ||
                  error?.response?.data?.error === "invalid token")
              ) {
                localStorage.clear()
                navigate("/login")
              }
            })
        } else {
          setFlagReport(false)
          navigate("/login")
        }

        //dispatch(loginUser(values, props.router.navigate));
      },
    })

    const tog_standard = () => {
      setmodal_standard(!modal_standard)
      validation.resetForm()
      setselectedGroup(null)
      setResonText("")
    }

    
    function submitQuestionReport() {
      if (authUser && authUser != "" && authUser != null) {
        setQuestionReport(true)
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        axios
          .post(BASE_URL + "studentSession/questionReport", {
            fk_lesson_activity_key: ActivityData1.fk_lesson_activity_key,
            fk_lesson_activity_question_key:
              ActivityData1.pk_lesson_activity_question_key,
            fk_sub_id: ActivityData1.fk_sub_id,
            question_id: ActivityData1.fk_question_id,
          })
          .then(responseQus => {
            //console.log(responseSessionEnd.data);
            // Assuming the API response is an array of objects with 'id' and 'value' properties
            if (parseInt(responseQus.data) === 1) {
              tog_standard1()
              setQuestionReport(false)
              toast.success(
                "Thank you! Our Curriculum team will review and add 5 coins if the issue reported is correct.",
                {
                  autoClose: 3000, // 3 seconds in this example
                }
              )
            } else if (parseInt(responseQus.data) === 2) {
              tog_standard1()
              setQuestionReport(false)
              toast.error("Already submitted a report on this question", {
                autoClose: 3000, // 3 seconds in this example
              })
            } else {
              tog_standard1()
              setQuestionReport(false)
              toast.error("Failure! Unable to insert data. Try again later", {
                autoClose: 3000, // 3 seconds in this example
              })
            }
          })
          .catch(error => {
            //console.log(error)
            tog_standard1()
            setQuestionReport(false)
            if (
              (error?.response?.status === 403 ||
                error?.response?.status === 401) &&
              (error?.response?.data?.error === "jwt expired" ||
                error?.response?.data?.error === "invalid algorithm" ||
                error?.response?.data?.error === "invalid token")
            ) {
              localStorage.clear()
              navigate("/login")
            }
          })
      } else {
        tog_standard1()
        setQuestionReport(false)
        navigate("/login")
      }
    }

    const [IsSkipButton, setIsSkipButton] = useState(0)
    //caregory 1
    const selectedAnsOption = async (answer, is_skip = 0) => {
      //console.log(answer);

      if (parseInt(ActivityData1.fk_sub_id) === 1) {
        setselectedAnswer(answer.english_answer_id)
        let result = [
          {
            part_id: answer.english_answer_part_id,
            answer_id: answer.english_answer_id,
            text: answer.english_answer_text,
            is_skip: is_skip,
          },
        ]
        setselectedAnswerText(result)

        if (is_skip == 1) {
          setIsSkipButton(1)
        }
      } else {
        setselectedAnswer(answer.answer_id)
        let result = [
          {
            part_id: answer.answer_part_id,
            answer_id: answer.answer_id,
            text: answer.answer_text,
            is_skip: is_skip,
          },
        ]
        setselectedAnswerText(result)

        if (is_skip == 1) {
          setIsSkipButton(1)
        }
      }

      //  const jsonString = JSON.stringify(result).replace(/\"/g, '\\"');
      //console.log(result);
    }

    //category 8

    // // Initialize state for answerText with initial data
    // const [answerText, setAnswerText] = useState([]);

    async function handletext(e, answer_id, part_id, is_skip = 0) {
      //console.log(e)
      var answer_text = ""
      if (is_skip == 1) {
        answer_text = e
      } else {
        answer_text = e.target.value
      }
      //CountAnswerQuestion(part_id,answer_id, e.target.value);
      setselectedAnswerText(prevAnswerText => {
        // console.log(prevAnswerText);
        if (!answer_text.trim()) {
          // If text is empty or contains only whitespace, remove the corresponding entry
          return prevAnswerText.filter(item => item.answer_id !== answer_id)
        } else {
          const existingAnswerIndex = prevAnswerText.findIndex(
            item => item.answer_id === answer_id
          )

          if (existingAnswerIndex !== -1) {
            // If answer_id already exists, update the text
            const updatedAnswerText = [...prevAnswerText]
            updatedAnswerText[existingAnswerIndex] = {
              part_id: part_id,
              answer_id: answer_id,
              text: answer_text,
              is_skip: is_skip,
            }
            return updatedAnswerText
          } else {
            // If answer_id does not exist, add the new answer
            return [
              ...prevAnswerText,
              {
                part_id: part_id,
                answer_id: answer_id,
                text: answer_text,
                is_skip: is_skip,
              },
            ]
          }
        }
      })

      setValuefield(true)
      if (is_skip == 1) {
        setIsSkipButton(1)
      }
    }

    function parseAttemptList(raw) {
      if (Array.isArray(raw)) return raw
      if (typeof raw !== "string" || raw === "") return []
      try {
        const parsed = JSON.parse(raw)
        return Array.isArray(parsed) ? parsed : []
      } catch (error) {
        return []
      }
    }

    function latestWritingBoxValues() {
      const byId = new Map()
      for (const part of ActivePartData || []) {
        for (const attempt of part.StudentAnsAttempts || []) {
          for (const item of parseAttemptList(attempt.student_answer)) {
            if (item == null || item.text == null || String(item.text) === "")
              continue
            byId.set(String(item.answer_id), {
              part_id: item.part_id,
              answer_id: item.answer_id,
              text: item.text,
              is_skip: item.is_skip || 0,
            })
          }
        }
      }
      return Array.from(byId.values())
    }

    async function handleAllowSpacetext(e, answer_id, part_id, is_skip = 0) {
      //console.log(e)
      var answer_text = ""
      if (is_skip == 1) {
        answer_text = e
      } else {
        answer_text = e.target.value
      }
      //CountAnswerQuestion(part_id,answer_id, e.target.value);
      setselectedAnswerText(prevAnswerText => {
        const sameBox = item => parseInt(item.answer_id) === parseInt(answer_id)
        const base = Array.isArray(prevAnswerText) ? prevAnswerText : []
        if (!answer_text) {
          return base.map(item =>
            sameBox(item)
              ? {
                  part_id: part_id,
                  answer_id: answer_id,
                  text: "",
                  is_skip: is_skip,
                }
              : item
          )
        } else {
          const existingAnswerIndex = base.findIndex(sameBox)

          if (existingAnswerIndex !== -1) {
            // If answer_id already exists, update the text
            const updatedAnswerText = [...base]
            updatedAnswerText[existingAnswerIndex] = {
              part_id: part_id,
              answer_id: answer_id,
              text: answer_text,
              is_skip: is_skip,
            }
            return updatedAnswerText
          } else {
            // If answer_id does not exist, add the new answer
            return [
              ...base,
              {
                part_id: part_id,
                answer_id: answer_id,
                text: answer_text,
                is_skip: is_skip,
              },
            ]
          }
        }
      })
      setValuefield(true)
      if (is_skip == 1) {
        setIsSkipButton(1)
      }
    }
    async function handletextCheck(e, answer_id, part_id, is_skip = 0) {
      //console.log(e)
      var answer_text = e
      //CountAnswerQuestion(part_id,answer_id, e.target.value);
      setselectedAnswerText(prevAnswerText => {
        if (!answer_text.trim()) {
          // If text is empty or contains only whitespace, remove the corresponding entry
          return prevAnswerText.filter(item => item.answer_id !== answer_id)
        } else {
          const existingAnswerIndex = prevAnswerText.findIndex(
            item => item.answer_id === answer_id
          )

          if (existingAnswerIndex !== -1) {
            // If answer_id already exists, update the text
            const updatedAnswerText = [...prevAnswerText]
            updatedAnswerText[existingAnswerIndex] = {
              part_id: part_id,
              answer_id: answer_id,
              text: answer_text,
              is_skip: is_skip,
            }
            return updatedAnswerText
          } else {
            // If answer_id does not exist, add the new answer
            return [
              ...prevAnswerText,
              {
                part_id: part_id,
                answer_id: answer_id,
                text: answer_text,
                is_skip: is_skip,
              },
            ]
          }
        }
      })
      setValuefield(true)
      if (is_skip == 1) {
        setIsSkipButton(1)
      }
    }

    useEffect(() => {
      if (parseInt(IsSkipButton) === 1 && selectedAnswerText != "") {
        triggerSubmitFunction(selectedAnswerText)
        setIsSubmited(true)
      }
    }, [IsSkipButton, selectedAnswerText])

    const textAreaRefs = useRef([])
    useEffect(() => {
      // Set focus to the first textarea when the component mounts
      //console.log(textAreaRefs.current[1])
      if (textAreaRefs.current[1]) {
        textAreaRefs.current[1].focus()
        // console.log('focused')
      }
    }, [ActivePartData, textAreaRefs.current[1]])
    
    useEffect(() => {
      //console.log(responceData);

      if (responceData && responceData != null) {
        setIsSubmited(false)
        setselectedAnswer(null)
        setIsSkipButton(0)
        // Derive studentAnswer + explanation when the backend doesn't return them
        const writingCatForResult = parseInt(
          ActivityData1?.english_question?.[0]?.english_question_category_id,
          10
        )
        let attemptRowsForResult = Array.isArray(responceData.answerArray)
          ? [...responceData.answerArray]
          : []
        if (
          (writingCatForResult === 10 || writingCatForResult === 13) &&
          attemptRowsForResult.length > 1
        ) {
          attemptRowsForResult = [
            attemptRowsForResult.reduce((latest, row) =>
              Number(row?.atempt_count || 0) >=
              Number(latest?.atempt_count || 0)
                ? row
                : latest
            ),
          ]
        }
        const derivedStudentAnswer =
          responceData.studentAnswer ||
          attemptRowsForResult
            .flatMap(a => {
              try {
                return JSON.parse(a.student_answer)
              } catch {
                return []
              }
            })
            .map(item => item.text)
            .filter(Boolean)
            .join(", ")
        const isBlankFeedback = html =>
          !html ||
          html.trim() === "<p><br></p>" ||
          html.trim() === "<br>" ||
          html
            .replace(/<[^>]*>/g, "")
            .replace(/&nbsp;/g, "")
            .trim() === ""
        const derivedExplanation =
          responceData.explanation ||
          (() => {
            let correctAnswerText = null
            for (const part of ActivePartData) {
              for (const ans of part.english_question_answers ||
                part.question_answers ||
                []) {
                const isCorrectAns =
                  parseInt(ans.english_answer_is_correct) === 1 ||
                  parseInt(ans.answer_is_correct) === 1
                const feedback =
                  ans.english_answer_feedback || ans.answer_feedback
                // Prefer explicit feedback text
                if (isCorrectAns && !isBlankFeedback(feedback)) return feedback
                // Store correct answer text as fallback
                if (isCorrectAns && !correctAnswerText) {
                  correctAnswerText = (
                    ans.english_answer_text ||
                    ans.answer_text ||
                    ""
                  )
                    .replace(/<[^>]*>/g, "")
                    .replace(/&nbsp;/g, " ")
                    .trim()
                }
              }
            }
            if (correctAnswerText) {
              return `Correct answer: ${correctAnswerText}`
            }
            return null
          })()
        const enrichedData = {
          ...responceData,
          studentAnswer: derivedStudentAnswer,
          explanation: derivedExplanation,
        }
        setresultData(enrichedData)
        let ansStatus = responceData.is_correct || null
        //setresultData(responceData);
        if (parseInt(ansStatus) === 3) {
          if (parseInt(ActivityData1.fk_sub_id) === 1) {
            //english functionality correct answer start
            if (responceData.answerArray.length >= 0) {
              //console.log(responceData.answerArray);
              // Create a copy of ActiveData
              const updatedData = [...ActivePartData]

              // Update the copied data
              updatedData.forEach(quspart => {
                //console.log(quspart)
                // quspart.english_question_answers.forEach((qusAns) => {
                // Assign answerArray directly to StudentAnsAttempts
                quspart.StudentAnsAttempts = responceData.answerArray
                // });
              })
              // Update the state with the modified data
              setActivePartData(updatedData)

              setselectedAnswerText([])

              if (
                ActivityData1 &&
                ActivityData1.english_question &&
                ActivityData1.english_question.length > 0 &&
                ActivityData1.english_question[0]
                  .english_question_category_id &&
                (ActivityData1.english_question[0]
                  .english_question_category_id === 8 ||
                  ActivityData1.english_question[0]
                    .english_question_category_id === 2 ||
                  ActivityData1.english_question[0]
                    .english_question_category_id === 12)
              ) {
                if (responceData && responceData.LastQuestion) {
                  setSummryView(true)
                  setSkipQuestionCount(SkipQuestionCount + 1)
                } else {
                  // window.location.reload();
                  triggerFunction()
                }
              } else if (
                ActivityData1.english_question[0]
                  .english_question_category_id === 13 ||
                ActivityData1.english_question[0]
                  .english_question_category_id === 10
              ) {
                if (responceData && responceData.LastQuestion) {
                  setSummryView(true)
                  setSkipQuestionCount(SkipQuestionCount + 1)
                } else {
                  // window.location.reload();
                  triggerFunction()
                }
              } else {
                if (responceData && responceData.LastQuestion) {
                  setSummryView(true)
                  setSkipQuestionCount(SkipQuestionCount + 1)
                } else {
                  triggerFunction()
                  //setnextQuestion(false)
                }
              }
            }
            //english functionality correct answer end
          } else {
            if (responceData.answerArray.length >= 0) {
              //console.log(responceData.answerArray);
              // Create a copy of ActiveData
              const updatedData = [...ActivePartData]

              // Update the copied data
              updatedData.forEach(quspart => {
                //console.log(quspart)
                // quspart.english_question_answers.forEach((qusAns) => {
                // Assign answerArray directly to StudentAnsAttempts
                quspart.StudentAnsAttempts = responceData.answerArray
                // });
              })
              // Update the state with the modified data
              setActivePartData(updatedData)

              setselectedAnswerText([])

              if (
                parseInt(ActivityData1.is_current_tab_total_part) ===
                parseInt(ActivityData1.is_current_tab_current_part)
              ) {
                //setSummryView(true)
                if (responceData && responceData.LastQuestion) {
                  setSummryView(true)
                  setSkipQuestionCount(SkipQuestionCount + 1)
                } else {
                  triggerFunction()
                  //setnextQuestion(false)
                }
              } else {
                // window.location.reload();
                triggerFunction()
              }
            }
          }
        } else if (parseInt(ansStatus) === 1) {
          //green color
          if (parseInt(ActivityData1.fk_sub_id) === 1) {
            //english functionality correct answer start
            if (responceData.answerArray.length > 0) {
              //console.log(responceData.answerArray);
              // Create a copy of ActiveData
              const updatedData = [...ActivePartData]

              // Update the copied data
              updatedData.forEach(quspart => {
                //console.log(quspart)
                // quspart.english_question_answers.forEach((qusAns) => {
                // Assign answerArray directly to StudentAnsAttempts
                quspart.StudentAnsAttempts = responceData.answerArray
                // });
              })
              // Update the state with the modified data
              setActivePartData(updatedData)

              setselectedAnswerText([])

              if (
                ActivityData1 &&
                ActivityData1.english_question &&
                ActivityData1.english_question.length > 0 &&
                ActivityData1.english_question[0]
                  .english_question_category_id &&
                (ActivityData1.english_question[0]
                  .english_question_category_id === 8 ||
                  ActivityData1.english_question[0]
                    .english_question_category_id === 2 ||
                  ActivityData1.english_question[0]
                    .english_question_category_id === 12)
              ) {
                if (
                  (responceData && responceData.LastQuestion) ||
                  ActivityData1.is_current_tab_current_part ===
                    ActivityData1.is_current_tab_total_part
                ) {
                  setnextQuestion(false)
                } else {
                  // window.location.reload();
                  triggerFunction()
                }
              } else if (
                ActivityData1.english_question[0]
                  .english_question_category_id === 13 ||
                ActivityData1.english_question[0]
                  .english_question_category_id === 10
              ) {
                if (
                  (responceData && responceData.LastQuestion) ||
                  ActivityData1.is_first_question ===
                    ActivityData1.is_last_question
                ) {
                  setnextQuestion(false)
                } else {
                  // window.location.reload();
                  triggerFunction()
                }
              } else {
                setnextQuestion(false)
              }
            }
            //english functionality correct answer end
          } else {
            if (responceData.answerArray.length > 0) {
              //console.log(responceData.answerArray);
              // Create a copy of ActiveData
              const updatedData = [...ActivePartData]

              // Update the copied data
              updatedData.forEach(quspart => {
                //console.log(quspart)
                // quspart.english_question_answers.forEach((qusAns) => {
                // Assign answerArray directly to StudentAnsAttempts
                quspart.StudentAnsAttempts = responceData.answerArray
                // });
              })
              // Update the state with the modified data
              setActivePartData(updatedData)

              setselectedAnswerText([])

              if (
                parseInt(ActivityData1.is_current_tab_total_part) ===
                parseInt(ActivityData1.is_current_tab_current_part)
              ) {
                setnextQuestion(false)
              } else {
                // window.location.reload();
                triggerFunction()
              }
            }
          }
        } else {
          //console.log(responceData.answerArray);
          //red color

          if (parseInt(ActivityData1.fk_sub_id) === 1) {
            if (responceData.answerArray.length > 0) {
              // console.log(responceData.answerArray);
              const updatedData = [...ActivePartData]

              // Update the copied data
              updatedData.forEach(quspart => {
                //console.log(quspart)
                // quspart.english_question_answers.forEach((qusAns) => {
                // Assign answerArray directly to StudentAnsAttempts
                quspart.StudentAnsAttempts = responceData.answerArray
                // });
              })

              // Update the state with the modified data
              setActivePartData(updatedData)
            }

            const writingCat = parseInt(
              ActivityData1?.english_question?.[0]?.english_question_category_id
            )
            if (writingCat === 10 || writingCat === 13) {
              if ((responceData.answerArray || []).length >= 2) {
                setWritingLocked(true)
                setnextQuestion(false)
              }
            }

            if (responceData.attempCount === 2) {
              const writingCat = parseInt(
                ActivityData1?.english_question?.[0]
                  ?.english_question_category_id
              )
              if (writingCat !== 10 && writingCat !== 13) {
                setselectedAnswerText([])
              }
              setValuefield(false)
              if (
                (ActivityData1 &&
                  ActivityData1.english_question &&
                  ActivityData1.english_question.length > 0 &&
                  ActivityData1.english_question[0]
                    .english_question_category_id &&
                  (ActivityData1.english_question[0]
                    .english_question_category_id === 8 ||
                    ActivityData1.english_question[0]
                      .english_question_category_id === 2 ||
                    ActivityData1.english_question[0]
                      .english_question_category_id === 12)) ||
                parseInt(responceData.is_auto_mark) <= 0
              ) {
                if (
                  (responceData && responceData.LastQuestion === true) ||
                  ActivityData1.is_current_tab_current_part ===
                    ActivityData1.is_current_tab_total_part
                ) {
                  setnextQuestion(false)
                } else {
                  //window.location.reload();
                  triggerFunction()
                }
              } else if (
                ActivityData1.english_question[0]
                  .english_question_category_id === 13 ||
                ActivityData1.english_question[0]
                  .english_question_category_id === 10 ||
                parseInt(responceData.is_auto_mark) <= 0
              ) {
                // Second attempt is the last one: keep the question on screen
                // with the submitted text. The Next button moves on.
                setnextQuestion(false)
              } else {
                setnextQuestion(false)
              }
            } else {
              if (
                textAreaRefs &&
                textAreaRefs.current &&
                textAreaRefs.current
              ) {
                for (let i = 0; i < textAreaRefs.current.length; i++) {
                  if (
                    textAreaRefs.current[i] &&
                    textAreaRefs.current[i] instanceof HTMLTextAreaElement
                  ) {
                    textAreaRefs.current[i].focus()
                    break // Stop once the first valid textarea is found and focused
                  }
                }
                //textAreaRefs.current.focus();
              }
              setValuefield(false)
              if (
                ActivityData1 &&
                ActivityData1.english_question &&
                ActivityData1.english_question.length > 0 &&
                ActivityData1.english_question[0]
                  .english_question_category_id &&
                (ActivityData1.english_question[0]
                  .english_question_category_id === 8 ||
                  ActivityData1.english_question[0]
                    .english_question_category_id === 2 ||
                  ActivityData1.english_question[0]
                    .english_question_category_id === 12) &&
                parseInt(responceData.is_auto_mark) <= 0
              ) {
                if (
                  (responceData && responceData.LastQuestion) ||
                  ActivityData1.is_current_tab_current_part ===
                    ActivityData1.is_current_tab_total_part
                ) {
                  setnextQuestion(false)
                } else {
                  //window.location.reload();
                  triggerFunction()
                }
              } else if (
                (ActivityData1.english_question[0]
                  .english_question_category_id === 13 ||
                  ActivityData1.english_question[0]
                    .english_question_category_id === 10) &&
                parseInt(responceData.is_auto_mark) <= 0
              ) {
                if (
                  (responceData && responceData.LastQuestion) ||
                  ActivityData1.is_first_question ===
                    ActivityData1.is_last_question
                ) {
                  setnextQuestion(false)
                } else {
                  // window.location.reload();
                  triggerFunction()
                }
              }
            }
          } else {
            if (responceData.answerArray.length > 0) {
              // console.log(responceData.answerArray);
              const updatedData = [...ActivePartData]

              // Update the copied data
              updatedData.forEach(quspart => {
                //console.log(quspart)
                // quspart.english_question_answers.forEach((qusAns) => {
                // Assign answerArray directly to StudentAnsAttempts
                quspart.StudentAnsAttempts = responceData.answerArray
                // });
              })

              // Update the state with the modified data
              setActivePartData(updatedData)
            }

            if (responceData.attempCount === 2) {
              setselectedAnswerText([])

              if (
                (responceData && responceData.LastQuestion === true) ||
                ActivityData1.is_current_tab_current_part ===
                  ActivityData1.is_current_tab_total_part
              ) {
                setnextQuestion(false)
              } else {
                //window.location.reload();
                triggerFunction()
              }
            } else {
              setselectedAnswerText([])
            }
          }
        }
      }
    }, [responceData])

    // console.log(responceData);
    // console.log(ActivePartData)

    // console.log(selectedAnswerText);
    //redirect Link
    useEffect(() => {
      if (isDarkMode && keyStage === "KS3") {
        document.body.classList.add("nv-dark-mode")
      } else {
        document.body.classList.remove("nv-dark-mode")
      }
      return () => document.body.classList.remove("nv-dark-mode")
    }, [isDarkMode, keyStage])
    const assessementSummary = () => {
      if (
        ActivityData1 &&
        ActivityData1.fk_lesson_activity_key &&
        ActivityData1.fk_lesson_activity_key != ""
      ) {
        if (ActivityData1.fk_sub_id && ActivityData1.fk_sub_id != "") {
          navigate(
            "/summary/" +
              ActivityData1.fk_lesson_activity_key +
              "?type=" +
              ActivityData1.fk_sub_id +
              "&homework=" +
              ActivityData1.IsHomework
          )
        } else {
          toast.error("Sorry, Activity Key Missing", {
            autoClose: 3000, // 3 seconds in this example
          })
        }
      } else {
        toast.error("Sorry, Activity Key Missing", {
          autoClose: 3000, // 3 seconds in this example
        })
      }
    }

    // console.log(selectedGroup);
    // console.log(ResonTextData);

    const filterValidAnswers = (answers = []) => {
      return answers.filter(qusAns => {
        const answerText =
          qusAns.english_answer_text || qusAns.answer_text || ""

        const cleanText = answerText
          .replace(/&nbsp;/g, "")
          .replace(/`/g, "")
          .replace(/<[^>]*>/g, "")
          .trim()

        const hasImage = /<img\s+[^>]*>/gi.test(answerText)

        return cleanText || hasImage
      })
    }

    function rearrangeEvenOddSecond(array) {
      const even = [] // To store even-indexed elements
      const odd = [] // To store odd-indexed elements

      array.forEach((element, index) => {
        if (index % 2 === 0) {
          even.push(element)
        } else {
          odd.push(element)
        }
      })

      // Combine odd and even arrays
      const rearranged = [...odd, ...even]

      return rearranged // Return the final rearranged array
    }

    function rearrangeEvenOdd(array) {
      array = filterValidAnswers(array)
      array.sort((a, b) => {
        const textA = a.english_answer_text || a.answer_text || ""
        const textB = b.english_answer_text || b.answer_text || ""
        return textA.localeCompare(textB)
      })
      array = filterValidAnswers(array)

      const even = [] // To store even-indexed elements
      const odd = [] // To store odd-indexed elements

      array.forEach((element, index) => {
        if (index % 2 === 0) {
          even.push(element)
        } else {
          odd.push(element)
        }
      })

      // Combine odd and even arrays
      const rearranged = [...odd, ...even]

      // Check if further rearrangement is needed
      if (rearranged.length > 1) {
        return rearrangeEvenOddSecond(rearranged) // Call recursively for further rearrangement
      }

      return rearranged // Return the final rearranged array
    }


    const handleKeyDown = e => {
      // Check if Enter key (keyCode 13) is pressed
      if (e.key === "Enter") {
        if (e.target.tagName === "TEXTAREA") {
          return // Do nothing if the target is an input or textarea
        }
        const submitButton = document.querySelector(".submit-btn-question")
        if (submitButton && !IsSubmited) {
          submitButton.click() // Trigger the click event on the button
        }
      }
    }

    const handleKeyPress = e => {
      if (e.key === "Enter") {
        if (resultData && !resultData.LastQuestion) {
          const nextquestionbutton =
            document.querySelector(".next-btn-question")
          if (nextquestionbutton) {
            nextquestionbutton.click()
          }
        } else if (resultData && resultData.LastQuestion) {
          const summarybutton = document.querySelector(".summary-btn-question")
          if (summarybutton) {
            summarybutton.click()
          }
        }
      }
    }

    const navigatorRef = useRef(null)
    useEffect(() => {
      if (isReadingOrWritingQuestion()) return
      if (navigatorRef.current) {
        navigatorRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        })
      }
    }, [resultData])

    useEffect(() => {
      if (!isReadingOrWritingQuestion()) return
      if (nextQuestion && !SummryView) return
      let cancelled = false
      const alignResultToBottom = () => {
        if (cancelled) return
        const wrapper =
          navigatorRef.current?.closest(".navigator-wrapper") ||
          navigatorRef.current
        if (!wrapper) return
        let scroller = wrapper.parentElement
        while (scroller && scroller !== document.body) {
          const overflowY = window.getComputedStyle(scroller).overflowY
          if (
            (overflowY === "auto" || overflowY === "scroll") &&
            scroller.scrollHeight > scroller.clientHeight + 2
          ) {
            break
          }
          scroller = scroller.parentElement
        }
        const pageScroller =
          !scroller || scroller === document.body
            ? document.scrollingElement || document.documentElement
            : scroller
        const viewBottom =
          pageScroller === document.scrollingElement ||
          pageScroller === document.documentElement
            ? window.innerHeight
            : pageScroller.getBoundingClientRect().bottom
        const gap = wrapper.getBoundingClientRect().bottom - viewBottom
        if (gap <= 2) return
        pageScroller.scrollBy({ top: gap, behavior: "auto" })
      }
      let frames = 0
      const settle = () => {
        if (cancelled || frames > 8) return
        frames += 1
        alignResultToBottom()
        requestAnimationFrame(settle)
      }
      const frame = requestAnimationFrame(settle)
      const timer = window.setTimeout(alignResultToBottom, 400)
      return () => {
        cancelled = true
        cancelAnimationFrame(frame)
        window.clearTimeout(timer)
      }
    }, [resultData, nextQuestion, SummryView])

    useEffect(() => {
      document.addEventListener("keydown", handleKeyPress)
      return () => {
        document.removeEventListener("keydown", handleKeyPress)
      }
    }, [resultData])

    //Avathr image functionality
    //useEffect
    const [userGender, setUserGender] = useState(
      localStorage.getItem("usergender") || null
    )
    //Note resource type : '0- Head, 1- Armour, 2- Hand, 3- Weapon, 4- Pet'
    const [maleAvatarData, setMaleAvatarData] = useState([])
    const [femaleAvatarData, setFemaleAvatarData] = useState([])

    const [AvatarGendar, setAvatarGendar] = useState(
      localStorage.getItem("usergender") === "Female" ? true : false
    )
    useEffect(() => {
      if (userGender && userGender == "Male") {
        setAvatarGendar(false)
      } else if (userGender && userGender == "Female") {
        setAvatarGendar(true)
      } else {
        setAvatarGendar(false)
      }
    }, [userGender])
    useEffect(() => {
      fetchStudentAvatarData()
    }, [])
    const togAvatarGendar = () => {
      setAvatarGendar(!AvatarGendar)
    }

    const properties = {
      prevArrow: (
        <button className="prev-btn">
          <i className="fas fa-arrow-circle-left"></i>
        </button>
      ),
      nextArrow: (
        <button className="next-btn">
          <i className="fas fa-arrow-circle-right"></i>
        </button>
      ),
    }
    //resource male
    const [maleAvatarHeadData, setMaleAvatarHeadData] = useState({})
    const [maleAvatarArmourData, setMaleAvatarArmourData] = useState({})
    const [maleAvatarHandData, setMaleAvatarHandData] = useState({})
    const [maleAvatarWeaponData, setMaleAvatarWeaponData] = useState({})
    const [maleAvatarPetData, setMaleAvatarPetData] = useState({})

    //resource female
    const [femaleAvatarHeadData, setFemaleAvatarHeadData] = useState({})
    const [femaleAvatarArmourData, setFemaleAvatarArmourData] = useState({})
    const [femaleAvatarHandData, setFemaleAvatarHandData] = useState({})
    const [femaleAvatarWeaponData, setFemaleAvatarWeaponData] = useState({})
    const [femaleAvatarPetData, setFemaleAvatarPetData] = useState({})

    const fetchStudentAvatarData = async () => {
      if (authUser && authUser != "" && authUser != null) {
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        axios
          .post(BASE_URL + "studentAvatar/StudentAvatarDeatils", {})
          .then(responseAvatar => {
            if (responseAvatar.data != "") {
              if (responseAvatar.data.maleInventory.length > 0) {
                setMaleAvatarData(responseAvatar.data.maleInventory)

                //Note resource type : '0- Head, 1- Armour, 2- Hand, 3- Weapon, 4- Pet'

                const filteredMaleHeadArray =
                  responseAvatar.data.maleInventory.filter(
                    item => parseInt(item.resource_type) === 0
                  )
                if (filteredMaleHeadArray.length > 0) {
                  setMaleAvatarHeadData(filteredMaleHeadArray[0])
                } else {
                  setMaleAvatarHeadData({})
                }

                const filteredMaleArmourArray =
                  responseAvatar.data.maleInventory.filter(
                    item => parseInt(item.resource_type) === 1
                  )
                if (filteredMaleArmourArray.length > 0) {
                  setMaleAvatarArmourData(filteredMaleArmourArray[0])
                } else {
                  setMaleAvatarArmourData({})
                }

                const filteredMaleHandArray =
                  responseAvatar.data.maleInventory.filter(
                    item => parseInt(item.resource_type) === 2
                  )
                if (filteredMaleHandArray.length > 0) {
                  setMaleAvatarHandData(filteredMaleHandArray[0])
                } else {
                  setMaleAvatarHandData({})
                }

                const filteredMaleWeaponArray =
                  responseAvatar.data.maleInventory.filter(
                    item => parseInt(item.resource_type) === 3
                  )
                if (filteredMaleWeaponArray.length > 0) {
                  setMaleAvatarWeaponData(filteredMaleWeaponArray[0])
                } else {
                  setMaleAvatarWeaponData({})
                }

                const filteredMalePetArray =
                  responseAvatar.data.maleInventory.filter(
                    item => parseInt(item.resource_type) === 4
                  )
                if (filteredMalePetArray.length > 0) {
                  setMaleAvatarPetData(filteredMalePetArray[0])
                } else {
                  setMaleAvatarPetData({})
                }
              } else {
                setMaleAvatarData([])
                setMaleAvatarHeadData({})
                setMaleAvatarArmourData({})
                setMaleAvatarHandData({})
                setMaleAvatarWeaponData({})
                setMaleAvatarPetData({})
              }

              if (responseAvatar.data.femaleInventory.length > 0) {
                setFemaleAvatarData(responseAvatar.data.femaleInventory)
                //Note resource type : '0- Head, 1- Armour, 2- Hand, 3- Weapon, 4- Pet'

                const filteredFeMaleHeadArray =
                  responseAvatar.data.femaleInventory.filter(
                    item => parseInt(item.resource_type) === 0
                  )
                if (filteredFeMaleHeadArray.length > 0) {
                  setFemaleAvatarHeadData(filteredFeMaleHeadArray[0])
                } else {
                  setFemaleAvatarHeadData({})
                }

                const filteredFeMaleArmourArray =
                  responseAvatar.data.femaleInventory.filter(
                    item => parseInt(item.resource_type) === 1
                  )
                if (filteredFeMaleArmourArray.length > 0) {
                  setFemaleAvatarArmourData(filteredFeMaleArmourArray[0])
                } else {
                  setFemaleAvatarArmourData({})
                }

                const filteredFeMaleHandArray =
                  responseAvatar.data.femaleInventory.filter(
                    item => parseInt(item.resource_type) === 2
                  )
                if (filteredFeMaleHandArray.length > 0) {
                  setFemaleAvatarHandData(filteredFeMaleHandArray[0])
                } else {
                  setFemaleAvatarHandData({})
                }

                const filteredFeMaleWeaponArray =
                  responseAvatar.data.femaleInventory.filter(
                    item => parseInt(item.resource_type) === 3
                  )
                if (filteredFeMaleWeaponArray.length > 0) {
                  setFemaleAvatarWeaponData(filteredFeMaleWeaponArray[0])
                } else {
                  setFemaleAvatarWeaponData({})
                }

                const filteredFeMalePetArray =
                  responseAvatar.data.femaleInventory.filter(
                    item => parseInt(item.resource_type) === 4
                  )
                if (filteredFeMalePetArray.length > 0) {
                  setFemaleAvatarPetData(filteredFeMalePetArray[0])
                } else {
                  setFemaleAvatarPetData({})
                }
              } else {
                setFemaleAvatarData([])
                setFemaleAvatarHeadData({})
                setFemaleAvatarArmourData({})
                setFemaleAvatarHandData({})
                setFemaleAvatarWeaponData({})
                setFemaleAvatarPetData({})
              }
            } else {
              setMaleAvatarData([])
              setMaleAvatarHeadData({})
              setMaleAvatarArmourData({})
              setMaleAvatarHandData({})
              setMaleAvatarWeaponData({})
              setMaleAvatarPetData({})

              setFemaleAvatarData([])
              setFemaleAvatarHeadData({})
              setFemaleAvatarArmourData({})
              setFemaleAvatarHandData({})
              setFemaleAvatarWeaponData({})
              setFemaleAvatarPetData({})
            }
          })
          .catch(error => {
            if (
              (error?.response?.status === 403 ||
                error?.response?.status === 401) &&
              (error?.response?.data?.error === "jwt expired" ||
                error?.response?.data?.error === "invalid algorithm" ||
                error?.response?.data?.error === "invalid token")
            ) {
              localStorage.clear()
              navigate("/login")
            }
          })
      } else {
        navigate("/login")
      }
    }

    // Function to add "character_" prefix to filename
    const modifyUrl = url => {
      const parts = url.split("/")
      const filename = parts[parts.length - 1]
      const modifiedFilename = `character_${filename}`
      parts[parts.length - 1] = modifiedFilename
      return parts.join("/")
    }
    const ReDirectProfile = async () => {
      navigate("/profile")
    }
    // student avatar system

    const trySkipQuestion = () => {
      if (authUser && authUser != "" && authUser != null) {
        if (activitykey && activitykey) {
          axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
          axios
            .post(BASE_URL + "studentAnswer/trySkipuestions", {
              fk_lesson_activity_key: activitykey,
            })
            .then(responseSkipQuestion => {
              // Assuming the API response is an array of objects with 'id' and 'value' properties

              if (responseSkipQuestion.data && responseSkipQuestion.data == 1) {
                triggerFunction()
                setnextQuestion(true)
                setActivePartData([])
                setIsSubmited(false)
                setresultData(null)
                setReTrySkipQuestion({
                  created_on: new Date(Date.now() + (4 * 60 * 1000) + (25 * 1000)).toISOString(),
                  isCorrect: false, // Skipped parts are considered incorrect for streak purposes
                })
              } else {
                toast.error(
                  "Sorry, unable to write the answers to the skipped questions",
                  {
                    autoClose: 3000, // 3 seconds
                  }
                )
              }
            })
            .catch(error => {
              if (
                (error?.response?.status === 403 ||
                  error?.response?.status === 401) &&
                (error?.response?.data?.error === "jwt expired" ||
                  error?.response?.data?.error === "invalid algorithm" ||
                  error?.response?.data?.error === "invalid token")
              ) {
                localStorage.clear()
                navigate("/login")
              }
            })
        } else {
          // window.history.back()
        }
      } else {
        // setLoader(false);
        navigate("/login")
      }
    }

    const finishQuestion = () => {
      if (authUser && authUser != "" && authUser != null) {
        if (activitykey && activitykey) {
          axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
          axios
            .post(BASE_URL + "studentAnswer/finishQuestions", {
              fk_lesson_activity_key: activitykey,
            })
            .then(responseFinishQuestion => {
              // Assuming the API response is an array of objects with 'id' and 'value' properties

              if (
                responseFinishQuestion.data &&
                responseFinishQuestion.data == 1
              ) {
                const fullPath = window.location.search // Combine pathname and query string
                navigate("/summary/" + activitykey + fullPath)
                //console.log("/summary/" + activitykey + fullPath); // Logs: "/assessment/laBf1zmItfAOV178UlcfHkSNCRKKMgMx?type=2&homework=1"
              } else {
                toast.error("Sorry, unable to finish activity.", {
                  autoClose: 3000, // 3 seconds
                })
              }
            })
            .catch(error => {
              if (
                (error?.response?.status === 403 ||
                  error?.response?.status === 401) &&
                (error?.response?.data?.error === "jwt expired" ||
                  error?.response?.data?.error === "invalid algorithm" ||
                  error?.response?.data?.error === "invalid token")
              ) {
                localStorage.clear()
                navigate("/login")
              }
            })
        } else {
          //window.history.back()
        }
      } else {
        // setLoader(false);
        navigate("/login")
      }
    }

    //Maths Answer guid start
    //const [popoverOpen, setPopoverOpen] = useState(false);
    const [openAccordion, setOpenAccordion] = useState("1")

    // const togglePopover = () => setPopoverOpen(!popoverOpen);
    const toggleAccordion = id => {
      setOpenAccordion(openAccordion === id ? "" : id)
    }

    const [popoverOpen, setPopoverOpen] = useState({})

    // Toggle function for individual popovers
    const togglePopover = id => {
      setPopoverOpen(prevState => ({
        ...prevState,
        [id]: !prevState[id], // Toggle the specific popover
      }))
    }
    //Maths Answer guid end

    function shuffleArray(array) {
      const shuffled = [...array]
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
      }
      return shuffled
    }
    const [shuffledAnswersMap, setShuffledAnswersMap] = useState({})
    useEffect(() => {
      if (
        ActivityData1 &&
        parseInt(ActivityData1.fk_sub_id) === 2 &&
        ActivePartData &&
        ActivePartData.length > 0
      ) {
        setShuffledAnswersMap(prevMap => {
          const newMap = { ...prevMap }
          ActivePartData.forEach(part => {
            if (part.question_answers && !newMap[part.part_id]) {
              newMap[part.part_id] = shuffleArray(
                rearrangeEvenOdd([...part.question_answers])
              )
            }
          })
          // Remove from map any parts no longer present (optional cleanup)
          Object.keys(newMap).forEach(pid => {
            if (!ActivePartData.some(part => part.part_id == pid)) {
              delete newMap[pid]
            }
          })
          return newMap
        })
      }
    }, [
      ActivityData1?.fk_question_id,
      JSON.stringify(ActivePartData.map(p => p.part_id)),
    ])

    const speakResult = (id, content) => {
      const htmlContent = Array.isArray(content)
        ? content.filter(Boolean).join(" ")
        : content
      if (!htmlContent) return
      speak(id, htmlToText(htmlContent))
    }

    function renderSpeakerToggle(id, content) {
      const htmlContent = Array.isArray(content)
        ? content.filter(Boolean).join(" ")
        : content
      //   const htmlContent = Array.isArray(content)
      // ? content.join(" ")
      // : content;

      const isYear = isYearOneToThree(activityLevel)

      return htmlContent?.trim() && isYear ? (
        <div>
          <SpeakerButton
            id={`q-text-${id}`}
            html={htmlContent}
            speak={speak}
            stop={stop}
            activeId={activeId}
          />
        </div>
      ) : null
    }

    const mathActivityData0 =
      ActivityData1 &&
      parseInt(ActivityData1.fk_sub_id) === 2 &&
      ActivityData1.question?.[0]
        ? ActivityData1.question[0]
        : null

    const mathFeedback = React.useMemo(() => {
      const toN = v => (v == null ? null : Number(v))
      const isBlankHtml = html =>
        !html || html.trim() === "<p><br></p>" || html.trim() === "<br>"

      const parts = mathActivityData0?.question_parts || []
      const totalParts = parts.length

      const perPart = parts.map((quspart, idx) => {
        if (
          (quspart.StudentQusSkip && quspart.StudentQusSkip.length > 0) ||
          (resultData && !resultData.studentAnswer)
        ) {
          return { idx, skipped: true, html: null, isCorrect: null }
        }

        const selectedIdFromAttempt =
          quspart?.StudentAnsAttempts?.[0]?.fk_answer_id ??
          quspart?.StudentAnsAttempts?.[0]?.answer_id ??
          null
        const selectedIdFromUIByPart =
          selectedAnswerText?.find(a => toN(a.part_id) === toN(quspart.part_id))
            ?.answer_id ?? null
        const selectedIdFromUIScalar = selectedAnswer ?? null

        const selectedId = toN(
          selectedIdFromAttempt ??
            selectedIdFromUIByPart ??
            selectedIdFromUIScalar
        )

        const answers = quspart.question_answers || []
        const selectedObj =
          selectedId != null
            ? answers.find(a => toN(a.answer_id) === selectedId)
            : null
        const correctObj = answers.find(a => toN(a.answer_is_correct) === 1)

        // NEW: was this specific part answered correctly?
        const isPartCorrect = selectedObj
          ? toN(selectedObj.answer_is_correct) === 1
          : null

        const filteredAns =
          selectedObj && toN(selectedObj.answer_is_correct) !== 1
            ? [selectedObj, correctObj].filter(Boolean)
            : correctObj
            ? [correctObj]
            : []

        const htmlBlocks = filteredAns
          .map(qusAns => {
            const h = !isBlankHtml(qusAns.answer_feedback)
              ? qusAns.answer_feedback
              : qusAns.answer_text || ""
            return h
          })
          .filter(Boolean)

        return {
          idx,
          skipped: false,
          html: htmlBlocks.join("") || null,
          isCorrect: isPartCorrect, // NEW
        }
      })

      const skippedCount = perPart.filter(p => p.skipped).length
      const allSkipped = totalParts > 0 && skippedCount === totalParts
      const hasSkip = skippedCount > 0
      const answeredWithContent = perPart.filter(p => !p.skipped && p.html)

      const explanationHtml = allSkipped
        ? ""
        : answeredWithContent
            .map(p =>
              totalParts > 1
                ? `<p><strong>Question ${p.idx + 1}:</strong></p>${p.html}`
                : p.html
            )
            .join("")

      // CHANGED: last part (when totalParts > 1) gets "Last question correct/incorrect" instead of "Question N:"
      const speechParts = allSkipped
        ? ["Please attempt the skipped question"]
        : perPart
            .map(p => {
              const isLast = totalParts > 1 && p.idx === totalParts - 1

              if (p.skipped) {
                if (totalParts === 1)
                  return "Please attempt the skipped question."
                if (isLast)
                  return "Last question: please attempt the skipped question."
                return `Question ${
                  p.idx + 1
                }: Please attempt the skipped question.`
              }

              if (p.html) {
                if (totalParts === 1) return htmlToText(p.html)
                if (isLast) {
                  //const status = p.isCorrect ? "correct" : "incorrect"
                  return `Last question ${status}. ${htmlToText(p.html)}`
                }
                return `Question ${p.idx + 1}: ${htmlToText(p.html)}`
              }
              return null
            })
            .filter(Boolean)

      return {
        allSkipped,
        hasSkip,
        hasContent: answeredWithContent.length > 0,
        explanationHtml,
        speechParts,
      }
    }, [mathActivityData0, resultData, selectedAnswerText, selectedAnswer])

    // console.log(mathFeedback)
    return ActivityData1 &&
      ActivityData1.fk_sub_id &&
      parseInt(ActivityData1.fk_sub_id) === 1 ? (
      ActivityData1.english_question.map((ActivityData, index) => {
        if (index === 0) {
          if (
            ActivityData &&
            ActivityData.english_question_category_id &&
            parseInt(ActivityData.english_question_category_id) === 1
          ) {
            return (
              <div
                style={getOverlayCardStyle()}
                className={`hw-list mt-2 ${
                  localStorage.getItem("is_fontsize") == 1
                    ? "stu-custom-font-size"
                    : ""
                }`}
              >
                {/* <ToastContainer autoClose={3000} /> */}
                <Modal isOpen={modal_standard1} toggle={tog_standard1}>
                  <ModalHeader toggle={tog_standard1}></ModalHeader>
                  <ModalBody>
                    <p className="text-center fw-bold text-dark mb-0 font-size-18">
                      Report this question to your tutor as being incorrectly
                      marked?
                    </p>
                  </ModalBody>
                  <ModalFooter className="justify-content-center">
                    <Button
                      className="btn-cst-success-md"
                      disabled={isFlagReport}
                      onClick={() => {
                        submitQuestionReport()
                      }}
                    >
                      Yes
                    </Button>
                    <Button
                      className="btn-cst-danger-md"
                      onClick={() => {
                        tog_standard1()
                      }}
                    >
                      No
                    </Button>
                  </ModalFooter>
                </Modal>

                <Modal isOpen={modal_standard} toggle={tog_standard}>
                  <Form
                    className="mt-4"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    action="#"
                  >
                    <ModalHeader toggle={tog_standard}>
                      Flag this Question
                    </ModalHeader>
                    <ModalBody>
                      <div className="flex-grow-1 mb-3 cs-rsm">
                        <Label>Select a Reason</Label>
                        <Select
                          name="reson"
                          id="reson"
                          className="cs-style bg-mutant"
                          value={optionGroup.find(
                            option =>
                              option.value &&
                              validation.values.reson &&
                              option.value.toString() ==
                                validation.values.reson.toString()
                          )}
                          placeholder="Select"
                          onChange={selectedOption => {
                            const event = {
                              target: {
                                name: "reson",
                                value: selectedOption["value"],
                              },
                            }
                            validation.handleChange(event)
                          }}
                          onBlur={event => {
                            validation.handleBlur(event)
                          }}
                          // invalid={
                          //   validation.touched.reson &&
                          //   validation.errors.reson
                          //     ? true
                          //     : false
                          // }
                          options={optionGroup}
                          classNamePrefix="select2-selection"
                        />
                        {validation.touched.reson && validation.errors.reson ? (
                          <div className="invalid-feedback-all">
                            {validation.errors.reson}
                          </div>
                        ) : null}
                      </div>
                      <div className="flex-grow-1 cs-rsm">
                        <Label>Reason:</Label>
                        <Input
                          style={{ height: "200px" }}
                          type="textarea"
                          name="reson_text"
                          id="reson_text"
                          // onChange={e=> {
                          // textareachange(e)
                          // }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.reson_text || ""}
                          // invalid={
                          //   validation.touched.reson_text &&
                          //   validation.errors.reson_text
                          //     ? true
                          //     : false
                          // }
                          maxLength="225"
                          rows="3"
                          placeholder="Write your reason here..."
                        />
                        {validation.touched.reson_text &&
                        validation.errors.reson_text ? (
                          <div className="invalid-feedback-all">
                            {validation.errors.reson_text}
                          </div>
                        ) : null}
                      </div>
                    </ModalBody>
                    <ModalFooter className="justify-content-center">
                      <Button
                        type="submit"
                        className="btn btn-danger cs-btn-danger"
                        disabled={isFlagReport}
                      >
                        Submit
                      </Button>
                    </ModalFooter>
                  </Form>
                </Modal>
                <ul
                  className={`list-unstyled mb-0 question_container nv-question-highlight ${
                    isDarkMode && keyStage === "KS3" ? "nv-dark-mode" : ""
                  }`}
                >
                  <li
                    className="justify-content-between mb-0 overflow-visible"
                    onKeyDown={handleKeyDown}
                    tabIndex={index}
                  >
                    <div className="d-flex align-items-center gap-4 justify-content-end nv-sticky-header">
                      <div className="mb-0 d-flex align-items-center gap-2">
                        <p className="mb-0">
                          #
                          {ActivityData.english_question_id
                            ? ActivityData.english_question_id
                            : null}
                        </p>
                        <span onClick={tog_standard}>
                          <i className="mdi mdi-flag-variant-outline font-size-18"></i>
                        </span>
                      </div>
                      {renderDarkModeToggle()}
                      {renderOverlayToggle()}
                    </div>

                    <div className="d-flex gap-4 mt-4">
                      {renderSpeakerToggle(index, [
                        ActivityData.english_question_text,
                      ])}
                      <div
                        className="question_work"
                        dangerouslySetInnerHTML={{
                          __html: ActivityData.english_question_text
                            ? ActivityData.english_question_text
                                .replace(/\[(\d+)Answer char=\d+\]/g, "")
                                .replace(/\[Answer char=\d+\]/g, "")
                            : null,
                        }}
                      ></div>
                    </div>

                    <ul className="dg-selector choose-it-question width-controll list-unstyled mb-0">
                      {ActivePartData &&
                        ActivePartData.map((quspart, index) => {
                          //const stuAnswersarray = quspart.StudentAnsAttempts.map(stuAns => stuAns.student_answer);

                          const stuAnswersarray =
                            quspart.StudentAnsAttempts.map(stuAns => {
                              try {
                                return JSON.parse(stuAns.student_answer)
                              } catch (error) {
                                console.error("Error parsing JSON:", error)
                                return null // or handle the error in an appropriate way
                              }
                            }) || [] // Extracting session keys

                          // Assuming stuAnswersarray is a nested array
                          const flattenedStuAnswers = [].concat(
                            ...stuAnswersarray
                          )
                          let correct_count = 0
                          let serialNumber = 0
                          //const stuAnswersarray = stuAnswersJson.length > 0 ? JSON.parse(stuAnswersJson) : [];
                          return (
                            quspart.english_question_answers &&
                            rearrangeEvenOdd(
                              quspart.english_question_answers
                            ).map((qusAns, index1) => {
                              //   if ((!qusAns.english_answer_text.replace(/&nbsp;/g, '').replace(/<[^>]*>/g, '') || qusAns.english_answer_text.replace(/&nbsp;/g, '').replace(/<[^>]*>/g, '').trim() === '')
                              //   && !(/<img\s+[^>]*>/gi.test(qusAns.english_answer_text))) {
                              //     return null; // Skip rendering if english_answer_text is null
                              // }
                              const cleanText = qusAns.english_answer_text
                                .replace(/&nbsp;/g, "")
                                .replace(/`/g, "")
                                .replace(/<[^>]*>/g, "")
                                .trim()

                              const hasImage = /<img\s+[^>]*>/gi.test(
                                qusAns.english_answer_text
                              )

                              if (!cleanText && !hasImage) {
                                return null // Skip rendering if english_answer_text is effectively empty and no image is present
                              }
                              serialNumber++
                              let filteredStuAns =
                                flattenedStuAnswers.filter(
                                  stuAns =>
                                    parseInt(stuAns.part_id) ===
                                      parseInt(qusAns.english_answer_part_id) &&
                                    parseInt(stuAns.answer_id) ===
                                      parseInt(qusAns.english_answer_id)
                                ) || []

                              var status_color =
                                "selector-general cursor-pointer"
                              var border_color = "border-start-secondary"

                              if (filteredStuAns.length > 0) {
                                if (
                                  parseInt(qusAns.english_answer_is_correct) ===
                                  1
                                ) {
                                  status_color = "selector-success"
                                  border_color = "border-start-success"

                                  //if(selectedAnswer && selectedAnswer === qusAns.english_answer_id){
                                  correct_count += 1
                                  // }
                                } else {
                                  status_color = "selector-wrong "
                                  border_color = "border-start-danger"
                                }
                              }

                              //const sesKeys = quspart.StudentAnsAttempts.map(stuAns => stuAns.part_id); // Extracting session keys
                              return (
                                <>
                                  <li
                                    className={
                                      selectedAnswer &&
                                      selectedAnswer ===
                                        qusAns.english_answer_id
                                        ? status_color +
                                          " active choose e_choose"
                                        : status_color + " choose e_choose"
                                    }
                                    key={index1}
                                    onClick={() => selectedAnsOption(qusAns)}
                                  >
                                    <div
                                      style={{
                                        position: "absolute",
                                        left: "-40px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                      }}
                                      onClick={e => e.stopPropagation()}
                                    >
                                      {renderSpeakerToggle(
                                        "ans-" + qusAns.english_answer_id,
                                        [qusAns.english_answer_text]
                                      )}
                                    </div>
                                    <div className="p-2 px-3 font-size-18 dg-serial-badge-wrap">
                                      <span className="dg-serial-badge">
                                        {serialNumber}
                                      </span>
                                    </div>
                                    <div
                                      className={
                                        "p-2 dg-media " + { border_color }
                                      }
                                      dangerouslySetInnerHTML={{
                                        __html: qusAns.english_answer_text
                                          ? qusAns.english_answer_text
                                          : null,
                                      }}
                                    ></div>
                                  </li>
                                  {index1 + 1 >=
                                    quspart.english_question_answers.length &&
                                  quspart.StudentAnsAttempts.length === 1 &&
                                  parseInt(
                                    quspart.english_question_part_automark
                                  ) === 1 ? (
                                    correct_count > 0 ? null : (
                                      <div className="d-flex justify-content-end">
                                        <span className="text-danger font-size-14 mt-auto mb-2">
                                          Try again with a different answer.
                                        </span>
                                      </div>
                                    )
                                  ) : null}
                                  {nextQuestion &&
                                  SummryView === false &&
                                  index1 + 1 >=
                                    rearrangeEvenOdd(
                                      quspart.english_question_answers
                                    )?.length &&
                                  skipAnchorEl
                                    ? createPortal(
                                        <span
                                          className="font-size-15 mt-1 text-danger fw-bold skip-button"
                                          onClick={() =>
                                            selectedAnsOption(qusAns, 1)
                                          }
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            version="1.1"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            width={20}
                                            height={20}
                                            x={0}
                                            y={0}
                                            viewBox="0 0 24 25"
                                            style={{
                                              enableBackground:
                                                "new 0 0 512 512",
                                            }}
                                            xmlSpace="preserve"
                                            className=""
                                          >
                                            <g>
                                              <path
                                                fill="#ef0000"
                                                fillRule="evenodd"
                                                d="M9.676 8.205c0-2.256 2.568-3.553 4.383-2.212l6.822 5.037a2.75 2.75 0 0 1 0 4.424l-6.822 5.037c-1.815 1.34-4.383.044-4.383-2.212v-.035l-3.042 2.247c-1.816 1.34-4.384.044-4.384-2.212V8.205c0-2.256 2.568-3.553 4.384-2.212l3.042 2.246zm1.5 1.142 2.279 1.683a2.75 2.75 0 0 1 0 4.424l-2.28 1.683v1.142c0 1.025 1.168 1.615 1.993 1.005l6.821-5.036a1.25 1.25 0 0 0 0-2.012L13.17 7.2c-.826-.61-1.993-.02-1.993 1.005zM5.743 7.2c-.826-.61-1.993-.02-1.993 1.005V18.28c0 1.025 1.167 1.615 1.993 1.005l6.82-5.036a1.25 1.25 0 0 0 0-2.012z"
                                                clipRule="evenodd"
                                                opacity={1}
                                                data-original="#000000"
                                                className=""
                                              />
                                            </g>
                                          </svg>{" "}
                                          Skip Question
                                        </span>,
                                        skipAnchorEl
                                      )
                                    : null}
                                </>
                              )
                            })
                          )
                        })}
                    </ul>
                  </li>
                </ul>
                <div className="d-flex justify-content-between align-items-center gap-3 mt-2 skip-submit-row">
                  <div className="skip-anchor" ref={setSkipAnchorEl}></div>
                  <div className="text-end">
                  {selectedAnswerText &&
                  selectedAnswerText != null &&
                  selectedAnswerText.length > 0 &&
                  nextQuestion &&
                  parseInt(IsSkipButton) !== 1 ? (
                    <Button
                      className="submit-btn-question btn btn-danger cs-btn-danger mt-1"
                      disabled={IsSubmited}
                      onClick={() => {
                        triggerSubmitFunction(selectedAnswerText)
                        setIsSubmited(true)
                      }}
                    >
                      Submit
                    </Button>
                  ) : null}
                  </div>
                </div>
                {renderNextButton()}

                {!nextQuestion || SummryView === true ? (
                  <div className="navigator-wrapper position-relative pb-3 mt-4">
                    <div
                      style={getOverlayCardStyle()}
                      className={`nv-feedback-card feedback-${keyStage} ${
                        resultData && parseInt(resultData.is_correct) === 1
                          ? parseInt(resultData.attempCount) >= 2
                            ? "nv-feedback-card--warn"
                            : "nv-feedback-card--ok"
                          : resultData && !resultData.studentAnswer
                          ? "nv-feedback-card--skip"
                          : "nv-feedback-card--err"
                      }`}
                    >
                      {/* ── Main row: icon · status · coins + button ── */}
                      <div className="nv-feedback-card__main">
                        {/* student avatar start */}
                        {/* <img width={400} src={dsmile} alt="" /> */}
                        <div className="nv-feedback-card__icon">
                          {renderFeedbackIcon(resultData)}
                        </div>
                        {/* student avatar end */}

                        <div className="nv-feedback-card__text">
                          <div className="nv-feedback-card__title-row">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                flexWrap: "wrap",
                              }}
                            >
                              <div className="nv-feedback-card__status-group">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <span
                                    className={`nv-feedback-card__title feedback-title-${keyStage} ${
                                      resultData &&
                                      parseInt(resultData.is_correct) === 1
                                        ? parseInt(resultData.attempCount) >= 2
                                          ? "nv-feedback-card__title--warn"
                                          : "nv-feedback-card__title--ok"
                                        : resultData &&
                                          !resultData.studentAnswer
                                        ? "nv-feedback-card__title--skip"
                                        : "nv-feedback-card__title--err"
                                    }`}
                                  >
                                    {resultData &&
                                    parseInt(resultData.is_correct) === 1
                                      ? "Correct!"
                                      : resultData && !resultData.studentAnswer
                                      ? "Skipped!"
                                      : "Incorrect"}
                                  </span>
                                  
                                  <ResultSpeakButton
                                    id={`result-${ActivityData?.english_question_id}`}
                                    activeId={activeId}
                                    speak={speak}
                                    resultData={resultData}
                                    parts={[
                                      resultData &&
                                      parseInt(resultData.is_correct) === 1
                                        ? "Correct! Great job!"
                                        : resultData &&
                                          !resultData.studentAnswer
                                        ? "Skipped! Give it a try!"
                                        : "Incorrect. Keep practising!",
                                      resultData?.studentAnswer
                                        ? `You answered: ${resultData.studentAnswer}`
                                        : null,
                                      ...(resultData?.is_correct !== 3
                                        ? resultData?.explanation
                                          ? [`${resultData.explanation}`]
                                          : ActivityData?.english_question_parts?.flatMap(
                                              part =>
                                                part.english_question_answers
                                                  ?.filter(
                                                    ans =>
                                                      parseInt(
                                                        ans.english_answer_is_correct
                                                      ) === 1
                                                  )
                                                  .map(
                                                    ans =>
                                                      `Correct answer: ${ans.english_answer_text}`
                                                  )
                                            )
                                        : [
                                            `Please attempt the skipped question`,
                                          ] || []),
                                    ]}
                                  />
                                </div>
                                <p
                                  className={`nv-feedback-card__subtitle feedback-subtitle-${keyStage}`}
                                >
                                  {resultData &&
                                  parseInt(resultData.is_correct) === 1
                                    ? "Great job!"
                                    : resultData && !resultData.studentAnswer
                                    ? "Give it a try!"
                                    : "Keep practising!"}
                                </p>
                              </div>
                              <div className="nv-feedback-card__inline-stats">
                                <div className="nv-feedback-card__stat-item">
                                  <span className="nv-feedback-card__stat-label">
                                    ⏱ SUGGESTED TIME
                                  </span>
                                  <span className="nv-feedback-card__stat-value">
                                    {ActivityData.english_question_time_needed}
                                  </span>
                                </div>
                                <div className="nv-feedback-card__stat-sep" />
                                <div className="nv-feedback-card__stat-item">
                                  <span className="nv-feedback-card__stat-label">
                                    🎯 GOT IT RIGHT
                                  </span>
                                  <span className="nv-feedback-card__stat-value">
                                    {resultData
                                      ? parseInt(
                                          resultData.accuracyOfOtherStudents
                                        )
                                      : 0}
                                    %
                                  </span>
                                </div>
                              </div>
                              {resultData && resultData.studentAnswer ? (
                                <div
                                  className={`nv-answer-box answer-box-${keyStage} ${
                                    parseInt(resultData.is_correct) === 1
                                      ? parseInt(resultData.attempCount) >= 2
                                        ? "nv-answer-box--warn"
                                        : "nv-answer-box--ok"
                                      : "nv-answer-box--err"
                                  }`}
                                >
                                  <div className="nv-answer-box__col nv-answer-box__col--answer">
                                    <span className="nv-answer-box__label">
                                      You answered:
                                    </span>
                                    <p
                                      className={`nv-answer-box__value answer-value-${keyStage}`}
                                      dangerouslySetInnerHTML={{
                                        __html: resultData.studentAnswer,
                                      }}
                                    />
                                  </div>
                                  {resultData.explanation ? (
                                    <>
                                      <div className="nv-answer-box__divider" />
                                      <div className="nv-answer-box__col nv-answer-box__col--explanation">
                                        <span className="nv-answer-box__label">
                                          Explanation:
                                        </span>
                                        <div
                                          className={`nv-answer-box__text answer-text-${keyStage}`}
                                          dangerouslySetInnerHTML={{
                                            __html: resultData.explanation,
                                          }}
                                        />
                                      </div>
                                    </>
                                  ) : (
                                    ActivityData.english_question_parts &&
                                    ActivityData.english_question_parts.map(
                                      (quspart, index) => {
                                        let filteredAns =
                                          quspart.english_question_answers.filter(
                                            CorrAns =>
                                              parseInt(
                                                CorrAns.english_answer_is_correct
                                              ) === 1
                                          )
                                        return filteredAns.map(
                                          (qusAns, index1) => {
                                            return (
                                              <div
                                                dangerouslySetInnerHTML={{
                                                  __html:
                                                    qusAns.english_answer_text
                                                      ? qusAns.english_answer_text
                                                      : null,
                                                }}
                                              ></div>
                                            )
                                          }
                                        )
                                      }
                                    )
                                  )}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div
                          className="nv-feedback-card__actions"
                          style={{ alignSelf: "flex-start", justifyContent: "flex-end", alignItems: "flex-end" }}
                          ref={navigatorRef}
                        >
                          {/* Coin badge */}
                          <div className="nv-feedback-card__coin-badge">
                            <img width={32} src={awicon} alt="coins" />
                            <div className="nv-feedback-card__coin-text">
                              <span className="nv-feedback-card__coin-num">
                                {resultData &&
                                parseInt(resultData.is_correct) === 1
                                  ? "+"
                                  : ""}
                                {resultData && resultData?.points && parseInt(resultData.is_correct) !== 3 ? resultData.points : 0}
                              </span>
                              <span className="nv-feedback-card__coin-lbl">
                                coins
                              </span>
                            </div>
                          </div>

                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                            {resultData &&
                            resultData.LastQuestion &&
                            parseInt(SkipQuestionCount) > 0 ? (
                              <>
                                <Button
                                  className="btn btn-danger cs-btn-danger mt-1 nv-feedback-card__btn"
                                  onClick={() => trySkipQuestion()}
                                >
                                  Attempt {SkipQuestionCount} skipped questions
                                </Button>
                                <p className="font-size-16 d-flex align-items-center gap-2" style={{ margin: 0 }}>
                                  OR
                                </p>
                              </>
                            ) : null}

                            {resultData ? (
                              !resultData.LastQuestion ? (
                                <Button
                                  className="next-btn-question btn btn-danger cs-btn-danger mt-1 nv-feedback-card__btn"
                                  onClick={() => {
                                    //window.location.reload();
                                    triggerFunction()
                                    setnextQuestion(false)
                                    setActivePartData([])
                                    setIsSubmited(false)
                                    setresultData(null)
                                  }}
                                >
                                  Next Question&nbsp;
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-fast-forward-icon lucide-fast-forward"
                                  >
                                    <path d="M12 6a2 2 0 0 1 3.414-1.414l6 6a2 2 0 0 1 0 2.828l-6 6A2 2 0 0 1 12 18z" />
                                    <path d="M2 6a2 2 0 0 1 3.414-1.414l6 6a2 2 0 0 1 0 2.828l-6 6A2 2 0 0 1 2 18z" />
                                  </svg>
                                </Button>
                              ) : (
                                <Button
                                  className="summary-btn-question btn btn-danger cs-btn-danger mt-1 nv-feedback-card__btn"
                                  onClick={() => assessementSummary()}
                                >
                                  Finish
                                </Button>
                              )
                            ) : null}
                          </div>
                        </div>
                      </div>

                      {/* Marked incorrectly link */}
                      {resultData &&
                      resultData.attempCount &&
                      parseInt(resultData.attempCount) >= 2 ? (
                        <span
                          className="font-size-15 text-dark fw-bold"
                          onClick={tog_standard1}
                          style={{
                            fontStyle: "italic",
                            textDecoration: "underline",
                            cursor: "pointer",
                            display: "block",
                            textAlign: "center",
                          }}
                        >
                          It was marked incorrectly
                        </span>
                      ) : null}
                    </div>
                  </div>
                ) : null}
              </div>
            )
          } else if (
            ActivityData &&
            ActivityData.english_question_category_id &&
            (parseInt(ActivityData.english_question_category_id) === 8 ||
              parseInt(ActivityData.english_question_category_id) === 2 ||
              parseInt(ActivityData.english_question_category_id) === 12)
          ) {
            return (
              <div
                style={getOverlayCardStyle()}
                className={`hw-list mt-2 not_scroll ${
                  localStorage.getItem("is_fontsize") == 1
                    ? "stu-custom-font-size"
                    : ""
                }`}
              >
                {/* <ToastContainer autoClose={3000} /> */}
                <Modal isOpen={modal_standard1} toggle={tog_standard1}>
                  <ModalHeader toggle={tog_standard1}></ModalHeader>
                  <ModalBody>
                    <p className="text-center fw-bold text-dark mb-0 font-size-18">
                      Report this question to your tutor as being incorrectly
                      marked?
                    </p>
                  </ModalBody>
                  <ModalFooter className="justify-content-center">
                    <Button
                      className="btn-cst-success-md"
                      disabled={isFlagReport}
                      onClick={() => {
                        submitQuestionReport()
                      }}
                    >
                      Yes
                    </Button>
                    <Button
                      className="btn-cst-danger-md"
                      onClick={() => {
                        tog_standard1()
                      }}
                    >
                      No
                    </Button>
                  </ModalFooter>
                </Modal>

                <Modal isOpen={modal_standard} toggle={tog_standard}>
                  <Form
                    className="mt-4"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    action="#"
                  >
                    <ModalHeader toggle={tog_standard}>
                      Flag this Question
                    </ModalHeader>
                    <ModalBody>
                      <div className="flex-grow-1 mb-3 cs-rsm">
                        <Label>Select a Reason</Label>
                        <Select
                          name="reson"
                          id="reson"
                          className="cs-style bg-mutant"
                          value={optionGroup.find(
                            option =>
                              option.value &&
                              validation.values.reson &&
                              option.value.toString() ==
                                validation.values.reson.toString()
                          )}
                          placeholder="Select"
                          onChange={selectedOption => {
                            const event = {
                              target: {
                                name: "reson",
                                value: selectedOption["value"],
                              },
                            }
                            validation.handleChange(event)
                          }}
                          onBlur={event => {
                            validation.handleBlur(event)
                          }}
                          // invalid={
                          //   validation.touched.reson &&
                          //   validation.errors.reson
                          //     ? true
                          //     : false
                          // }
                          options={optionGroup}
                          classNamePrefix="select2-selection"
                        />
                        {validation.touched.reson && validation.errors.reson ? (
                          <div className="invalid-feedback-all">
                            {validation.errors.reson}
                          </div>
                        ) : null}
                      </div>
                      <div className="flex-grow-1 cs-rsm">
                        <Label>Reason:</Label>
                        <Input
                          style={{ height: "200px" }}
                          type="textarea"
                          name="reson_text"
                          id="reson_text"
                          // onChange={e=> {
                          // textareachange(e)
                          // }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.reson_text || ""}
                          // invalid={
                          //   validation.touched.reson_text &&
                          //   validation.errors.reson_text
                          //     ? true
                          //     : false
                          // }
                          maxLength="225"
                          rows="3"
                          placeholder="Write your reason here..."
                        />
                        {validation.touched.reson_text &&
                        validation.errors.reson_text ? (
                          <div className="invalid-feedback-all">
                            {validation.errors.reson_text}
                          </div>
                        ) : null}
                      </div>
                    </ModalBody>
                    <ModalFooter className="justify-content-center">
                      <Button
                        type="submit"
                        className="btn btn-danger cs-btn-danger"
                        disabled={isFlagReport}
                      >
                        Submit
                      </Button>
                    </ModalFooter>
                  </Form>
                </Modal>
                <ul
                  className={`list-unstyled mb-0 question_container nv-question-highlight ${
                    isDarkMode && keyStage === "KS3" ? "nv-dark-mode" : ""
                  }`}
                >
                  {" "}
                  <li
                    className="justify-content-between mb-0 overflow-visible"
                    onKeyDown={handleKeyDown}
                    tabIndex={index}
                  >
                    <div className="d-flex align-items-center gap-4 justify-content-end nv-sticky-header">
                      <div className="mb-0 d-flex align-items-center gap-2">
                        <p className="mb-0">
                          #
                          {ActivityData.english_question_id
                            ? ActivityData.english_question_id
                            : null}
                        </p>
                        <span onClick={tog_standard}>
                          <i className="mdi mdi-flag-variant-outline font-size-18"></i>
                        </span>
                      </div>
                      {renderDarkModeToggle()}
                      {renderOverlayToggle()}
                    </div>
                    <div className="question-container-custom">
                      <div className="passage-area flex-fill border">
                        <div className="d-flex gap-4 mt-3">
                          {renderSpeakerToggle(
                            ActivityData?.english_question_id,
                            [
                              ActivityData?.english_question_instruction,
                              ...(ActivityData?.english_question_choices?.map(
                                qusChoice =>
                                  `${qusChoice.choice_no}. ${qusChoice.choice_text}`
                              ) || []),
                              ActivityData?.english_question_text,
                              ActivityData?.part_heading,
                            ]
                          )}
                          <div>
                            <div
                              className="question_work"
                              dangerouslySetInnerHTML={{
                                __html:
                                  ActivityData.english_question_instruction
                                    ? ActivityData.english_question_instruction
                                        .replace(
                                          /\[(\d+)Answer char=\d+\]/g,
                                          ""
                                        )
                                        .replace(/\[Answer char=\d+\]/g, "")
                                    : null,
                              }}
                            ></div>

                            {/* Choice */}
                            {ActivityData &&
                            ActivityData.english_question_choices &&
                            ActivityData.english_question_choices.length > 0 ? (
                              <div className="mt-4 my-2 border border-dark choice-options_wrapper">
                                {ActivityData.english_question_choices.map(
                                  (qusChoice, Cindex) => (
                                    <div
                                      class="choice-options_child"
                                      key={Cindex}
                                    >
                                      <div>{qusChoice.choice_no}</div>
                                      <div>{qusChoice.choice_text}</div>
                                    </div>
                                  )
                                )}
                              </div>
                            ) : null}

                            {ActivityData.english_question_text &&
                            parseInt(
                              ActivityData.english_question_category_id
                            ) === 8 ? (
                              <div
                                className="mt-4"
                                dangerouslySetInnerHTML={{
                                  __html: ActivityData.english_question_text
                                    ? ActivityData.english_question_text
                                        .replace(
                                          /\[(\d+)Answer char=\d+\]/g,
                                          ""
                                        )
                                        .replace(/\[Answer char=\d+\]/g, "")
                                        .replace(/&nbsp;/g, "")
                                        .split("</p>")
                                        .map((paragraph, index) =>
                                          paragraph
                                            ? `<div class="d-flex"><p class="me-2">${
                                                index + 1
                                              } <div>${paragraph}</div></p></div>`
                                            : ""
                                        )
                                        .filter(Boolean)
                                        .join("")
                                    : null,
                                }}
                              />
                            ) : (
                              <div
                                className="mt-4"
                                dangerouslySetInnerHTML={{
                                  __html: ActivityData.english_question_text
                                    ? ActivityData.english_question_text
                                        .replace(
                                          /\[(\d+)Answer char=\d+\]/g,
                                          ""
                                        )
                                        .replace(/\[Answer char=\d+\]/g, "")
                                    : null,
                                }}
                              ></div>
                            )}
                            {ActivityData &&
                            ActivityData.part_heading &&
                            ActivityData.part_heading != "" ? (
                              <div
                                className="mt-4"
                                dangerouslySetInnerHTML={{
                                  __html: ActivityData.part_heading
                                    .replace(/\[(\d+)Answer char=\d+\]/g, "")
                                    .replace(/\[Answer char=\d+\]/g, ""),
                                }}
                              ></div>
                            ) : null}
                            {/* File option */}
                            <div className="mt-4 my-2">
                              {ActivityData &&
                              ActivityData.english_question_files &&
                              ActivityData.english_question_files.length > 0
                                ? ActivityData.english_question_files.map(
                                    (qusFile, index) => (
                                      <img
                                        key={index}
                                        alt=""
                                        style={{
                                          height: "auto",
                                          maxWidth: "100%",
                                        }}
                                        src={`https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/question_files/${qusFile.file_name}`}
                                      />
                                    )
                                  )
                                : null}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={`question-area flex-fill border long-inputbox cat-${ActivityData.english_question_category_id}`}>
                        {/* Past question */}
                        {!ActivityData1?.is_show_all_parts &&
                          ActivityData.english_question_parts &&
                          ActivityData.english_question_parts.map(
                            (quspart, index) => {
                              const stuAnswersarray =
                                quspart.StudentAnsAttempts.map(stuAns => {
                                  try {
                                    return JSON.parse(stuAns.student_answer)
                                  } catch (error) {
                                    console.error("Error parsing JSON:", error)
                                    return null // or handle the error in an appropriate way
                                  }
                                }) || [] // Extracting session keys

                              // Assuming stuAnswersarray is a nested array
                              const flattenedStuAnswers = [].concat(
                                ...stuAnswersarray
                              )
                              let serialNumber = 0
                              let filteredCorrectAns =
                                quspart.english_question_answers.filter(
                                  CorrAns =>
                                    parseInt(
                                      CorrAns.english_answer_is_correct
                                    ) === 1
                                )
                              return index + 1 <
                                ActivityData1.is_current_tab_current_part ? (
                                <>
                                  <div key={index}>
                                    <div className="d-flex gap-2 flex-row ">
                                      {renderSpeakerToggle("pt" + index, [
                                        quspart?.english_question_part_text,
                                      ])}
                                      <div className="mr-3">
                                        {index + 1}
                                        {")"}
                                      </div>
                                      <div
                                        className="question_work"
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            quspart.english_question_part_text
                                              ? quspart.english_question_part_text
                                                  .replace(
                                                    /\[(\d+)Answer char=\d+\]/g,
                                                    ""
                                                  )
                                                  .replace(
                                                    /\[Answer char=\d+\]/g,
                                                    ""
                                                  )
                                              : null,
                                        }}
                                      ></div>
                                    </div>
                                    {/* Anse category statement Star */}
                                    {quspart.english_question_part_answer_type ===
                                      8 ||
                                    quspart.english_question_part_answer_type ===
                                      1 ||
                                    quspart.english_question_part_answer_type ===
                                      7 ? (
                                      <ul className="dg-selector width-controll list-unstyled mb-0">
                                        {" "}
                                        {parseInt(
                                          quspart.english_question_part_automark
                                        ) === 1 ? (
                                          ""
                                        ) : (
                                          <div className="d-flex justify-content-end">
                                            <span className="badge bg-primary font-size-14 mt-auto mb-2">
                                              Manual Marking
                                            </span>
                                          </div>
                                        )}
                                        {quspart.english_question_answers &&
                                          quspart.english_question_answers.map(
                                            (qusAns, index1) => {
                                              // Your logic for filtering student answers and determining status_color and border_color
                                              const stuAnswersarray =
                                                quspart.StudentAnsAttempts.map(
                                                  stuAns => {
                                                    try {
                                                      return JSON.parse(
                                                        stuAns.student_answer
                                                      )
                                                    } catch (error) {
                                                      console.error(
                                                        "Error parsing JSON:",
                                                        error
                                                      )
                                                      return null // or handle the error in an appropriate way
                                                    }
                                                  }
                                                ) || [] // Extracting session keys
                                              //console.log(stuAnswersarray);
                                              // Assuming stuAnswersarray is a nested array
                                              const flattenedStuAnswers =
                                                [].concat(...stuAnswersarray)
                                              let cleanedText =
                                                qusAns.english_answer_text
                                                  .replace(/&nbsp;/g, "")
                                                  .replace(/`/g, "")
                                                  .replace(/<[^>]*>/g, "") || ""
                                              let resultTest = cleanedText
                                                .toLowerCase()
                                                .trim()
                                              let answers =
                                                resultTest.split("|") || []
                                              let firstAnswer = answers[0]
                                                ? answers[0].trim()
                                                : ""
                                              let secondAnswer = answers[1]
                                                ? answers[1].trim()
                                                : ""

                                              let answersArray =
                                                cleanedText
                                                  .split("|")
                                                  .map(ans =>
                                                    ans.trim().toLowerCase()
                                                  )
                                                  .filter(Boolean) || []

                                              if (
                                                qusAns.english_answer_is_correct ===
                                                1
                                              ) {
                                                let filteredStuAns =
                                                  flattenedStuAnswers.filter(
                                                    stuAns =>
                                                      parseInt(
                                                        stuAns.part_id
                                                      ) ===
                                                        parseInt(
                                                          qusAns.english_answer_part_id
                                                        ) &&
                                                      (stuAns.text
                                                        .toLowerCase()
                                                        .trim() == resultTest ||
                                                        stuAns.text
                                                          .toLowerCase()
                                                          .trim() ==
                                                          firstAnswer ||
                                                        stuAns.text
                                                          .toLowerCase()
                                                          .trim() ==
                                                          secondAnswer ||
                                                        answersArray.some(
                                                          answer =>
                                                            answer ==
                                                            stuAns.text
                                                              .toLowerCase()
                                                              .trim()
                                                        )) &&
                                                      parseInt(
                                                        stuAns.answer_id
                                                      ) ===
                                                        parseInt(
                                                          qusAns.english_answer_id
                                                        )
                                                  ) || []

                                                let filteredAllStuAns =
                                                  flattenedStuAnswers.filter(
                                                    stuAns =>
                                                      parseInt(
                                                        stuAns.part_id
                                                      ) ===
                                                        parseInt(
                                                          qusAns.english_answer_part_id
                                                        ) &&
                                                      parseInt(
                                                        stuAns.answer_id
                                                      ) ===
                                                        parseInt(
                                                          qusAns.english_answer_id
                                                        )
                                                  ) || []

                                                return (
                                                  <li
                                                    key={index1}
                                                    className={
                                                      parseInt(
                                                        quspart.english_question_part_automark
                                                      ) === 1
                                                        ? filteredStuAns.length >
                                                          0
                                                          ? "input_box e_input_box"
                                                          : "input_box e_input_box"
                                                        : " input_box e_input_box"
                                                    }
                                                  >
                                                    {ActivityData?.english_question_category_id ===
                                                    2 ? (
                                                      <textarea
                                                        id={
                                                          index1 +
                                                          Math.floor(
                                                            Math.random() * 5
                                                          )
                                                        }
                                                        rows={3}
                                                        style={{
                                                          resize: "vertical",
                                                          ...getAnswerInputStyle(),
                                                        }}
                                                        className={
                                                          parseInt(
                                                            quspart.english_question_part_automark
                                                          ) === 1
                                                            ? filteredStuAns.length >
                                                              0
                                                              ? "answersuccess "
                                                              : "answererror"
                                                            : "answereditor "
                                                        }
                                                        value={
                                                          filteredAllStuAns
                                                            .filter(
                                                              item =>
                                                                parseInt(
                                                                  item.answer_id
                                                                ) ===
                                                                parseInt(
                                                                  qusAns.english_answer_id
                                                                )
                                                            )
                                                            .reverse()
                                                            .map(
                                                              item => item.text
                                                            )
                                                            .find(
                                                              text =>
                                                                text !==
                                                                undefined
                                                            ) || "" // Find the first non-undefined text value
                                                        }
                                                        disabled={true}
                                                        //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                        onChange={e =>
                                                          handletext(
                                                            e,
                                                            qusAns.english_answer_id,
                                                            qusAns.english_answer_part_id
                                                          )
                                                        }
                                                        // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                      />
                                                    ) : (
                                                      <textarea
                                                        id={
                                                          index1 +
                                                          Math.floor(
                                                            Math.random() * 5
                                                          )
                                                        }
                                                        type="text"
                                                        className={
                                                          parseInt(
                                                            quspart.english_question_part_automark
                                                          ) === 1
                                                            ? filteredStuAns.length >
                                                              0
                                                              ? "answersuccess "
                                                              : "answererror"
                                                            : "answereditor "
                                                        }
                                                        style={{
                                                          resize: "vertical",
                                                          ...getAnswerInputStyle(),
                                                        }}
                                                        value={
                                                          filteredAllStuAns
                                                            .filter(
                                                              item =>
                                                                parseInt(
                                                                  item.answer_id
                                                                ) ===
                                                                parseInt(
                                                                  qusAns.english_answer_id
                                                                )
                                                            )
                                                            .reverse()
                                                            .map(
                                                              item => item.text
                                                            )
                                                            .find(
                                                              text =>
                                                                text !==
                                                                undefined
                                                            ) || "" // Find the first non-undefined text value
                                                        }
                                                        disabled={true}
                                                        //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                        onChange={e =>
                                                          handletext(
                                                            e,
                                                            qusAns.english_answer_id,
                                                            qusAns.english_answer_part_id
                                                          )
                                                        }
                                                        // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                      />
                                                    )}
                                                  </li>
                                                )
                                              }
                                            }
                                          )}
                                      </ul>
                                    ) : quspart.english_question_part_answer_type ===
                                      4 ? (
                                      //const stuAnswersarray = stuAnswersJson.length > 0 ? JSON.parse(stuAnswersJson) : [];
                                      <ul className="dg-selector choose-it-question width-controll list-unstyled mb-0">
                                        {parseInt(
                                          quspart.english_question_part_automark
                                        ) === 1 ? (
                                          ""
                                        ) : (
                                          <div className="d-flex justify-content-end">
                                            <span className="badge bg-primary font-size-14 mt-auto mb-2">
                                              Manual Marking
                                            </span>
                                          </div>
                                        )}
                                        {quspart.english_question_answers &&
                                          rearrangeEvenOdd(
                                            quspart.english_question_answers
                                          ).map((qusAns, index1) => {
                                            const cleanText =
                                              qusAns.english_answer_text
                                                .replace(/&nbsp;/g, "")
                                                .replace(/`/g, "")
                                                .replace(/<[^>]*>/g, "")
                                                .trim()

                                            const hasImage =
                                              /<img\s+[^>]*>/gi.test(
                                                qusAns.english_answer_text
                                              )

                                            if (!cleanText && !hasImage) {
                                              return null // Skip rendering if english_answer_text is effectively empty and no image is present
                                            }
                                            serialNumber++
                                            let filteredStuAns =
                                              flattenedStuAnswers.filter(
                                                stuAns =>
                                                  parseInt(stuAns.part_id) ===
                                                    parseInt(
                                                      qusAns.english_answer_part_id
                                                    ) &&
                                                  parseInt(stuAns.answer_id) ===
                                                    parseInt(
                                                      qusAns.english_answer_id
                                                    )
                                              ) || []

                                            var status_color =
                                              "selector-general cursor-pointer"
                                            var border_color =
                                              "border-start-secondary"
                                            if (
                                              filteredStuAns.length > 0 &&
                                              parseInt(
                                                quspart.english_question_part_automark
                                              ) === 1
                                            ) {
                                              if (
                                                parseInt(
                                                  qusAns.english_answer_is_correct
                                                ) === 1
                                              ) {
                                                status_color =
                                                  "selector-success"
                                                border_color =
                                                  "border-start-success"
                                              } else {
                                                status_color = "selector-wrong "
                                                border_color =
                                                  "border-start-danger"
                                              }
                                            }
                                            //const sesKeys = quspart.StudentAnsAttempts.map(stuAns => stuAns.part_id); // Extracting session keys
                                            return (
                                              <li
                                                className={
                                                  selectedAnswer &&
                                                  selectedAnswer ===
                                                    qusAns.english_answer_id
                                                    ? status_color +
                                                      " active choose e_choose"
                                                    : status_color +
                                                      " choose e_choose"
                                                }
                                                key={index1}
                                                onClick={() =>
                                                  selectedAnsOption(qusAns)
                                                }
                                              >
                                                <div
                                                  style={{
                                                    position: "absolute",
                                                    left: "-40px",
                                                    top: "50%",
                                                    transform:
                                                      "translateY(-50%)",
                                                  }}
                                                  onClick={e =>
                                                    e.stopPropagation()
                                                  }
                                                >
                                                  {renderSpeakerToggle(
                                                    "ans-" + qusAns.english_answer_id,
                                                    [qusAns.english_answer_text]
                                                  )}
                                                  
                                                </div>
                                                <div className="p-2 px-3 font-size-18 dg-serial-badge-wrap">
                                                  <span className="dg-serial-badge">
                                                    {serialNumber}
                                                  </span>
                                                </div>
                                                <div
                                                  className={
                                                    "p-2 dg-media " +
                                                    { border_color }
                                                  }
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      qusAns.english_answer_text
                                                        ? qusAns.english_answer_text
                                                        : null,
                                                  }}
                                                ></div>
                                              </li>
                                            )
                                          })}
                                      </ul>
                                    ) : (
                                      <p className="text-center">No option</p>
                                    )}
                                    {/* Anse category statement end */}
                                  </div>
                                  {parseInt(
                                    quspart.english_question_part_automark
                                  ) === 1 &&
                                  quspart.StudentQusSkip?.length === 0 ? (
                                    <div className="mb-3">
                                      <h4 className="font-size-16 fw-bold mb-2">
                                        Solution
                                      </h4>
                                      {filteredCorrectAns.map(
                                        (qusAns, index1) => {
                                          return (
                                            <div
                                              className="e_feedBack"
                                              style={{
                                                border: "1px solid #1a1a1a",
                                                borderRadius: "4px",
                                                fontSize: "16px",
                                              }}
                                            >
                                              <div
                                                dangerouslySetInnerHTML={{
                                                  __html:
                                                    qusAns.english_answer_text
                                                      ? qusAns.english_answer_text
                                                      : null,
                                                }}
                                              ></div>
                                            </div>
                                          )
                                        }
                                      )}
                                    </div>
                                  ) : null}
                                </>
                              ) : null
                            }
                          )}

                        {/* past question End */}
                        {ActivePartData &&
                          ActivePartData.map((quspart, index) => {
                            const stuAnswersarray =
                              quspart.StudentAnsAttempts.map(stuAns => {
                                try {
                                  return JSON.parse(stuAns.student_answer)
                                } catch (error) {
                                  console.error("Error parsing JSON:", error)
                                  return null // or handle the error in an appropriate way
                                }
                              }) || [] // Extracting session keys

                            // Assuming stuAnswersarray is a nested array
                            const flattenedStuAnswers = [].concat(
                              ...stuAnswersarray
                            )
                            let correct_count = 0
                            let serialNumber = 0
                            let initial_question = 0
                            return (
                              <div
                                key={
                                  quspart.english_question_part_id ||
                                  quspart.part_id ||
                                  index
                                }
                              >
                                <div className="d-flex gap-2 flex-row ">
                                  {renderSpeakerToggle(
                                    "ptc" +
                                      (ActivityData1?.is_show_all_parts
                                        ? index + 1
                                        : ActivityData1?.is_current_tab_current_part),
                                    [quspart?.english_question_part_text]
                                  )}
                                  <div className="mr-3">
                                    {/* {ActivityData1.is_first_question} */}
                                    {ActivityData1?.is_show_all_parts
                                      ? index + 1
                                      : ActivityData1.is_current_tab_current_part}
                                    {")"}
                                  </div>
                                  <div
                                    className="question_work"
                                    dangerouslySetInnerHTML={{
                                      __html: quspart.english_question_part_text
                                        ? quspart.english_question_part_text
                                            .replace(
                                              /\[(\d+)Answer char=\d+\]/g,
                                              ""
                                            )
                                            .replace(/\[Answer char=\d+\]/g, "")
                                        : null,
                                    }}
                                  ></div>
                                </div>
                                {/* Anse category statement Star */}
                                {quspart.english_question_part_answer_type ===
                                  8 ||
                                quspart.english_question_part_answer_type ===
                                  1 ||
                                quspart.english_question_part_answer_type ===
                                  7 ? (
                                  <ul className="dg-selector width-controll list-unstyled mb-0">
                                    {resultData &&
                                    resultData.is_auto_mark &&
                                    resultData.is_auto_mark == "0" &&
                                    parseInt(
                                      quspart.english_question_part_automark
                                    ) <= 0 ? (
                                      <div className="d-flex justify-content-end">
                                        <span className="badge bg-primary font-size-14 mt-auto mb-2">
                                          Manual Marking
                                        </span>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                    {quspart.english_question_answers &&
                                      quspart.english_question_answers.map(
                                        (qusAns, index1) => {
                                          // Your logic for filtering student answers and determining status_color and border_color
                                          const stuAnswersarray =
                                            quspart.StudentAnsAttempts.map(
                                              stuAns => {
                                                try {
                                                  return JSON.parse(
                                                    stuAns.student_answer
                                                  )
                                                } catch (error) {
                                                  console.error(
                                                    "Error parsing JSON:",
                                                    error
                                                  )
                                                  return null // or handle the error in an appropriate way
                                                }
                                              }
                                            ) || [] // Extracting session keys
                                          // console.log(stuAnswersarray);
                                          // Assuming stuAnswersarray is a nested array
                                          const flattenedStuAnswers = [].concat(
                                            ...stuAnswersarray
                                          )
                                          let cleanedText =
                                            qusAns.english_answer_text
                                              .replace(/&nbsp;/g, "")
                                              .replace(/`/g, "")
                                              .replace(/<[^>]*>/g, "") || ""
                                          let resultTest = cleanedText
                                            .toLowerCase()
                                            .trim()
                                          let answers =
                                            resultTest.split("|") || []
                                          let firstAnswer = answers[0]
                                            ? answers[0].trim()
                                            : ""
                                          let secondAnswer = answers[1]
                                            ? answers[1].trim()
                                            : ""

                                          let answersArray =
                                            cleanedText
                                              .split("|")
                                              .map(ans =>
                                                ans.trim().toLowerCase()
                                              )
                                              .filter(Boolean) || []

                                          if (
                                            qusAns.english_answer_is_correct ===
                                            1
                                          ) {
                                            initial_question++

                                            let filteredStuAns =
                                              flattenedStuAnswers.filter(
                                                stuAns =>
                                                  parseInt(stuAns.part_id) ===
                                                    parseInt(
                                                      qusAns.english_answer_part_id
                                                    ) &&
                                                  (stuAns.text
                                                    .toLowerCase()
                                                    .trim() == resultTest ||
                                                    stuAns.text
                                                      .toLowerCase()
                                                      .trim() == firstAnswer ||
                                                    stuAns.text
                                                      .toLowerCase()
                                                      .trim() == secondAnswer ||
                                                    answersArray.some(
                                                      answer =>
                                                        answer ==
                                                        stuAns.text
                                                          .toLowerCase()
                                                          .trim()
                                                    )) &&
                                                  parseInt(stuAns.answer_id) ===
                                                    parseInt(
                                                      qusAns.english_answer_id
                                                    )
                                              ) || []

                                            let filteredAllStuAns =
                                              flattenedStuAnswers.filter(
                                                stuAns =>
                                                  parseInt(stuAns.part_id) ===
                                                    parseInt(
                                                      qusAns.english_answer_part_id
                                                    ) &&
                                                  parseInt(stuAns.answer_id) ===
                                                    parseInt(
                                                      qusAns.english_answer_id
                                                    )
                                              ) || []

                                            return (
                                              <>
                                                <li
                                                  key={index1}
                                                  className={
                                                    parseInt(
                                                      quspart.english_question_part_automark
                                                    ) === 1
                                                      ? quspart
                                                          .StudentAnsAttempts
                                                          .length > 0 &&
                                                        filteredStuAns.length >
                                                          0
                                                        ? "input_box e_input_box"
                                                        : "input_box e_input_box"
                                                      : "input_box e_input_box"
                                                  }
                                                >
                                                  {ActivityData?.english_question_category_id ===
                                                  2 ? (
                                                    <textarea
                                                      id={
                                                        index1 +
                                                        Math.floor(
                                                          Math.random() * 5
                                                        )
                                                      }
                                                      placeholder="Type your answer here..."
                                                      rows={3}
                                                      style={{
                                                        resize: "vertical",
                                                        marginRight: "0%",
                                                        ...getAnswerInputStyle(),
                                                      }}
                                                      autoFocus={
                                                        initial_question === 1
                                                      }
                                                      ref={el =>
                                                        (textAreaRefs.current[
                                                          initial_question
                                                        ] = el)
                                                      }
                                                      className={
                                                        quspart
                                                          .StudentAnsAttempts
                                                          .length > 0 &&
                                                        parseInt(
                                                          quspart.english_question_part_automark
                                                        ) === 1
                                                          ? filteredStuAns.length >
                                                            0
                                                            ? "answersuccess initial_question"
                                                            : "answererror initial_question"
                                                          : "answereditor initial_question"
                                                      }
                                                      value={
                                                        resultData &&
                                                        resultData.is_correct &&
                                                        resultData.is_correct ===
                                                          1
                                                          ? filteredAllStuAns
                                                              .filter(
                                                                item =>
                                                                  parseInt(
                                                                    item.answer_id
                                                                  ) ===
                                                                  parseInt(
                                                                    qusAns.english_answer_id
                                                                  )
                                                              )
                                                              .reverse()
                                                              .map(
                                                                item =>
                                                                  item.text
                                                              )
                                                              .find(
                                                                text =>
                                                                  text !==
                                                                  undefined
                                                              ) ||
                                                            selectedAnswerText
                                                              .filter(
                                                                item =>
                                                                  parseInt(
                                                                    item.answer_id
                                                                  ) ===
                                                                  parseInt(
                                                                    qusAns.english_answer_id
                                                                  )
                                                              )
                                                              .map(
                                                                item =>
                                                                  item.text
                                                              )
                                                              .find(
                                                                text =>
                                                                  text !==
                                                                  undefined
                                                              ) ||
                                                            "" // Find the first non-undefined text value
                                                          : isValuefield &&
                                                            filteredStuAns.length <=
                                                              0
                                                          ? selectedAnswerText
                                                              .filter(
                                                                item =>
                                                                  parseInt(
                                                                    item.answer_id
                                                                  ) ===
                                                                  parseInt(
                                                                    qusAns.english_answer_id
                                                                  )
                                                              )
                                                              .map(
                                                                item =>
                                                                  item.text
                                                              )
                                                              .find(
                                                                text =>
                                                                  text !==
                                                                  undefined
                                                              ) || ""
                                                          : filteredAllStuAns
                                                              .filter(
                                                                item =>
                                                                  parseInt(
                                                                    item.answer_id
                                                                  ) ===
                                                                  parseInt(
                                                                    qusAns.english_answer_id
                                                                  )
                                                              )
                                                              .reverse()
                                                              .map(
                                                                item =>
                                                                  item.text
                                                              )
                                                              .find(
                                                                text =>
                                                                  text !==
                                                                  undefined
                                                              ) || ""
                                                      }
                                                      disabled={
                                                        filteredStuAns.length >
                                                        0
                                                          ? true
                                                          : false
                                                      }
                                                      //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                      onChange={e =>
                                                        handletext(
                                                          e,
                                                          qusAns.english_answer_id,
                                                          qusAns.english_answer_part_id
                                                        )
                                                      }
                                                      // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                    />
                                                  ) : (
                                                    <textarea
                                                      id={
                                                        index1 +
                                                        Math.floor(
                                                          Math.random() * 5
                                                        )
                                                      }
                                                      placeholder="Type your answer here..."
                                                      type="text"
                                                      autoFocus={
                                                        initial_question === 1
                                                      }
                                                      ref={el =>
                                                        (textAreaRefs.current[
                                                          initial_question
                                                        ] = el)
                                                      }
                                                      className={
                                                        quspart
                                                          .StudentAnsAttempts
                                                          .length > 0 &&
                                                        parseInt(
                                                          quspart.english_question_part_automark
                                                        ) === 1
                                                          ? filteredStuAns.length >
                                                            0
                                                            ? "answersuccess initial_question"
                                                            : "answererror initial_question"
                                                          : "answereditor initial_question"
                                                      }
                                                      value={
                                                        resultData &&
                                                        resultData.is_correct &&
                                                        resultData.is_correct ===
                                                          1
                                                          ? filteredAllStuAns
                                                              .filter(
                                                                item =>
                                                                  parseInt(
                                                                    item.answer_id
                                                                  ) ===
                                                                  parseInt(
                                                                    qusAns.english_answer_id
                                                                  )
                                                              )
                                                              .reverse()
                                                              .map(
                                                                item =>
                                                                  item.text
                                                              )
                                                              .find(
                                                                text =>
                                                                  text !==
                                                                  undefined
                                                              ) ||
                                                            selectedAnswerText
                                                              .filter(
                                                                item =>
                                                                  parseInt(
                                                                    item.answer_id
                                                                  ) ===
                                                                  parseInt(
                                                                    qusAns.english_answer_id
                                                                  )
                                                              )
                                                              .map(
                                                                item =>
                                                                  item.text
                                                              )
                                                              .find(
                                                                text =>
                                                                  text !==
                                                                  undefined
                                                              ) ||
                                                            "" // Find the first non-undefined text value
                                                          : isValuefield &&
                                                            filteredStuAns.length <=
                                                              0
                                                          ? selectedAnswerText
                                                              .filter(
                                                                item =>
                                                                  parseInt(
                                                                    item.answer_id
                                                                  ) ===
                                                                  parseInt(
                                                                    qusAns.english_answer_id
                                                                  )
                                                              )
                                                              .map(
                                                                item =>
                                                                  item.text
                                                              )
                                                              .find(
                                                                text =>
                                                                  text !==
                                                                  undefined
                                                              ) || ""
                                                          : filteredAllStuAns
                                                              .filter(
                                                                item =>
                                                                  parseInt(
                                                                    item.answer_id
                                                                  ) ===
                                                                  parseInt(
                                                                    qusAns.english_answer_id
                                                                  )
                                                              )
                                                              .reverse()
                                                              .map(
                                                                item =>
                                                                  item.text
                                                              )
                                                              .find(
                                                                text =>
                                                                  text !==
                                                                  undefined
                                                              ) || ""
                                                      }
                                                      disabled={
                                                        filteredStuAns.length >
                                                        0
                                                          ? true
                                                          : false
                                                      }
                                                      style={{
                                                        resize: "vertical",
                                                        marginRight: "0%",
                                                        ...getAnswerInputStyle(),
                                                      }}
                                                      //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                      onChange={e =>
                                                        handletext(
                                                          e,
                                                          qusAns.english_answer_id,
                                                          qusAns.english_answer_part_id
                                                        )
                                                      }
                                                      // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                    />
                                                  )}
                                                </li>
                                                {quspart.StudentAnsAttempts
                                                  .length === 1 &&
                                                parseInt(
                                                  quspart.english_question_part_automark
                                                ) === 1 ? (
                                                  filteredStuAns.length >
                                                  0 ? null : (
                                                    <div className="d-flex justify-content-end">
                                                      <span className="text-danger font-size-14 mt-auto mb-2">
                                                        Try again with a
                                                        different answer.
                                                      </span>
                                                    </div>
                                                  )
                                                ) : null}

                                                {nextQuestion &&
                                                SummryView === false &&
                                                qusAns &&
                                                quspart.english_question_answers
                                                  .length ==
                                                  index1 + 1 &&
                                                (!ActivityData1?.is_show_all_parts ||
                                                  index ===
                                                    ActivePartData.length -
                                                      1) &&
                                                skipAnchorEl
                                                  ? createPortal(
                                                      <span
                                                        className="font-size-15 mt-1 text-danger fw-bold skip-button"
                                                        onClick={() =>
                                                          handletext(
                                                            ".",
                                                            qusAns.english_answer_id,
                                                            qusAns.english_answer_part_id,
                                                            1
                                                          )
                                                        }
                                                      >
                                                        <svg
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          version="1.1"
                                                          xmlnsXlink="http://www.w3.org/1999/xlink"
                                                          width={20}
                                                          height={20}
                                                          x={0}
                                                          y={0}
                                                          viewBox="0 0 24 25"
                                                          style={{
                                                            enableBackground:
                                                              "new 0 0 512 512",
                                                          }}
                                                          xmlSpace="preserve"
                                                          className=""
                                                        >
                                                          <g>
                                                            <path
                                                              fill="#ef0000"
                                                              fillRule="evenodd"
                                                              d="M9.676 8.205c0-2.256 2.568-3.553 4.383-2.212l6.822 5.037a2.75 2.75 0 0 1 0 4.424l-6.822 5.037c-1.815 1.34-4.383.044-4.383-2.212v-.035l-3.042 2.247c-1.816 1.34-4.384.044-4.384-2.212V8.205c0-2.256 2.568-3.553 4.384-2.212l3.042 2.246zm1.5 1.142 2.279 1.683a2.75 2.75 0 0 1 0 4.424l-2.28 1.683v1.142c0 1.025 1.168 1.615 1.993 1.005l6.821-5.036a1.25 1.25 0 0 0 0-2.012L13.17 7.2c-.826-.61-1.993-.02-1.993 1.005zM5.743 7.2c-.826-.61-1.993-.02-1.993 1.005V18.28c0 1.025 1.167 1.615 1.993 1.005l6.82-5.036a1.25 1.25 0 0 0 0-2.012z"
                                                              clipRule="evenodd"
                                                              opacity={1}
                                                              data-original="#000000"
                                                              className=""
                                                            />
                                                          </g>
                                                        </svg>{" "}
                                                        Skip Question
                                                      </span>,
                                                      skipAnchorEl
                                                    )
                                                  : null}
                                              </>
                                            )
                                          }
                                        }
                                      )}
                                  </ul>
                                ) : quspart.english_question_part_answer_type ===
                                  4 ? (
                                  //const stuAnswersarray = stuAnswersJson.length > 0 ? JSON.parse(stuAnswersJson) : [];
                                  <ul className="dg-selector choose-it-question width-controll list-unstyled mb-0">
                                    {resultData &&
                                    resultData.is_auto_mark &&
                                    resultData.is_auto_mark == "0" &&
                                    parseInt(
                                      quspart.english_question_part_automark
                                    ) <= 1 ? (
                                      <div className="d-flex justify-content-end">
                                        <span className="badge bg-primary font-size-14 mt-auto mb-2">
                                          Manual Marking
                                        </span>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                    {quspart.english_question_answers &&
                                      rearrangeEvenOdd(
                                        quspart.english_question_answers
                                      ).map((qusAns, index1) => {
                                        

                                        const cleanText =
                                          qusAns.english_answer_text
                                            .replace(/&nbsp;/g, "")
                                            .replace(/`/g, "")
                                            .replace(/<[^>]*>/g, "")
                                            .trim()

                                        const hasImage = /<img\s+[^>]*>/gi.test(
                                          qusAns.english_answer_text
                                        )

                                        if (!cleanText && !hasImage) {
                                          return null // Skip rendering if english_answer_text is effectively empty and no image is present
                                        }

                                        serialNumber++

                                        let filteredStuAns =
                                          flattenedStuAnswers.filter(
                                            stuAns =>
                                              parseInt(stuAns.part_id) ===
                                                parseInt(
                                                  qusAns.english_answer_part_id
                                                ) &&
                                              parseInt(stuAns.answer_id) ===
                                                parseInt(
                                                  qusAns.english_answer_id
                                                )
                                          ) || []

                                        var status_color =
                                          "selector-general cursor-pointer"
                                        var border_color =
                                          "border-start-secondary"
                                        if (filteredStuAns.length > 0) {
                                          if (
                                            parseInt(
                                              qusAns.english_answer_is_correct
                                            ) === 1
                                          ) {
                                            status_color = "selector-success"
                                            border_color =
                                              "border-start-success"
                                            correct_count += 1
                                          } else {
                                            status_color = "selector-wrong "
                                            border_color = "border-start-danger"
                                          }
                                        }
                                        //const sesKeys = quspart.StudentAnsAttempts.map(stuAns => stuAns.part_id); // Extracting session keys
                                        return (
                                          <>
                                            <li
                                              className={
                                                selectedAnswer &&
                                                selectedAnswer ===
                                                  qusAns.english_answer_id
                                                  ? status_color +
                                                    " active choose e_choose"
                                                  : status_color +
                                                    " choose e_choose"
                                              }
                                              key={index1}
                                              onClick={() =>
                                                selectedAnsOption(qusAns)
                                              }
                                            >
                                              <div
                                                style={{
                                                  position: "absolute",
                                                  left: "-40px",
                                                  top: "50%",
                                                  transform: "translateY(-50%)",
                                                }}
                                                onClick={e =>
                                                  e.stopPropagation()
                                                }
                                              >
                                                {renderSpeakerToggle(
                                                  "ans-" + qusAns.english_answer_id,
                                                  [qusAns.english_answer_text]
                                                )}
                                               
                                              </div>
                                              <div className="p-2 px-3 font-size-18 dg-serial-badge-wrap">
                                                <span className="dg-serial-badge">
                                                  {serialNumber}
                                                </span>
                                              </div>
                                              <div
                                                className={
                                                  "p-2 dg-media " +
                                                  { border_color }
                                                }
                                                dangerouslySetInnerHTML={{
                                                  __html:
                                                    qusAns.english_answer_text
                                                      ? qusAns.english_answer_text
                                                      : null,
                                                }}
                                              ></div>
                                            </li>
                                            {index1 + 1 >=
                                              quspart.english_question_answers
                                                .length &&
                                            quspart.StudentAnsAttempts
                                              .length === 1 &&
                                            parseInt(
                                              quspart.english_question_part_automark
                                            ) === 1 ? (
                                              correct_count > 0 ? null : (
                                                <div className="d-flex justify-content-end">
                                                  <span className="text-danger font-size-14 mt-auto mb-2">
                                                    Try again with a different
                                                    answer.
                                                  </span>
                                                </div>
                                              )
                                            ) : null}
                                            {nextQuestion &&
                                            SummryView === false &&
                                            index1 + 1 >=
                                              quspart.english_question_answers
                                                .length &&
                                            (!ActivityData1?.is_show_all_parts ||
                                              index ===
                                                ActivePartData.length - 1) &&
                                            skipAnchorEl
                                              ? createPortal(
                                                  <span
                                                    className="font-size-15 mt-1 text-danger fw-bold skip-button"
                                                    onClick={() =>
                                                      selectedAnsOption(
                                                        qusAns,
                                                        1
                                                      )
                                                    }
                                                  >
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      version="1.1"
                                                      xmlnsXlink="http://www.w3.org/1999/xlink"
                                                      width={20}
                                                      height={20}
                                                      x={0}
                                                      y={0}
                                                      viewBox="0 0 24 25"
                                                      style={{
                                                        enableBackground:
                                                          "new 0 0 512 512",
                                                      }}
                                                      xmlSpace="preserve"
                                                      className=""
                                                    >
                                                      <g>
                                                        <path
                                                          fill="#ef0000"
                                                          fillRule="evenodd"
                                                          d="M9.676 8.205c0-2.256 2.568-3.553 4.383-2.212l6.822 5.037a2.75 2.75 0 0 1 0 4.424l-6.822 5.037c-1.815 1.34-4.383.044-4.383-2.212v-.035l-3.042 2.247c-1.816 1.34-4.384.044-4.384-2.212V8.205c0-2.256 2.568-3.553 4.384-2.212l3.042 2.246zm1.5 1.142 2.279 1.683a2.75 2.75 0 0 1 0 4.424l-2.28 1.683v1.142c0 1.025 1.168 1.615 1.993 1.005l6.821-5.036a1.25 1.25 0 0 0 0-2.012L13.17 7.2c-.826-.61-1.993-.02-1.993 1.005zM5.743 7.2c-.826-.61-1.993-.02-1.993 1.005V18.28c0 1.025 1.167 1.615 1.993 1.005l6.82-5.036a1.25 1.25 0 0 0 0-2.012z"
                                                          clipRule="evenodd"
                                                          opacity={1}
                                                          data-original="#000000"
                                                          className=""
                                                        />
                                                      </g>
                                                    </svg>{" "}
                                                    Skip Question
                                                  </span>,
                                                  skipAnchorEl
                                                )
                                              : null}
                                          </>
                                        )
                                      })}
                                  </ul>
                                ) : (
                                  <p className="text-center">No option</p>
                                )}
                                {/* Anse category statement end */}
                              </div>
                            )
                          })}
                      </div>
                    </div>
                  </li>
                </ul>
                <div className="d-flex justify-content-between align-items-center gap-3 mt-2 skip-submit-row">
                  <div className="skip-anchor" ref={setSkipAnchorEl}></div>
                  <div className="text-end">
                  {resultData && resultData.is_auto_mark == "0" ? (
                    ""
                  ) : nextQuestion && parseInt(IsSkipButton) !== 1 ? (
                    <div className="submit-actions-fixed">
                      <Button
                        type="button"
                        className="save-progress-btn btn btn-danger cs-btn-danger"
                        disabled={IsSubmited}
                        onKeyDown={e => {
                          if (e.key === "Enter") e.stopPropagation()
                        }}
                        onClick={handleSaveAndExit}
                      >
                        Save and Exit
                      </Button>
                      {selectedAnswerText &&
                      selectedAnswerText.length > 0 ? (
                        <Button
                          type="button"
                          className="submit-btn-question btn btn-danger cs-btn-danger"
                          disabled={IsSubmited}
                          onClick={submitReadingWriting}
                        >
                          Submit
                        </Button>
                      ) : null}
                    </div>
                  ) : null}
                  </div>
                </div>
                {renderNextButton()}

                {!nextQuestion || SummryView === true ? (
                  <div className="navigator-wrapper position-relative pb-3 mt-4">
                    <div
                      style={getOverlayCardStyle()}
                      className={`nv-feedback-card feedback-${keyStage} ${
                        ActivePartData?.some(
                          quspart =>
                            parseInt(quspart.english_question_part_automark) ===
                              1 && quspart.StudentQusSkip?.length === 0
                        )
                          ? resultData && parseInt(resultData.is_correct) === 1
                            ? parseInt(resultData.attempCount) >= 2
                              ? "nv-feedback-card--warn"
                              : "nv-feedback-card--ok"
                            : resultData && !resultData.studentAnswer
                            ? "nv-feedback-card--skip"
                            : "nv-feedback-card--err"
                          : "nv-feedback-card--warn"
                      }`}
                    >
                      <div className="nv-feedback-card__main">
                        <div className="nv-feedback-card__icon">
                          {renderFeedbackIcon(resultData, ActivePartData)}
                        </div>

                        <div className="nv-feedback-card__text">
                          <div className="nv-feedback-card__title-row">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                flexWrap: "wrap",
                              }}
                            >
                              <div className="nv-feedback-card__status-group">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <span
                                    className={`nv-feedback-card__title feedback-title-${keyStage} ${
                                      ActivePartData?.some(
                                        quspart =>
                                          parseInt(
                                            quspart.english_question_part_automark
                                          ) === 1 &&
                                          quspart.StudentQusSkip?.length === 0
                                      )
                                        ? resultData &&
                                          parseInt(resultData.is_correct) === 1
                                          ? parseInt(resultData.attempCount) >=
                                            2
                                            ? "nv-feedback-card__title--warn"
                                            : "nv-feedback-card__title--ok"
                                          : resultData &&
                                            !resultData.studentAnswer
                                          ? "nv-feedback-card__title--skip"
                                          : "nv-feedback-card__title--err"
                                        : "nv-feedback-card__title--warn"
                                    }`}
                                  >
                                    {ActivePartData?.some(
                                      quspart =>
                                        parseInt(
                                          quspart.english_question_part_automark
                                        ) === 1 &&
                                        quspart.StudentQusSkip?.length === 0
                                    )
                                      ? resultData &&
                                        parseInt(resultData.is_correct) === 1
                                        ? "Correct!"
                                        : resultData &&
                                          !resultData.studentAnswer
                                        ? "Skipped!"
                                        : "Incorrect"
                                      : "Manual Marking"}
                                  </span>

                                  <ResultSpeakButton
                                    id={`result-${ActivityData?.english_question_id}`}
                                    activeId={activeId}
                                    speak={speak}
                                    resultData={resultData}
                                    parts={
                                      ActivePartData?.some(
                                        quspart =>
                                          parseInt(
                                            quspart.english_question_part_automark
                                          ) === 1 &&
                                          quspart.StudentQusSkip?.length === 0
                                      )
                                        ? [
                                            resultData &&
                                            parseInt(resultData.is_correct) ===
                                              1
                                              ? "Correct! Great job!"
                                              : resultData &&
                                                !resultData.studentAnswer
                                              ? "Skipped! Give it a try!"
                                              : "Incorrect. Keep practising!",
                                            resultData?.studentAnswer
                                              ? `You answered: ${resultData.studentAnswer}`
                                              : null,
                                            ...(resultData?.is_correct !== 3 &&
                                            !ActivityData1?.is_show_all_parts
                                              ? resultData?.explanation
                                                ? [`${resultData.explanation}`]
                                                : ActivePartData?.flatMap(
                                                    part =>
                                                      part.english_question_answers
                                                        ?.filter(
                                                          ans =>
                                                            parseInt(
                                                              ans.english_answer_is_correct
                                                            ) === 1
                                                        )
                                                        .map(
                                                          ans =>
                                                            `Correct answer: ${ans.english_answer_text}`
                                                        )
                                                  )
                                              : resultData?.is_correct === 3
                                              ? [
                                                  `Please attempt the skipped question`,
                                                ]
                                              : []),
                                          ]
                                        : [
                                            "Manual Marking. Please wait for your teacher to review your answer.",
                                            resultData?.studentAnswer
                                              ? `You answered: ${resultData.studentAnswer}`
                                              : null,
                                          ]
                                    }
                                  />
                                </div>
                                <p
                                  className={`nv-feedback-card__subtitle feedback-subtitle-${keyStage}`}
                                >
                                  {ActivePartData?.some(
                                    quspart =>
                                      parseInt(
                                        quspart.english_question_part_automark
                                      ) === 1 &&
                                      quspart.StudentQusSkip?.length === 0
                                  )
                                    ? resultData &&
                                      parseInt(resultData.is_correct) === 1
                                      ? "Great job!"
                                      : resultData && !resultData.studentAnswer
                                      ? "Give it a try!"
                                      : "Keep practising!"
                                    : "Please wait for your teacher to review your answer."}
                                </p>
                              </div>

                              <div className="nv-feedback-card__inline-stats">
                                <div className="nv-feedback-card__stat-item">
                                  <span className="nv-feedback-card__stat-label">
                                    ⏱ SUGGESTED TIME
                                  </span>
                                  <span className="nv-feedback-card__stat-value">
                                    {ActivityData.english_question_time_needed}
                                  </span>
                                </div>
                                <div className="nv-feedback-card__stat-sep" />
                                <div className="nv-feedback-card__stat-item">
                                  <span className="nv-feedback-card__stat-label">
                                    🎯 GOT IT RIGHT
                                  </span>
                                  <span className="nv-feedback-card__stat-value">
                                    {resultData
                                      ? parseInt(
                                          resultData.accuracyOfOtherStudents
                                        )
                                      : 0}
                                    %
                                  </span>
                                </div>
                              </div>

                              {resultData && resultData.studentAnswer ? (
                                <div
                                  className={`nv-answer-box answer-box-${keyStage} ${
                                    parseInt(resultData.is_correct) === 1
                                      ? parseInt(resultData.attempCount) >= 2
                                        ? "nv-answer-box--warn"
                                        : "nv-answer-box--ok"
                                      : "nv-answer-box--err"
                                  }`}
                                >
                                  <div className="nv-answer-box__col nv-answer-box__col--answer">
                                    <span className="nv-answer-box__label">
                                      You answered:
                                    </span>
                                    <p
                                      className={`nv-answer-box__value answer-value-${keyStage}`}
                                    >
                                      {resultData.studentAnswer}
                                    </p>
                                  </div>
                                  {ActivePartData?.some(
                                    quspart =>
                                      parseInt(
                                        quspart.english_question_part_automark
                                      ) === 1 &&
                                      quspart.StudentQusSkip?.length === 0
                                  ) &&
                                  resultData.explanation &&
                                  !ActivityData1?.is_show_all_parts ? (
                                    <>
                                      <div className="nv-answer-box__divider" />
                                      <div className="nv-answer-box__col nv-answer-box__col--explanation">
                                        <span className="nv-answer-box__label">
                                          Explanation:
                                        </span>
                                        <div
                                          className={`nv-answer-box__text answer-text-${keyStage}`}
                                          dangerouslySetInnerHTML={{
                                            __html: resultData.explanation,
                                          }}
                                        />
                                      </div>
                                    </>
                                  ) : null}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div
                          className="nv-feedback-card__actions"
                          style={{ alignSelf: "flex-start", justifyContent: "flex-end", alignItems: "flex-end" }}
                          ref={navigatorRef}
                        >
                          {/* Coin badge */}
                          <div className="nv-feedback-card__coin-badge">
                            <img width={32} src={awicon} alt="coins" />
                            <div className="nv-feedback-card__coin-text">
                              <span className="nv-feedback-card__coin-num">
                                {resultData &&
                                parseInt(resultData.is_correct) === 1
                                  ? "+"
                                  : ""}
                                {resultData && resultData?.points && parseInt(resultData.is_correct) !== 3 ? resultData.points : 0}
                              </span>
                              <span className="nv-feedback-card__coin-lbl">
                                coins
                              </span>
                            </div>
                          </div>

                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                            {resultData &&
                            resultData.LastQuestion &&
                            parseInt(SkipQuestionCount) > 0 ? (
                              <>
                                <Button
                                  className="btn btn-danger cs-btn-danger mt-1 nv-feedback-card__btn"
                                  onClick={() => trySkipQuestion()}
                                >
                                  Attempt {SkipQuestionCount} skipped questions
                                </Button>
                                <p className="font-size-16 d-flex align-items-center gap-2" style={{ margin: 0 }}>
                                  OR
                                </p>
                              </>
                            ) : null}

                            {resultData ? (
                              !resultData.LastQuestion ? (
                                <Button
                                  className="next-btn-question btn btn-danger cs-btn-danger mt-1 nv-feedback-card__btn"
                                  onClick={() => {
                                    //window.location.reload();
                                    triggerFunction()
                                    setnextQuestion(false)
                                    setActivePartData([])
                                    setIsSubmited(false)
                                    setresultData(null)
                                  }}
                                >
                                  Next Question&nbsp;
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-fast-forward-icon lucide-fast-forward"
                                  >
                                    <path d="M12 6a2 2 0 0 1 3.414-1.414l6 6a2 2 0 0 1 0 2.828l-6 6A2 2 0 0 1 12 18z" />
                                    <path d="M2 6a2 2 0 0 1 3.414-1.414l6 6a2 2 0 0 1 0 2.828l-6 6A2 2 0 0 1 2 18z" />
                                  </svg>
                                </Button>
                              ) : (
                                <Button
                                  className="summary-btn-question btn btn-danger cs-btn-danger mt-1 nv-feedback-card__btn"
                                  onClick={() => assessementSummary()}
                                >
                                  Finish
                                </Button>
                              )
                            ) : null}
                          </div>
                        </div>
                      </div>

                      {resultData &&
                      resultData.attempCount &&
                      parseInt(resultData.attempCount) >= 2 ? (
                        <span
                          className="font-size-15 text-dark fw-bold"
                          onClick={tog_standard1}
                          style={{
                            fontStyle: "italic",
                            textDecoration: "underline",
                            cursor: "pointer",
                            display: "block",
                            textAlign: "center",
                          }}
                        >
                          It was marked incorrectly
                        </span>
                      ) : null}
                    </div>
                  </div>
                ) : null}
              </div>
            )
          } else if (
            ActivityData &&
            ActivityData.english_question_category_id &&
            (parseInt(ActivityData.english_question_category_id) === 13 ||
              parseInt(ActivityData.english_question_category_id) === 10)
          ) {
            return (
              <div
                style={getOverlayCardStyle()}
                className={`hw-list mt-2 not_scroll ${
                  localStorage.getItem("is_fontsize") == 1
                    ? "stu-custom-font-size"
                    : ""
                }`}
              >
                {/* <ToastContainer autoClose={3000} /> */}
                <Modal isOpen={modal_standard1} toggle={tog_standard1}>
                  <ModalHeader toggle={tog_standard1}></ModalHeader>
                  <ModalBody>
                    <p className="text-center fw-bold text-dark mb-0 font-size-18">
                      Report this question to your tutor as being incorrectly
                      marked?
                    </p>
                  </ModalBody>
                  <ModalFooter className="justify-content-center">
                    <Button
                      className="btn-cst-success-md"
                      disabled={isFlagReport}
                      onClick={() => {
                        submitQuestionReport()
                      }}
                    >
                      Yes
                    </Button>
                    <Button
                      className="btn-cst-danger-md"
                      onClick={() => {
                        tog_standard1()
                      }}
                    >
                      No
                    </Button>
                  </ModalFooter>
                </Modal>

                <Modal isOpen={modal_standard} toggle={tog_standard}>
                  <Form
                    className="mt-4"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    action="#"
                  >
                    <ModalHeader toggle={tog_standard}>
                      Flag this Question
                    </ModalHeader>
                    <ModalBody>
                      <div className="flex-grow-1 mb-3 cs-rsm">
                        <Label>Select a Reason</Label>
                        <Select
                          name="reson"
                          id="reson"
                          className="cs-style bg-mutant"
                          value={optionGroup.find(
                            option =>
                              option.value &&
                              validation.values.reson &&
                              option.value.toString() ==
                                validation.values.reson.toString()
                          )}
                          placeholder="Select"
                          onChange={selectedOption => {
                            const event = {
                              target: {
                                name: "reson",
                                value: selectedOption["value"],
                              },
                            }
                            validation.handleChange(event)
                          }}
                          onBlur={event => {
                            validation.handleBlur(event)
                          }}
                          // invalid={
                          //   validation.touched.reson &&
                          //   validation.errors.reson
                          //     ? true
                          //     : false
                          // }
                          options={optionGroup}
                          classNamePrefix="select2-selection"
                        />
                        {validation.touched.reson && validation.errors.reson ? (
                          <div className="invalid-feedback-all">
                            {validation.errors.reson}
                          </div>
                        ) : null}
                      </div>
                      <div className="flex-grow-1 cs-rsm">
                        <Label>Reason:</Label>
                        <Input
                          style={{ height: "200px" }}
                          type="textarea"
                          name="reson_text"
                          id="reson_text"
                          // onChange={e=> {
                          // textareachange(e)
                          // }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.reson_text || ""}
                          // invalid={
                          //   validation.touched.reson_text &&
                          //   validation.errors.reson_text
                          //     ? true
                          //     : false
                          // }
                          maxLength="225"
                          rows="3"
                          placeholder="Write your reason here..."
                        />
                        {validation.touched.reson_text &&
                        validation.errors.reson_text ? (
                          <div className="invalid-feedback-all">
                            {validation.errors.reson_text}
                          </div>
                        ) : null}
                      </div>
                    </ModalBody>
                    <ModalFooter className="justify-content-center">
                      <Button
                        type="submit"
                        className="btn btn-danger cs-btn-danger"
                        disabled={isFlagReport}
                      >
                        Submit
                      </Button>
                    </ModalFooter>
                  </Form>
                </Modal>
                <ul
                  className={`list-unstyled mb-0 question_container nv-scrollbar ${
                    parseInt(ActivityData.english_question_category_id) === 13
                      ? "writing-question"
                      : ""
                  } ${isDarkMode && keyStage === "KS3" ? "nv-dark-mode" : ""}`}
                >
                  <li
                    className="justify-content-between mb-0 overflow-visible"
                    onKeyDown={handleKeyDown}
                    tabIndex={index}
                  >
                    <div className="d-flex align-items-center gap-4 justify-content-end nv-sticky-header">
                      <div className="mb-0 d-flex align-items-center gap-2">
                        <p className="mb-0">
                          #
                          {ActivityData.english_question_id
                            ? ActivityData.english_question_id
                            : null}
                        </p>
                        <span onClick={tog_standard}>
                          <i className="mdi mdi-flag-variant-outline font-size-18"></i>
                        </span>
                      </div>
                      {renderDarkModeToggle()}
                      {renderOverlayToggle()}
                    </div>
                    <div className="d-flex gap-3 mt-2">
                      {renderSpeakerToggle(ActivityData?.english_question_id, [
                        ActivityData?.english_question_instruction,
                        ...(ActivityData?.english_question_choices?.map(
                          qusChoice =>
                            `${qusChoice.choice_no}. ${qusChoice.choice_text}`
                        ) || []),
                        ActivityData?.english_question_text,
                        ActivityData?.part_heading,
                      ])}
                      <div>
                        {ActivityData?.english_question_instruction ? (
                          <div
                            className="mt-1"
                            dangerouslySetInnerHTML={{
                              __html: ActivityData.english_question_instruction
                                ? ActivityData.english_question_instruction
                                    .replace(/\[(\d+)Answer char=\d+\]/g, "")
                                    .replace(/\[Answer char=\d+\]/g, "")
                                : null,
                            }}
                          ></div>
                        ) : null}

                        {/* Choice */}
                        {ActivityData &&
                        ActivityData.english_question_choices &&
                        ActivityData.english_question_choices.length > 0 ? (
                          <div className="mt-1 my-2 border border-dark choice-options_wrapper">
                            {ActivityData.english_question_choices.map(
                              (qusChoice, Cindex) => (
                                <div class="choice-options_child" key={Cindex}>
                                  <div>{qusChoice.choice_no}</div>
                                  <div>{qusChoice.choice_text}</div>
                                </div>
                              )
                            )}
                          </div>
                        ) : null}

                        {ActivityData?.english_question_text ? (
                          <div
                            className="mt-0 question_work"
                            dangerouslySetInnerHTML={{
                              __html: ActivityData.english_question_text
                                ? ActivityData.english_question_text
                                    .replace(/\[(\d+)Answer char=\d+\]/g, "")
                                    .replace(/\[Answer char=\d+\]/g, "")
                                : null,
                            }}
                          ></div>
                        ) : null}
                        {ActivityData &&
                        ActivityData.part_heading &&
                        ActivityData.part_heading != "" ? (
                          <div
                            className="mt-0 question_work"
                            dangerouslySetInnerHTML={{
                              __html: ActivityData.part_heading
                                .replace(/\[(\d+)Answer char=\d+\]/g, "")
                                .replace(/\[Answer char=\d+\]/g, ""),
                            }}
                          ></div>
                        ) : null}
                        {/* File option */}
                        {ActivityData?.english_question_files?.length > 0 ? (
                          <div className="mt-0 my-2">
                            {ActivityData &&
                            ActivityData.english_question_files &&
                            ActivityData.english_question_files.length > 0
                              ? ActivityData.english_question_files.map(
                                  (qusFile, index) => (
                                    <img
                                      key={index}
                                      alt=""
                                      style={{
                                        height: "auto",
                                        maxWidth: "100%",
                                      }}
                                      src={`https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/question_files/${qusFile.file_name}`}
                                    />
                                  )
                                )
                              : null}
                          </div>
                        ) : null}
                      </div>
                    </div>

                    {/* Past question */}
                    {!ActivityData1?.is_show_all_parts &&
                      ActivityData.english_question_parts &&
                      ActivityData.english_question_parts.map(
                        (quspart, index) => {
                          if (
                            quspart.english_question_answers &&
                            quspart.english_question_answers.length > 0 &&
                            quspart.english_question_answers[0]
                              .english_answer_text &&
                            quspart.english_question_answers[0]
                              .english_answer_text != ""
                          ) {
                            const stuAnswersarray =
                              quspart.StudentAnsAttempts.map(stuAns => {
                                try {
                                  return JSON.parse(stuAns.student_answer)
                                } catch (error) {
                                  console.error("Error parsing JSON:", error)
                                  return null // or handle the error in an appropriate way
                                }
                              }) || [] // Extracting session keys

                            // Assuming stuAnswersarray is a nested array
                            const flattenedStuAnswers = [].concat(
                              ...stuAnswersarray
                            )
                            let serialNumber = 0
                            return index + 1 <
                              ActivityData1.is_current_tab_current_part ? (
                              <div
                                key={index}
                                className="d-flex justify-content-between align-items-flex-start mt-1"
                              >
                                <div className="d-flex gap-2 flex-row ">
                                  {/* <div className="mr-3">{index + 1}</div> */}
                                  {renderSpeakerToggle("pt" + index, [
                                    quspart.english_question_part_text,
                                  ])}
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: quspart.english_question_part_text
                                        ? quspart.english_question_part_text
                                            .replace(
                                              /\[\[(.+?)\]\]/g,
                                              function (match, p1) {
                                                return p1.length > 1
                                                  ? `<span class="text-bg-yellow">${p1}</span>`
                                                  : `<span class="text-bg-blue">${p1}</span>`
                                              }
                                            )
                                            .replace(/\{\{/g, "<u>")
                                            .replace(/\}\}/g, "</u>")
                                            .replace(
                                              /\[(\d+)Answer char=\d+\]/g,
                                              ""
                                            )
                                            .replace(/\[Answer char=\d+\]/g, "")
                                        : null,
                                    }}
                                  ></div>
                                </div>
                                {/* Anse category statement Star */}
                                {quspart.english_question_part_answer_type ===
                                  8 ||
                                quspart.english_question_part_answer_type ===
                                  1 ||
                                quspart.english_question_part_answer_type ===
                                  7 ? (
                                  <ul
                                    className="dg-selector width-controll list-unstyled mb-0"
                                    style={{
                                      alignSelf: "flex-start",
                                      marginTop: 0,
                                    }}
                                  >
                                    {" "}
                                    {parseInt(
                                      quspart.english_question_part_automark
                                    ) === 1 ? (
                                      ""
                                    ) : (
                                      <div className="d-flex justify-content-end">
                                        <span className="badge bg-primary font-size-14 mt-auto mb-2">
                                          Manual Marking
                                        </span>
                                      </div>
                                    )}
                                    {quspart.english_question_answers &&
                                      quspart.english_question_answers.map(
                                        (qusAns, index1) => {
                                          // Your logic for filtering student answers and determining status_color and border_color
                                          const stuAnswersarray =
                                            quspart.StudentAnsAttempts.map(
                                              stuAns => {
                                                try {
                                                  return JSON.parse(
                                                    stuAns.student_answer
                                                  )
                                                } catch (error) {
                                                  console.error(
                                                    "Error parsing JSON:",
                                                    error
                                                  )
                                                  return null // or handle the error in an appropriate way
                                                }
                                              }
                                            ) || [] // Extracting session keys
                                          //console.log(stuAnswersarray);
                                          // Assuming stuAnswersarray is a nested array
                                          const flattenedStuAnswers = [].concat(
                                            ...stuAnswersarray
                                          )
                                          let cleanedText =
                                            qusAns.english_answer_text
                                              .replace(/&nbsp;/g, "")
                                              .replace(/`/g, "")
                                              .replace(/<[^>]*>/g, "") || ""
                                          let resultTest = cleanedText
                                            .toLowerCase()
                                            .trim()
                                          let answers =
                                            resultTest.split("|") || []
                                          let firstAnswer = answers[0]
                                            ? answers[0].trim()
                                            : "No_Data"
                                          let secondAnswer = answers[1]
                                            ? answers[1].trim()
                                            : "No_Data"
                                          let answersArray =
                                            cleanedText
                                              .split("|")
                                              .map(ans =>
                                                ans.trim().toLowerCase()
                                              )
                                              .filter(Boolean) || []
                                          if (
                                            qusAns.english_answer_is_correct ===
                                            1
                                          ) {
                                            let filteredStuAns =
                                              flattenedStuAnswers.filter(
                                                stuAns =>
                                                  parseInt(stuAns.part_id) ===
                                                    parseInt(
                                                      qusAns.english_answer_part_id
                                                    ) &&
                                                  (stuAns.text
                                                    .toLowerCase()
                                                    .trim() == resultTest ||
                                                    stuAns.text
                                                      .toLowerCase()
                                                      .trim() == firstAnswer ||
                                                    stuAns.text
                                                      .toLowerCase()
                                                      .trim() == secondAnswer ||
                                                    answersArray.some(
                                                      answer =>
                                                        answer ==
                                                        stuAns.text
                                                          .toLowerCase()
                                                          .trim()
                                                    )) &&
                                                  parseInt(stuAns.answer_id) ===
                                                    parseInt(
                                                      qusAns.english_answer_id
                                                    )
                                              ) || []

                                            let filteredAllStuAns =
                                              flattenedStuAnswers.filter(
                                                stuAns =>
                                                  parseInt(stuAns.part_id) ===
                                                    parseInt(
                                                      qusAns.english_answer_part_id
                                                    ) &&
                                                  parseInt(stuAns.answer_id) ===
                                                    parseInt(
                                                      qusAns.english_answer_id
                                                    )
                                              ) || []

                                            return (
                                              <li
                                                key={index1}
                                                className={
                                                  parseInt(
                                                    quspart.english_question_part_automark
                                                  ) === 1
                                                    ? filteredStuAns.length > 0
                                                      ? "input_box small_input_box"
                                                      : "input_box small_input_box"
                                                    : " input_box small_input_box"
                                                }
                                              >
                                                <input
                                                  id={
                                                    index1 +
                                                    Math.floor(
                                                      Math.random() * 5
                                                    )
                                                  }
                                                  type="text"
                                                  className={
                                                    parseInt(
                                                      quspart.english_question_part_automark
                                                    ) === 1
                                                      ? filteredStuAns.length >
                                                        0
                                                        ? "answersuccess"
                                                        : "answererror"
                                                      : "answereditor"
                                                  }
                                                  value={
                                                    filteredAllStuAns
                                                      .filter(
                                                        item =>
                                                          parseInt(
                                                            item.answer_id
                                                          ) ===
                                                          parseInt(
                                                            qusAns.english_answer_id
                                                          )
                                                      )
                                                      .reverse()
                                                      .map(item => item.text)
                                                      .find(
                                                        text =>
                                                          text !== undefined
                                                      ) || "" // Find the first non-undefined text value
                                                  }
                                                  disabled={true}
                                                  autoComplete="off"
                                                  autoCorrect="off"
                                                  spellCheck="false"
                                                  //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                  onChange={e =>
                                                    handletext(
                                                      e,
                                                      qusAns.english_answer_id,
                                                      qusAns.english_answer_part_id
                                                    )
                                                  }
                                                  // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                />
                                              </li>
                                            )
                                          }
                                        }
                                      )}
                                  </ul>
                                ) : quspart.english_question_part_answer_type ===
                                  4 ? (
                                  //const stuAnswersarray = stuAnswersJson.length > 0 ? JSON.parse(stuAnswersJson) : [];
                                  <ul className="dg-selector choose-it-question width-controll list-unstyled mb-0">
                                    {parseInt(
                                      quspart.english_question_part_automark
                                    ) === 1 ? (
                                      ""
                                    ) : (
                                      <div className="d-flex justify-content-end">
                                        <span className="badge bg-primary font-size-14 mt-auto mb-2">
                                          Manual Marking
                                        </span>
                                      </div>
                                    )}
                                    {quspart.english_question_answers &&
                                      rearrangeEvenOdd(
                                        quspart.english_question_answers
                                      ).map((qusAns, index1) => {
                                        //   if ((!qusAns.english_answer_text.replace(/&nbsp;/g, '').replace(/`/g, '').replace(/<[^>]*>/g, '')
                                        //     || qusAns.english_answer_text.replace(/&nbsp;/g, '').replace(/`/g, '').replace(/<[^>]*>/g, '').trim() === '')
                                        //   && !(/<img\s+[^>]*>/gi.test(qusAns.english_answer_text))) {
                                        //     return null; // Skip rendering if english_answer_text is null
                                        // }
                                        const cleanText =
                                          qusAns.english_answer_text
                                            .replace(/&nbsp;/g, "")
                                            .replace(/`/g, "")
                                            .replace(/<[^>]*>/g, "")
                                            .trim()

                                        const hasImage = /<img\s+[^>]*>/gi.test(
                                          qusAns.english_answer_text
                                        )

                                        if (!cleanText && !hasImage) {
                                          return null // Skip rendering if english_answer_text is effectively empty and no image is present
                                        }

                                        serialNumber++

                                        let filteredStuAns =
                                          flattenedStuAnswers.filter(
                                            stuAns =>
                                              parseInt(stuAns.part_id) ===
                                                parseInt(
                                                  qusAns.english_answer_part_id
                                                ) &&
                                              parseInt(stuAns.answer_id) ===
                                                parseInt(
                                                  qusAns.english_answer_id
                                                )
                                          ) || []

                                        var status_color =
                                          "selector-general cursor-pointer"
                                        var border_color =
                                          "border-start-secondary"
                                        if (
                                          filteredStuAns.length > 0 &&
                                          parseInt(
                                            quspart.english_question_part_automark
                                          ) === 1
                                        ) {
                                          if (
                                            parseInt(
                                              qusAns.english_answer_is_correct
                                            ) === 1
                                          ) {
                                            status_color = "selector-success"
                                            border_color =
                                              "border-start-success"
                                          } else {
                                            status_color = "selector-wrong "
                                            border_color = "border-start-danger"
                                          }
                                        }
                                        //const sesKeys = quspart.StudentAnsAttempts.map(stuAns => stuAns.part_id); // Extracting session keys
                                        return (
                                          <li
                                            className={
                                              selectedAnswer &&
                                              selectedAnswer ===
                                                qusAns.english_answer_id
                                                ? status_color +
                                                  " active choose e_choose"
                                                : status_color +
                                                  " choose e_choose"
                                            }
                                            key={index1}
                                          >
                                             <div
                                                style={{
                                                  position: "absolute",
                                                  left: "-40px",
                                                  top: "50%",
                                                  transform: "translateY(-50%)",
                                                }}
                                                onClick={e =>
                                                  e.stopPropagation()
                                                }
                                              >
                                                {renderSpeakerToggle(
                                                  "ans-" + qusAns.english_answer_id,
                                                  [qusAns.english_answer_text]
                                                )}
                                               
                                              </div>
                                            <div className="p-2 px-3 font-size-18 dg-serial-badge-wrap">
                                              <span className="dg-serial-badge">
                                                {serialNumber}
                                              </span>
                                            </div>
                                            <div
                                              className={
                                                "p-2 dg-media " +
                                                { border_color }
                                              }
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  qusAns.english_answer_text
                                                    ? qusAns.english_answer_text
                                                    : null,
                                              }}
                                            ></div>
                                          </li>
                                        )
                                      })}
                                  </ul>
                                ) : (
                                  <p className="text-center">No option</p>
                                )}
                                {/* Anse category statement end */}
                              </div>
                            ) : null
                          } else {
                            return index + 1 <
                              ActivityData1.is_current_tab_current_part &&
                              quspart.english_question_part_text ? (
                              <div key={index} className="mt-3">
                                <div className="d-flex gap-2 flex-row w-75">
                                  {renderSpeakerToggle("pt" + index, [
                                    quspart.english_question_part_text,
                                  ])}
                                  {/* <div className="mr-3">{index + 1}</div> */}
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: quspart.english_question_part_text
                                        ? quspart.english_question_part_text
                                            .replace(
                                              /\[\[(.+?)\]\]/g,
                                              function (match, p1) {
                                                return p1.length > 1
                                                  ? `<span class="text-bg-yellow">${p1}</span>`
                                                  : `<span class="text-bg-blue">${p1}</span>`
                                              }
                                            )
                                            .replace(/\{\{/g, "<u>")
                                            .replace(/\}\}/g, "</u>")
                                            .replace(
                                              /\[(\d+)Answer char=\d+\]/g,
                                              ""
                                            )
                                            .replace(/\[Answer char=\d+\]/g, "")
                                        : null,
                                    }}
                                  ></div>
                                </div>
                              </div>
                            ) : null
                          }
                        }
                      )}

                    {/* past question End */}
                    {ActivePartData &&
                      ActivePartData.map((quspart, index) => {
                        const stuAnswersarray =
                          quspart.StudentAnsAttempts.map(stuAns => {
                            try {
                              return JSON.parse(stuAns.student_answer)
                            } catch (error) {
                              console.error("Error parsing JSON:", error)
                              return null // or handle the error in an appropriate way
                            }
                          }) || [] // Extracting session keys

                        // Assuming stuAnswersarray is a nested array
                        const flattenedStuAnswers = [].concat(
                          ...stuAnswersarray
                        )
                        let correct_count = 0
                        let serialNumber = 0
                        let initial_question = 0
                        return (
                          <div
                            key={
                              quspart.english_question_part_id ||
                              quspart.part_id ||
                              index
                            }
                            className="d-flex justify-content-between align-items-flex-start mt-1"
                          >
                            <div className="d-flex gap-2 flex-row ">
                              {/* <div className="mr-3">{ActivityData1.is_first_question}</div> */}
                              {renderSpeakerToggle("ptc" + index, [
                                quspart.english_question_part_text,
                              ])}
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: quspart.english_question_part_text
                                    ? quspart.english_question_part_text
                                        .replace(
                                          /\[\[(.+?)\]\]/g,
                                          function (match, p1) {
                                            return p1.length > 1
                                              ? `<span class="text-bg-yellow">${p1}</span>`
                                              : `<span class="text-bg-blue">${p1}</span>`
                                          }
                                        )
                                        .replace(/\{\{/g, "<u>")
                                        .replace(/\}\}/g, "</u>")
                                        .replace(
                                          /\[(\d+)Answer char=\d+\]/g,
                                          ""
                                        )
                                        .replace(/\[Answer char=\d+\]/g, "")
                                    : null,
                                }}
                              ></div>
                            </div>
                            {/* Anse category statement Star */}
                            {quspart.english_question_part_answer_type === 8 ||
                            quspart.english_question_part_answer_type === 1 ||
                            quspart.english_question_part_answer_type === 7 ? (
                              <ul
                                className="dg-selector width-controll list-unstyled mb-0"
                                style={{
                                  alignSelf: "flex-start",
                                  marginTop: 0,
                                }}
                              >
                                {resultData &&
                                resultData.is_auto_mark &&
                                resultData.is_auto_mark == "0" &&
                                parseInt(
                                  quspart.english_question_part_automark
                                ) <= 0 ? (
                                  <div className="d-flex justify-content-end">
                                    <span className="badge bg-primary font-size-14 mt-auto mb-2">
                                      Manual Marking
                                    </span>
                                  </div>
                                ) : (
                                  ""
                                )}
                                {quspart.english_question_answers &&
                                  quspart.english_question_answers.map(
                                    (qusAns, index1) => {
                                      // Your logic for filtering student answers and determining status_color and border_color
                                      const stuAnswersarray =
                                        quspart.StudentAnsAttempts.map(
                                          stuAns => {
                                            try {
                                              return JSON.parse(
                                                stuAns.student_answer
                                              )
                                            } catch (error) {
                                              console.error(
                                                "Error parsing JSON:",
                                                error
                                              )
                                              return null // or handle the error in an appropriate way
                                            }
                                          }
                                        ) || [] // Extracting session keys
                                      // console.log(stuAnswersarray);
                                      // Assuming stuAnswersarray is a nested array
                                      const flattenedStuAnswers = [].concat(
                                        ...stuAnswersarray
                                      )
                                      let cleanedText =
                                        qusAns.english_answer_text
                                          .replace(/&nbsp;/g, "")
                                          .replace(/`/g, "")
                                          .replace(/<[^>]*>/g, "") || ""
                                      let resultTest = cleanedText
                                        .toLowerCase()
                                        .trim()
                                      let answers = resultTest.split("|") || []
                                      let firstAnswer = answers[0]
                                        ? answers[0].trim()
                                        : "No_Data"
                                      let secondAnswer = answers[1]
                                        ? answers[1].trim()
                                        : "No_Data"

                                      let answersArray =
                                        cleanedText
                                          .split("|")
                                          .map(ans => ans.trim().toLowerCase())
                                          .filter(Boolean) || []

                                      if (
                                        qusAns.english_answer_is_correct === 1
                                      ) {
                                        initial_question++
                                        let filteredStuAns =
                                          flattenedStuAnswers.filter(
                                            stuAns =>
                                              parseInt(stuAns.part_id) ===
                                                parseInt(
                                                  qusAns.english_answer_part_id
                                                ) &&
                                              (stuAns.text
                                                .toLowerCase()
                                                .trim() == resultTest ||
                                                stuAns.text
                                                  .toLowerCase()
                                                  .trim() == firstAnswer ||
                                                stuAns.text
                                                  .toLowerCase()
                                                  .trim() == secondAnswer ||
                                                answersArray.some(
                                                  answer =>
                                                    answer ==
                                                    stuAns.text
                                                      .toLowerCase()
                                                      .trim()
                                                )) &&
                                              parseInt(stuAns.answer_id) ===
                                                parseInt(
                                                  qusAns.english_answer_id
                                                )
                                          ) || []

                                        let filteredAllStuAns =
                                          flattenedStuAnswers.filter(
                                            stuAns =>
                                              parseInt(stuAns.part_id) ===
                                                parseInt(
                                                  qusAns.english_answer_part_id
                                                ) &&
                                              parseInt(stuAns.answer_id) ===
                                                parseInt(
                                                  qusAns.english_answer_id
                                                )
                                          ) || []

                                        return (
                                          <>
                                            <li
                                              key={index1}
                                              className={
                                                parseInt(
                                                  quspart.english_question_part_automark
                                                ) === 1
                                                  ? quspart.StudentAnsAttempts
                                                      .length > 0 &&
                                                    filteredStuAns.length > 0
                                                    ? "input_box small_input_box"
                                                    : "input_box small_input_box"
                                                  : "input_box small_input_box"
                                              }
                                            >
                                              <WritingAnswerInput
                                                key={String(
                                                  qusAns.english_answer_id
                                                )}
                                                ref={handle => {
                                                  const boxKey = String(
                                                    qusAns.english_answer_id
                                                  )
                                                  if (handle)
                                                    writingInputRefs.current[
                                                      boxKey
                                                    ] = handle
                                                  else
                                                    delete writingInputRefs
                                                      .current[boxKey]
                                                }}
                                                answerId={
                                                  qusAns.english_answer_id
                                                }
                                                partId={
                                                  qusAns.english_answer_part_id
                                                }
                                                initialText={
                                                  writingBoxText[
                                                    String(
                                                      qusAns.english_answer_id
                                                    )
                                                  ] ?? ""
                                                }
                                                autoFocus={
                                                  initial_question === 1
                                                }
                                                className={
                                                  quspart.StudentAnsAttempts
                                                    .length > 0 &&
                                                  parseInt(
                                                    quspart.english_question_part_automark
                                                  ) === 1
                                                    ? filteredStuAns.length > 0
                                                      ? "answersuccess initial_question"
                                                      : "answererror initial_question"
                                                    : "answereditor initial_question"
                                                }
                                                disabled={
                                                  writingLocked ||
                                                  quspart.StudentAnsAttempts
                                                    .length >= 2
                                                    ? true
                                                    : filteredStuAns.length > 0
                                                    ? true
                                                    : selectedAnswerText.filter(
                                                        item =>
                                                          parseInt(
                                                            item.answer_id
                                                          ) ===
                                                            parseInt(
                                                              qusAns.english_answer_id
                                                            ) &&
                                                          item.text === "✔"
                                                      ).length > 0 || false
                                                }
                                                onText={text =>
                                                  handleAllowSpacetext(
                                                    { target: { value: text } },
                                                    qusAns.english_answer_id,
                                                    qusAns.english_answer_part_id
                                                  )
                                                }
                                              />
                                              <label className="mb-0 ps-2">
                                                <input
                                                  type="checkbox"
                                                  className="custom_check_box"
                                                  id={
                                                    index1 +
                                                    Math.floor(
                                                      Math.random() * 5
                                                    )
                                                  }
                                                  defaultChecked={true}
                                                  disabled={
                                                    writingLocked ||
                                                    quspart.StudentAnsAttempts
                                                      .length >= 2
                                                  }
                                                  checked={
                                                    selectedAnswerText.filter(
                                                      item =>
                                                        parseInt(
                                                          item.answer_id
                                                        ) ===
                                                          parseInt(
                                                            qusAns.english_answer_id
                                                          ) && item.text === "✔"
                                                    ).length > 0 || false
                                                  }
                                                  onChange={e => {
                                                    // const checkbox = e.target;
                                                    //   const input = checkbox.parentElement.previousElementSibling.querySelector('input[type="text"]');
                                                    //   if (input) {
                                                    //     input.disabled = checkbox.checked;
                                                    //   }
                                                    const value = e.target
                                                      .checked
                                                      ? "✔"
                                                      : ""
                                                    //console.log(value);
                                                    handletextCheck(
                                                      value,
                                                      qusAns.english_answer_id,
                                                      qusAns.english_answer_part_id
                                                    )
                                                  }}
                                                />
                                              </label>
                                            </li>

                                            {!writingLocked &&
                                            quspart.StudentAnsAttempts
                                              .length === 1 &&
                                            parseInt(
                                              quspart.english_question_part_automark
                                            ) === 1 ? (
                                              filteredStuAns.length >
                                              0 ? null : (
                                                <div className="d-flex justify-content-end">
                                                  <span className="text-danger font-size-14 mt-auto mb-2">
                                                    Try again with a different
                                                    answer.
                                                  </span>
                                                </div>
                                              )
                                            ) : null}
                                            {nextQuestion &&
                                            SummryView === false &&
                                            qusAns &&
                                            (!ActivityData1?.is_show_all_parts ||
                                              index ===
                                                ActivePartData.length -
                                                  1) ? (
                                              <div className="d-flex justify-content-start">
                                                <span
                                                  className="font-size-15 mt-1 text-danger fw-bold skip-button"
                                                  onClick={() =>
                                                    handleAllowSpacetext(
                                                      ".",
                                                      qusAns.english_answer_id,
                                                      qusAns.english_answer_part_id,
                                                      1
                                                    )
                                                  }
                                                >
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    version="1.1"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    width={20}
                                                    height={20}
                                                    x={0}
                                                    y={0}
                                                    viewBox="0 0 24 25"
                                                    style={{
                                                      enableBackground:
                                                        "new 0 0 512 512",
                                                    }}
                                                    xmlSpace="preserve"
                                                    className=""
                                                  >
                                                    <g>
                                                      <path
                                                        fill="#ef0000"
                                                        fillRule="evenodd"
                                                        d="M9.676 8.205c0-2.256 2.568-3.553 4.383-2.212l6.822 5.037a2.75 2.75 0 0 1 0 4.424l-6.822 5.037c-1.815 1.34-4.383.044-4.383-2.212v-.035l-3.042 2.247c-1.816 1.34-4.384.044-4.384-2.212V8.205c0-2.256 2.568-3.553 4.384-2.212l3.042 2.246zm1.5 1.142 2.279 1.683a2.75 2.75 0 0 1 0 4.424l-2.28 1.683v1.142c0 1.025 1.168 1.615 1.993 1.005l6.821-5.036a1.25 1.25 0 0 0 0-2.012L13.17 7.2c-.826-.61-1.993-.02-1.993 1.005zM5.743 7.2c-.826-.61-1.993-.02-1.993 1.005V18.28c0 1.025 1.167 1.615 1.993 1.005l6.82-5.036a1.25 1.25 0 0 0 0-2.012z"
                                                        clipRule="evenodd"
                                                        opacity={1}
                                                        data-original="#000000"
                                                        className=""
                                                      />
                                                    </g>
                                                  </svg>{" "}
                                                  Skip Question
                                                </span>
                                              </div>
                                            ) : null}
                                          </>
                                        )
                                      }
                                    }
                                  )}
                              </ul>
                            ) : quspart.english_question_part_answer_type ===
                              4 ? (
                              //const stuAnswersarray = stuAnswersJson.length > 0 ? JSON.parse(stuAnswersJson) : [];
                              <ul className="dg-selector choose-it-question width-controll list-unstyled mb-0">
                                {resultData &&
                                resultData.is_auto_mark &&
                                resultData.is_auto_mark == "0" &&
                                parseInt(
                                  quspart.english_question_part_automark
                                ) <= 1 ? (
                                  <div className="d-flex justify-content-end">
                                    <span className="badge bg-primary font-size-14 mt-auto mb-2">
                                      Manual Marking
                                    </span>
                                  </div>
                                ) : (
                                  ""
                                )}
                                {quspart.english_question_answers &&
                                  rearrangeEvenOdd(
                                    quspart.english_question_answers
                                  ).map((qusAns, index1) => {
                                    //   if ((!qusAns.english_answer_text.replace(/&nbsp;/g, '').replace(/`/g, '').replace(/<[^>]*>/g, '')
                                    //     || qusAns.english_answer_text.replace(/&nbsp;/g, '').replace(/`/g, '').replace(/<[^>]*>/g, '').trim() === '')
                                    //   && !(/<img\s+[^>]*>/gi.test(qusAns.english_answer_text))) {
                                    //     return null; // Skip rendering if english_answer_text is null
                                    // }

                                    const cleanText = qusAns.english_answer_text
                                      .replace(/&nbsp;/g, "")
                                      .replace(/`/g, "")
                                      .replace(/<[^>]*>/g, "")
                                      .trim()

                                    const hasImage = /<img\s+[^>]*>/gi.test(
                                      qusAns.english_answer_text
                                    )

                                    if (!cleanText && !hasImage) {
                                      return null // Skip rendering if english_answer_text is effectively empty and no image is present
                                    }
                                    serialNumber++
                                    let filteredStuAns =
                                      flattenedStuAnswers.filter(
                                        stuAns =>
                                          parseInt(stuAns.part_id) ===
                                            parseInt(
                                              qusAns.english_answer_part_id
                                            ) &&
                                          parseInt(stuAns.answer_id) ===
                                            parseInt(qusAns.english_answer_id)
                                      ) || []

                                    var status_color =
                                      "selector-general cursor-pointer"
                                    var border_color = "border-start-secondary"
                                    if (filteredStuAns.length > 0) {
                                      if (
                                        parseInt(
                                          qusAns.english_answer_is_correct
                                        ) === 1
                                      ) {
                                        status_color = "selector-success"
                                        border_color = "border-start-success"
                                        correct_count += 1
                                      } else {
                                        status_color = "selector-wrong "
                                        border_color = "border-start-danger"
                                      }
                                    }
                                    //const sesKeys = quspart.StudentAnsAttempts.map(stuAns => stuAns.part_id); // Extracting session keys
                                    return (
                                      <>
                                        <li
                                          className={
                                            selectedAnswer &&
                                            selectedAnswer ===
                                              qusAns.english_answer_id
                                              ? status_color +
                                                " active choose e_choose"
                                              : status_color +
                                                " choose e_choose"
                                          }
                                          key={index1}
                                          onClick={() =>
                                            selectedAnsOption(qusAns)
                                          }
                                        >
                                          <div
                                            style={{
                                              position: "absolute",
                                              left: "-40px",
                                              top: "50%",
                                              transform: "translateY(-50%)",
                                            }}
                                            onClick={e =>
                                              e.stopPropagation()
                                            }
                                          >
                                            {renderSpeakerToggle(
                                              "ans-" + qusAns.english_answer_id,
                                              [qusAns.english_answer_text]
                                            )}
                                            
                                          </div>
                                          <div className="p-2 px-3 font-size-18 dg-serial-badge-wrap">
                                            <span className="dg-serial-badge">
                                              {serialNumber}
                                            </span>
                                          </div>
                                          <div
                                            className={
                                              "p-2 dg-media " + { border_color }
                                            }
                                            dangerouslySetInnerHTML={{
                                              __html: qusAns.english_answer_text
                                                ? qusAns.english_answer_text
                                                : null,
                                            }}
                                          ></div>
                                        </li>
                                        {index1 + 1 >=
                                          quspart.english_question_answers
                                            .length &&
                                        quspart.StudentAnsAttempts.length ===
                                          1 &&
                                        parseInt(
                                          quspart.english_question_part_automark
                                        ) === 1 ? (
                                          correct_count > 0 ? null : (
                                            <div className="d-flex justify-content-end">
                                              <span className="text-danger font-size-14 mt-auto mb-2">
                                                Try again with a different
                                                answer.
                                              </span>
                                            </div>
                                          )
                                        ) : null}
                                        {nextQuestion &&
                                        SummryView === false &&
                                        index1 + 1 >=
                                          quspart.english_question_answers
                                            .length &&
                                        (!ActivityData1?.is_show_all_parts ||
                                          index ===
                                            ActivePartData.length - 1) ? (
                                          <div className="d-flex justify-content-start">
                                            <span
                                              className="font-size-15 mt-1 text-danger fw-bold skip-button"
                                              onClick={() =>
                                                selectedAnsOption(qusAns, 1)
                                              }
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                version="1.1"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                width={20}
                                                height={20}
                                                x={0}
                                                y={0}
                                                viewBox="0 0 24 25"
                                                style={{
                                                  enableBackground:
                                                    "new 0 0 512 512",
                                                }}
                                                xmlSpace="preserve"
                                                className=""
                                              >
                                                <g>
                                                  <path
                                                    fill="#ef0000"
                                                    fillRule="evenodd"
                                                    d="M9.676 8.205c0-2.256 2.568-3.553 4.383-2.212l6.822 5.037a2.75 2.75 0 0 1 0 4.424l-6.822 5.037c-1.815 1.34-4.383.044-4.383-2.212v-.035l-3.042 2.247c-1.816 1.34-4.384.044-4.384-2.212V8.205c0-2.256 2.568-3.553 4.384-2.212l3.042 2.246zm1.5 1.142 2.279 1.683a2.75 2.75 0 0 1 0 4.424l-2.28 1.683v1.142c0 1.025 1.168 1.615 1.993 1.005l6.821-5.036a1.25 1.25 0 0 0 0-2.012L13.17 7.2c-.826-.61-1.993-.02-1.993 1.005zM5.743 7.2c-.826-.61-1.993-.02-1.993 1.005V18.28c0 1.025 1.167 1.615 1.993 1.005l6.82-5.036a1.25 1.25 0 0 0 0-2.012z"
                                                    clipRule="evenodd"
                                                    opacity={1}
                                                    data-original="#000000"
                                                    className=""
                                                  />
                                                </g>
                                              </svg>{" "}
                                              Skip Question
                                            </span>
                                          </div>
                                        ) : null}
                                      </>
                                    )
                                  })}
                              </ul>
                            ) : (
                              <p className="text-center">No option</p>
                            )}
                            {/* Anse category statement end */}
                          </div>
                        )
                      })}

                    <div>
                      {resultData && resultData.is_auto_mark == "0" ? (
                        ""
                      ) : nextQuestion &&
                        !writingLocked &&
                        parseInt(IsSkipButton) !== 1 ? (
                        <div className="submit-actions-fixed">
                          <Button
                            type="button"
                            className="save-progress-btn btn btn-danger cs-btn-danger"
                            disabled={IsSubmited}
                            onKeyDown={e => {
                              if (e.key === "Enter") e.stopPropagation()
                            }}
                            onClick={handleSaveAndExit}
                          >
                            Save and Exit
                          </Button>
                          {selectedAnswerText &&
                          selectedAnswerText.length > 0 ? (
                            <Button
                              type="button"
                              className="submit-btn-question btn btn-danger cs-btn-danger"
                              disabled={IsSubmited}
                              onClick={submitReadingWriting}
                            >
                              Submit
                            </Button>
                          ) : null}
                        </div>
                      ) : null}
                    </div>

                    {!ActivityData1?.is_show_all_parts &&
                      ActivityData.english_question_parts &&
                      ActivityData.english_question_parts.map(
                        (quspart, index2) => {
                          if (
                            quspart.english_question_answers &&
                            quspart.english_question_answers.length > 0 &&
                            quspart.english_question_answers[0]
                              .english_answer_text &&
                            quspart.english_question_answers[0]
                              .english_answer_text != ""
                          ) {
                            let serialNumber = 0
                            return index2 + 1 >
                              ActivityData1.is_current_tab_current_part &&
                              quspart.english_question_part_text ? (
                              <div
                                key={index2}
                                className="d-flex justify-content-between align-items-flex-start mt-2"
                              >
                                <div className="d-flex gap-2 flex-row ">
                                  {renderSpeakerToggle("ptc" + index2, [
                                    quspart.english_question_part_text,
                                  ])}
                                  {/* <div className="mr-3">{index + 1}</div> */}
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: quspart.english_question_part_text
                                        ? quspart.english_question_part_text
                                            .replace(
                                              /\[\[(.+?)\]\]/g,
                                              function (match, p1) {
                                                return p1.length > 1
                                                  ? `<span class="text-bg-yellow">${p1}</span>`
                                                  : `<span class="text-bg-blue">${p1}</span>`
                                              }
                                            )
                                            .replace(/\{\{/g, "<u>")
                                            .replace(/\}\}/g, "</u>")
                                            .replace(
                                              /\[(\d+)Answer char=\d+\]/g,
                                              ""
                                            )
                                            .replace(/\[Answer char=\d+\]/g, "")
                                        : null,
                                    }}
                                  ></div>
                                </div>
                                {/* Anse category statement Star */}
                                {quspart.english_question_part_answer_type ===
                                  8 ||
                                quspart.english_question_part_answer_type ===
                                  1 ||
                                quspart.english_question_part_answer_type ===
                                  7 ? (
                                  <ul
                                    className="dg-selector width-controll list-unstyled mb-0"
                                    style={{
                                      alignSelf: "flex-start",
                                      marginTop: 0,
                                    }}
                                  >
                                    {" "}
                                    {parseInt(
                                      quspart.english_question_part_automark
                                    ) === 1 ? (
                                      ""
                                    ) : (
                                      <div className="d-flex justify-content-end">
                                        <span className="badge bg-primary font-size-14 mt-auto mb-2">
                                          Manual Marking
                                        </span>
                                      </div>
                                    )}
                                    {quspart.english_question_answers &&
                                      quspart.english_question_answers.map(
                                        (qusAns, index1) => {
                                          return (
                                            <li
                                              key={index1}
                                              className={
                                                "input_box small_input_box"
                                              }
                                            >
                                              <input
                                                id={
                                                  index1 +
                                                  Math.floor(Math.random() * 5)
                                                }
                                                type="text"
                                                className={"answereditor"}
                                                value={
                                                  "" // Find the first non-undefined text value
                                                }
                                                disabled={true}
                                                autoComplete="off"
                                                autoCorrect="off"
                                                spellCheck="false"
                                                //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                //  onChange={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                              />
                                            </li>
                                          )
                                        }
                                      )}
                                  </ul>
                                ) : quspart.english_question_part_answer_type ===
                                  4 ? (
                                  //const stuAnswersarray = stuAnswersJson.length > 0 ? JSON.parse(stuAnswersJson) : [];
                                  <ul className="dg-selector choose-it-question width-controll list-unstyled mb-0">
                                    {parseInt(
                                      quspart.english_question_part_automark
                                    ) === 1 ? (
                                      ""
                                    ) : (
                                      <div className="d-flex justify-content-end">
                                        <span className="badge bg-primary font-size-14 mt-auto mb-2">
                                          Manual Marking
                                        </span>
                                      </div>
                                    )}
                                    {quspart.english_question_answers &&
                                      rearrangeEvenOdd(
                                        quspart.english_question_answers
                                      ).map((qusAns, index1) => {
                                        //   if ((!qusAns.english_answer_text.replace(/&nbsp;/g, '').replace(/`/g, '').replace(/<[^>]*>/g, '')
                                        //     || qusAns.english_answer_text.replace(/&nbsp;/g, '').replace(/`/g, '').replace(/<[^>]*>/g, '').trim() === '')
                                        //   && !(/<img\s+[^>]*>/gi.test(qusAns.english_answer_text))) {
                                        //     return null; // Skip rendering if english_answer_text is null
                                        // }

                                        serialNumber++

                                        var status_color =
                                          "selector-general cursor-pointer"
                                        var border_color =
                                          "border-start-secondary"

                                        //const sesKeys = quspart.StudentAnsAttempts.map(stuAns => stuAns.part_id); // Extracting session keys
                                        return (
                                          <li
                                            className={
                                              status_color + " choose e_choose"
                                            }
                                            key={index1}
                                          >
                                             <div
                                                style={{
                                                  position: "absolute",
                                                  left: "-40px",
                                                  top: "50%",
                                                  transform: "translateY(-50%)",
                                                }}
                                                onClick={e =>
                                                  e.stopPropagation()
                                                }
                                              >
                                                {renderSpeakerToggle(
                                                  "ans-" + qusAns.english_answer_id,
                                                  [qusAns.english_answer_text]
                                                )}
                                               
                                              </div>
                                            <div className="p-2 px-3 font-size-18 dg-serial-badge-wrap">
                                              <span className="dg-serial-badge">
                                                {serialNumber}
                                              </span>
                                            </div>
                                            <div
                                              className={
                                                "p-2 dg-media " +
                                                { border_color }
                                              }
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  qusAns.english_answer_text
                                                    ? qusAns.english_answer_text
                                                    : null,
                                              }}
                                            ></div>
                                          </li>
                                        )
                                      })}
                                  </ul>
                                ) : (
                                  <p className="text-center">No option</p>
                                )}
                                {/* Anse category statement end */}
                              </div>
                            ) : null
                          } else {
                            return index2 + 1 >
                              ActivityData1.is_current_tab_current_part &&
                              quspart.english_question_part_text ? (
                              <div key={index2} className="mt-3">
                                <div className="d-flex gap-2 flex-row w-75">
                                  {quspart?.english_question_part_text &&
                                    renderSpeakerToggle("pt" + index2, [
                                      quspart.english_question_part_text,
                                    ])}
                                  {/* <div className="mr-3">{index + 1}</div> */}
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: quspart.english_question_part_text
                                        ? quspart.english_question_part_text
                                            .replace(
                                              /\[\[(.+?)\]\]/g,
                                              function (match, p1) {
                                                return p1.length > 1
                                                  ? `<span class="text-bg-yellow">${p1}</span>`
                                                  : `<span class="text-bg-blue">${p1}</span>`
                                              }
                                            )
                                            .replace(/\{\{/g, "<u>")
                                            .replace(/\}\}/g, "</u>")
                                            .replace(
                                              /\[(\d+)Answer char=\d+\]/g,
                                              ""
                                            )
                                            .replace(/\[Answer char=\d+\]/g, "")
                                        : null,
                                    }}
                                  ></div>
                                </div>
                              </div>
                            ) : null
                          }
                        }
                      )}
                  </li>
                </ul>
                {renderNextButton()}

                {!nextQuestion || SummryView === true ? (
                  <div
                    className={`navigator-wrapper position-relative ${
                      SummryView ? "" : "pb-100"
                    } mt-4`}
                  >
                    <div
                      style={getOverlayCardStyle()}
                      className={`nv-feedback-card feedback-${keyStage} ${
                        ActivePartData?.some(
                          quspart =>
                            parseInt(quspart.english_question_part_automark) ===
                              1 && quspart.StudentQusSkip?.length === 0
                        )
                          ? resultData && parseInt(resultData.is_correct) === 1
                            ? parseInt(resultData.attempCount) >= 2
                              ? "nv-feedback-card--warn"
                              : "nv-feedback-card--ok"
                            : resultData && !resultData.studentAnswer
                            ? "nv-feedback-card--skip"
                            : "nv-feedback-card--err"
                          : "nv-feedback-card--warn"
                      }`}
                    >
                      <div className="nv-feedback-card__main">
                        <div className="nv-feedback-card__icon">
                          {renderFeedbackIcon(resultData, ActivePartData)}
                        </div>

                        <div className="nv-feedback-card__text">
                          <div className="nv-feedback-card__title-row">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                flexWrap: "wrap",
                              }}
                            >
                              <div className="nv-feedback-card__status-group">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <span
                                    className={`nv-feedback-card__title feedback-title-${keyStage} ${
                                      ActivePartData?.some(
                                        quspart =>
                                          parseInt(
                                            quspart.english_question_part_automark
                                          ) === 1 &&
                                          quspart.StudentQusSkip?.length === 0
                                      )
                                        ? resultData &&
                                          parseInt(resultData.is_correct) === 1
                                          ? parseInt(resultData.attempCount) >=
                                            2
                                            ? "nv-feedback-card__title--warn"
                                            : "nv-feedback-card__title--ok"
                                          : resultData &&
                                            !resultData.studentAnswer
                                          ? "nv-feedback-card__title--skip"
                                          : "nv-feedback-card__title--err"
                                        : "nv-feedback-card__title--warn"
                                    }`}
                                  >
                                    {ActivePartData?.some(
                                      quspart =>
                                        parseInt(
                                          quspart.english_question_part_automark
                                        ) === 1 &&
                                        quspart.StudentQusSkip?.length === 0
                                    )
                                      ? resultData &&
                                        parseInt(resultData.is_correct) === 1
                                        ? "Correct!"
                                        : resultData &&
                                          !resultData.studentAnswer
                                        ? "Skipped!"
                                        : "Incorrect"
                                      : "Manual Marking"}
                                  </span>

                                  <ResultSpeakButton
                                    id={`result-${ActivityData?.english_question_id}`}
                                    activeId={activeId}
                                    speak={speak}
                                    resultData={resultData}
                                    parts={
                                      ActivePartData?.some(
                                        quspart =>
                                          parseInt(
                                            quspart.english_question_part_automark
                                          ) === 1 &&
                                          quspart.StudentQusSkip?.length === 0
                                      )
                                        ? [
                                            resultData &&
                                            parseInt(resultData.is_correct) ===
                                              1
                                              ? "Correct! Great job!"
                                              : resultData &&
                                                !resultData.studentAnswer
                                              ? "Skipped! Give it a try!"
                                              : "Incorrect. Keep practising!",
                                            resultData?.studentAnswer
                                              ? `You answered: ${resultData.studentAnswer}`
                                              : null,
                                            ...(resultData?.is_correct !== 3 &&
                                            !ActivityData1?.is_show_all_parts
                                              ? resultData?.explanation
                                                ? [`${resultData.explanation}`]
                                                : ActivePartData?.flatMap(
                                                    part =>
                                                      part.english_question_answers
                                                        ?.filter(
                                                          ans =>
                                                            parseInt(
                                                              ans.english_answer_is_correct
                                                            ) === 1
                                                        )
                                                        .map(
                                                          ans =>
                                                            `Correct answer: ${ans.english_answer_text}`
                                                        )
                                                  )
                                              : resultData?.is_correct === 3
                                              ? [
                                                  `Please attempt the skipped question`,
                                                ]
                                              : []),
                                          ]
                                        : [
                                            "Manual Marking. Please wait for your teacher to review your answer.",
                                            resultData?.studentAnswer
                                              ? `You answered: ${resultData.studentAnswer}`
                                              : null,
                                          ]
                                    }
                                  />
                                </div>
                                <p
                                  className={`nv-feedback-card__subtitle feedback-subtitle-${keyStage}`}
                                >
                                  {ActivePartData?.some(
                                    quspart =>
                                      parseInt(
                                        quspart.english_question_part_automark
                                      ) === 1 &&
                                      quspart.StudentQusSkip?.length === 0
                                  )
                                    ? resultData &&
                                      parseInt(resultData.is_correct) === 1
                                      ? "Great job!"
                                      : resultData && !resultData.studentAnswer
                                      ? "Give it a try!"
                                      : "Keep practising!"
                                    : "Please wait for your teacher to review your answer."}
                                </p>
                              </div>

                              <div className="nv-feedback-card__inline-stats">
                                <div className="nv-feedback-card__stat-item">
                                  <span className="nv-feedback-card__stat-label">
                                    ⏱ SUGGESTED TIME
                                  </span>
                                  <span className="nv-feedback-card__stat-value">
                                    {ActivityData.english_question_time_needed}
                                  </span>
                                </div>
                                <div className="nv-feedback-card__stat-sep" />
                                <div className="nv-feedback-card__stat-item">
                                  <span className="nv-feedback-card__stat-label">
                                    🎯 GOT IT RIGHT
                                  </span>
                                  <span className="nv-feedback-card__stat-value">
                                    {resultData
                                      ? parseInt(
                                          resultData.accuracyOfOtherStudents
                                        )
                                      : 0}
                                    %
                                  </span>
                                </div>
                              </div>

                              {resultData && resultData.studentAnswer ? (
                                <div
                                  className={`nv-answer-box answer-box-${keyStage} ${
                                    parseInt(resultData.is_correct) === 1
                                      ? parseInt(resultData.attempCount) >= 2
                                        ? "nv-answer-box--warn"
                                        : "nv-answer-box--ok"
                                      : "nv-answer-box--err"
                                  }`}
                                >
                                  <div className="nv-answer-box__col nv-answer-box__col--answer">
                                    <span className="nv-answer-box__label">
                                      You answered:
                                    </span>
                                    <p
                                      className={`nv-answer-box__value answer-value-${keyStage}`}
                                    >
                                      {resultData.studentAnswer}
                                    </p>
                                  </div>
                                  {ActivePartData?.some(
                                    quspart =>
                                      parseInt(
                                        quspart.english_question_part_automark
                                      ) === 1 &&
                                      quspart.StudentQusSkip?.length === 0
                                  ) &&
                                  resultData.explanation &&
                                  !ActivityData1?.is_show_all_parts ? (
                                    <>
                                      <div className="nv-answer-box__divider" />
                                      <div className="nv-answer-box__col nv-answer-box__col--explanation">
                                        <span className="nv-answer-box__label">
                                          Explanation:
                                        </span>
                                        <div
                                          className={`nv-answer-box__text answer-text-${keyStage}`}
                                          dangerouslySetInnerHTML={{
                                            __html: resultData.explanation,
                                          }}
                                        />
                                      </div>
                                    </>
                                  ) : null}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>

                        <div
                          className="nv-feedback-card__actions"
                          style={{ alignSelf: "flex-start", justifyContent: "flex-end", alignItems: "flex-end" }}
                          ref={navigatorRef}
                        >
                          {/* Coin badge */}
                          <div className="nv-feedback-card__coin-badge">
                            <img width={32} src={awicon} alt="coins" />
                            <div className="nv-feedback-card__coin-text">
                              <span className="nv-feedback-card__coin-num">
                                {resultData &&
                                parseInt(resultData.is_correct) === 1
                                  ? "+"
                                  : ""}
                                {resultData && resultData?.points && parseInt(resultData.is_correct) !== 3 ? resultData.points : 0}
                              </span>
                              <span className="nv-feedback-card__coin-lbl">
                                coins
                              </span>
                            </div>
                          </div>

                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                            {resultData &&
                            resultData.LastQuestion &&
                            parseInt(SkipQuestionCount) > 0 ? (
                              <>
                                <Button
                                  className="btn btn-danger cs-btn-danger mt-1 nv-feedback-card__btn"
                                  onClick={() => trySkipQuestion()}
                                >
                                  Attempt {SkipQuestionCount} skipped questions
                                </Button>
                                <p className="font-size-16 d-flex align-items-center gap-2" style={{ margin: 0 }}>
                                  OR
                                </p>
                              </>
                            ) : null}

                            {resultData ? (
                              !resultData.LastQuestion ? (
                                <Button
                                  className="next-btn-question btn btn-danger cs-btn-danger mt-1 nv-feedback-card__btn"
                                  onClick={() => {
                                    //window.location.reload();
                                    triggerFunction()
                                    setnextQuestion(false)
                                    setActivePartData([])
                                    setIsSubmited(false)
                                    setresultData(null)
                                  }}
                                >
                                  Next Question&nbsp;
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-fast-forward-icon lucide-fast-forward"
                                  >
                                    <path d="M12 6a2 2 0 0 1 3.414-1.414l6 6a2 2 0 0 1 0 2.828l-6 6A2 2 0 0 1 12 18z" />
                                    <path d="M2 6a2 2 0 0 1 3.414-1.414l6 6a2 2 0 0 1 0 2.828l-6 6A2 2 0 0 1 2 18z" />
                                  </svg>
                                </Button>
                              ) : (
                                <Button
                                  className="summary-btn-question btn btn-danger cs-btn-danger mt-1 nv-feedback-card__btn"
                                  onClick={() => assessementSummary()}
                                >
                                  Finish
                                </Button>
                              )
                            ) : null}
                          </div>
                        </div>
                      </div>

                      {resultData &&
                      resultData.attempCount &&
                      parseInt(resultData.attempCount) >= 2 ? (
                        <span
                          className="font-size-15 text-dark fw-bold"
                          onClick={tog_standard1}
                          style={{
                            fontStyle: "italic",
                            textDecoration: "underline",
                            cursor: "pointer",
                            display: "block",
                            textAlign: "center",
                          }}
                        >
                          It was marked incorrectly
                        </span>
                      ) : null}
                    </div>
                  </div>
                ) : null}
              </div>
            )
          } else {
            return (
              <div
                style={getOverlayCardStyle()}
                className={`hw-list mt-2 ${
                  localStorage.getItem("is_fontsize") == 1
                    ? "stu-custom-font-size"
                    : ""
                }`}
              >
                <div className="d-flex justify-content-end">
                  {renderDarkModeToggle()}
                  {renderOverlayToggle()}
                </div>
                <div className="navigator-wrapper position-relative pb-3 mt-4">
                  {/* <div className="nv-dg-smile">
                          <img width={400} src={dsmile} alt="" /> 
                        </div> */}
                  <div className="nv-dg-smile-avatar">
                    {/* <img width={400} src={dsmile} alt="" /> */}
                    <div className="avatar-wrapper">
                      {/* student avatar start */}
                      <div className="super-profile_wrapper img-consolidate-display">
                        <div className="content-left">
                          <div className="super-avatar-display">
                            {/* <Slide
                                  autoplay={false}
                                  infinite={false}
                                  onStartChange={togAvatarGendar}
                                  {...properties}
                                > */}
                            {/* male functionality start */}
                            {!AvatarGendar ? (
                              <div className="each-slide-effect cursor-pointer">
                                <div className="pirate-media male position-relative">
                                  <div className="avatar-display text-center position-relative">
                                    <div className="avatar-default">
                                      <img
                                        width={450}
                                        className=""
                                        src={piratemale}
                                        alt=""
                                      />
                                    </div>
                                    <div className="avatar-attachments">
                                      {maleAvatarHeadData &&
                                      maleAvatarHeadData != "" &&
                                      maleAvatarHeadData.image ? (
                                        <div className="head-float position-absolute">
                                          <img
                                            className=""
                                            src={modifyUrl(
                                              maleAvatarHeadData.image
                                            )}
                                            alt=""
                                          />
                                        </div>
                                      ) : null}

                                      {maleAvatarArmourData &&
                                      maleAvatarArmourData != "" &&
                                      maleAvatarArmourData.image ? (
                                        <div className="dress-float position-absolute">
                                          <img
                                            className=""
                                            src={maleAvatarArmourData.image}
                                            alt=""
                                          />
                                        </div>
                                      ) : null}

                                      {maleAvatarPetData &&
                                      maleAvatarPetData != "" &&
                                      maleAvatarPetData.image ? (
                                        <div className="companion-float position-absolute">
                                          <img
                                            className=""
                                            src={maleAvatarPetData.image}
                                            alt=""
                                          />
                                        </div>
                                      ) : null}

                                      {maleAvatarHandData &&
                                      maleAvatarHandData != "" &&
                                      maleAvatarHandData.image ? (
                                        <>
                                          <div className="hand-float position-absolute">
                                            <img
                                              className=""
                                              src={maleAvatarHandData.image}
                                              alt=""
                                            />
                                          </div>

                                          <div className="hand-float-revert position-absolute">
                                            <img
                                              className=""
                                              src={maleAvatarHandData.image}
                                              alt=""
                                            />
                                          </div>
                                        </>
                                      ) : null}

                                      {maleAvatarWeaponData &&
                                      maleAvatarWeaponData != "" &&
                                      maleAvatarWeaponData.image ? (
                                        <div className="weapon-float position-absolute">
                                          <img
                                            className=""
                                            src={maleAvatarWeaponData.image}
                                            alt=""
                                          />
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className="each-slide-effect cursor-pointer">
                                <div className="pirate-media female position-relative">
                                  <div className="avatar-display text-center position-relative">
                                    <div className="avatar-default">
                                      <img
                                        width={450}
                                        className=""
                                        src={piratefemale}
                                        alt=""
                                      />
                                    </div>
                                    <div className="avatar-attachments">
                                      {femaleAvatarHeadData &&
                                      femaleAvatarHeadData != "" &&
                                      femaleAvatarHeadData.image ? (
                                        <div className="head-float female-hd position-absolute">
                                          <img
                                            className=""
                                            src={modifyUrl(
                                              femaleAvatarHeadData.image
                                            )}
                                            alt=""
                                          />
                                        </div>
                                      ) : null}

                                      {femaleAvatarArmourData &&
                                      femaleAvatarArmourData != "" &&
                                      femaleAvatarArmourData.image ? (
                                        <div className="dress-float position-absolute">
                                          <img
                                            className=""
                                            src={femaleAvatarArmourData.image}
                                            alt=""
                                          />
                                        </div>
                                      ) : null}

                                      {femaleAvatarPetData &&
                                      femaleAvatarPetData != "" &&
                                      femaleAvatarPetData.image ? (
                                        <div className="companion-float position-absolute">
                                          <img
                                            className=""
                                            src={femaleAvatarPetData.image}
                                            alt=""
                                          />
                                        </div>
                                      ) : null}

                                      {femaleAvatarHandData &&
                                      femaleAvatarHandData != "" &&
                                      femaleAvatarHandData.image ? (
                                        <>
                                          <div className="hand-float position-absolute">
                                            <img
                                              className=""
                                              src={femaleAvatarHandData.image}
                                              alt=""
                                            />
                                          </div>
                                          <div className="hand-float-revert position-absolute">
                                            <img
                                              className=""
                                              src={femaleAvatarHandData.image}
                                              alt=""
                                            />
                                          </div>
                                        </>
                                      ) : null}

                                      {femaleAvatarWeaponData &&
                                      femaleAvatarWeaponData != "" &&
                                      femaleAvatarWeaponData.image ? (
                                        <div className="weapon-float position-absolute">
                                          <img
                                            className=""
                                            src={femaleAvatarWeaponData.image}
                                            alt=""
                                          />
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Female functionality end */}
                            {/* </Slide> */}
                          </div>
                        </div>
                      </div>

                      {/* student avatar end */}
                    </div>
                  </div>
                  <div className="navigator-nxt" ref={navigatorRef}>
                    <p className="opacity-75">No questions are available.</p>
                    {parseInt(SkipQuestionCount) > 0 ? (
                      <>
                        <div className="p-3">
                          <Button
                            className="btn btn-danger cs-btn-danger mt-1 nv-feedback-card__btn"
                            onClick={() => trySkipQuestion()}
                          >
                            Attempt {SkipQuestionCount} skipped questions
                          </Button>
                        </div>
                        <p className="font-size-16 d-flex align-items-center gap-2">
                          OR
                        </p>
                      </>
                    ) : null}
                    {/* <p className="opacity-75">{parseInt(resultData.accuracyOfOtherStudents)}% OF STUDENTS GOT IT RIGHT</p> */}

                    <Button
                      className="summary-btn-question btn btn-danger cs-btn-danger mt-1"
                      onClick={() => finishQuestion()}
                    >
                      Finish
                    </Button>
                  </div>
                </div>
              </div>
            )
          }
        }
      })
    ) : ActivityData1 &&
      ActivityData1.fk_sub_id &&
      parseInt(ActivityData1.fk_sub_id) === 2 ? (
      ActivityData1.question.map((ActivityData, index) => {
        if (index === 0) {
          if (
            ActivityData &&
            ActivityData.question_parts &&
            ActivityData.question_parts.length > 0
          ) {
            return (
              <div
                style={getOverlayCardStyle()}
                className={`hw-list mt-2 maths-subject ${
                  localStorage.getItem("is_fontsize") == 1
                    ? "stu-custom-font-size"
                    : ""
                } ${nextQuestion && !SummryView ? "" : ""}`}
              >
                {/* <ToastContainer autoClose={3000} /> */}
                <Modal isOpen={modal_standard1} toggle={tog_standard1}>
                  <ModalHeader toggle={tog_standard1}></ModalHeader>
                  <ModalBody>
                    <p className="text-center fw-bold text-dark mb-0 font-size-18">
                      Report this question to your tutor as being incorrectly
                      marked?
                    </p>
                  </ModalBody>
                  <ModalFooter className="justify-content-center">
                    <Button
                      className="btn-cst-success-md"
                      disabled={isFlagReport}
                      onClick={() => {
                        submitQuestionReport()
                      }}
                    >
                      Yes
                    </Button>
                    <Button
                      className="btn-cst-danger-md"
                      onClick={() => {
                        tog_standard1()
                      }}
                    >
                      No
                    </Button>
                  </ModalFooter>
                </Modal>

                <Modal isOpen={modal_standard} toggle={tog_standard}>
                  <Form
                    className="mt-4"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    action="#"
                  >
                    <ModalHeader toggle={tog_standard}>
                      Flag this Question
                    </ModalHeader>
                    <ModalBody>
                      <div className="flex-grow-1 mb-3 cs-rsm">
                        <Label>Select a Reason</Label>
                        <Select
                          name="reson"
                          id="reson"
                          className="cs-style bg-mutant"
                          value={optionGroup.find(
                            option =>
                              option.value &&
                              validation.values.reson &&
                              option.value.toString() ==
                                validation.values.reson.toString()
                          )}
                          placeholder="Select"
                          onChange={selectedOption => {
                            const event = {
                              target: {
                                name: "reson",
                                value: selectedOption["value"],
                              },
                            }
                            validation.handleChange(event)
                          }}
                          onBlur={event => {
                            validation.handleBlur(event)
                          }}
                          // invalid={
                          //   validation.touched.reson &&
                          //   validation.errors.reson
                          //     ? true
                          //     : false
                          // }
                          options={optionGroup}
                          classNamePrefix="select2-selection"
                        />
                        {validation.touched.reson && validation.errors.reson ? (
                          <div className="invalid-feedback-all">
                            {validation.errors.reson}
                          </div>
                        ) : null}
                      </div>
                      <div className="flex-grow-1 cs-rsm">
                        <Label>Reason:</Label>
                        <Input
                          style={{ height: "200px" }}
                          type="textarea"
                          name="reson_text"
                          id="reson_text"
                          // onChange={e=> {
                          // textareachange(e)
                          // }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.reson_text || ""}
                          // invalid={
                          //   validation.touched.reson_text &&
                          //   validation.errors.reson_text
                          //     ? true
                          //     : false
                          // }

                          maxLength="225"
                          rows="3"
                          placeholder="Write your reason here..."
                        />
                        {validation.touched.reson_text &&
                        validation.errors.reson_text ? (
                          <div className="invalid-feedback-all">
                            {validation.errors.reson_text}
                          </div>
                        ) : null}
                      </div>
                    </ModalBody>
                    <ModalFooter className="justify-content-center">
                      <Button
                        type="submit"
                        className="btn btn-danger cs-btn-danger"
                        disabled={isFlagReport}
                      >
                        Submit
                      </Button>
                    </ModalFooter>
                  </Form>
                </Modal>
                <ul
                  className={`list-unstyled mb-0 question_container nv-question-highlight ${
                    isDarkMode && keyStage === "KS3" ? "nv-dark-mode" : ""
                  }`}
                >
                  <li
                    className="justify-content-between mb-0 overflow-visible"
                    onKeyDown={handleKeyDown}
                    tabIndex={index}
                  >
                    <div className="d-flex align-items-center gap-4 justify-content-end nv-sticky-header">
                      <div className="mb-0 d-flex align-items-center gap-2">
                        <p className="mb-0">
                          #
                          {ActivityData.question_id
                            ? ActivityData.question_id
                            : null}
                        </p>
                        <span onClick={tog_standard}>
                          <i className="mdi mdi-flag-variant-outline font-size-18"></i>
                        </span>
                        <span
                          className="p-1"
                          id={`Popover_${index + 1}`}
                          type="button"
                        >
                          <i class="fa fa-info font-size-16"></i>
                        </span>
                        {/* Popover */}
                        <UncontrolledPopover
                          placement="bottom"
                          trigger="legacy"
                          target={`Popover_${index + 1}`}
                          boundariesElement="viewport"
                          modifiers={[
                            {
                              name: "preventOverflow",
                              options: { boundary: "viewport", padding: 8 },
                            },
                            {
                              name: "flip",
                              options: {
                                fallbackPlacements: ["top", "right", "left"],
                              },
                            },
                          ]}
                        >
                          <PopoverBody
                            className="shadow rounded bg-white p-3 math-guide-popover"
                            style={{
                              width: "min(600px, 92vw)",
                              maxHeight: "90vh",
                              overflowY: "auto",
                            }}
                          >
                            <h5 className="text-center">
                              <strong>User Guide for Math Answers</strong>
                            </h5>

                            {/* Accordion */}
                            <Accordion
                              open={openAccordion}
                              toggle={toggleAccordion}
                            >
                              <AccordionItem>
                                <AccordionHeader targetId="1">
                                  <strong>Numbers</strong>
                                </AccordionHeader>
                                <AccordionBody
                                  accordionId="1"
                                  className="p-0 answerQuide"
                                >
                                  {/* Table inside Accordion */}
                                  <Table
                                    bordered
                                    size="sm"
                                    className="mb-0 text-start"
                                  >
                                    <thead>
                                      <tr className="align-middle fw-bold">
                                        <th>Math Expression</th>
                                        <th>How to Type</th>
                                        <th>Not Accepted</th>
                                        <th>Similar Expressions</th>
                                        <th>Tips</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr className="align-middle">
                                        <td>
                                          Whole number e.g.{" "}
                                          <span className="text-danger">
                                            15
                                          </span>
                                        </td>
                                        <td>
                                          <span className="text-danger">
                                            15
                                          </span>
                                        </td>
                                        <td>
                                          • 1.5<br></br>• 1,5<br></br>• 1/5
                                          <br></br>• 1\5<br></br>• 015
                                        </td>
                                        <td>
                                          • 234<br></br>• 4078<br></br>• 37580
                                          <br></br>• 194026<br></br>• -763
                                          <br></br>
                                        </td>
                                        <td>
                                          Make sure to include a negative sign
                                          “-” for negative numbers.
                                        </td>
                                      </tr>
                                      <tr className="align-middle">
                                        <td>
                                          Decimal e.g.{" "}
                                          <span className="text-danger">
                                            0.67
                                          </span>
                                        </td>
                                        <td>
                                          <span className="text-danger">
                                            0.67
                                          </span>
                                        </td>
                                        <td>
                                          • 067<br></br>• 0,67<br></br>• 0:67
                                          <br></br>• 0_67
                                        </td>
                                        <td>
                                          • 0.2<br></br>• 1.45<br></br>• 0.768
                                          <br></br>• 30.85<br></br>• -4.10
                                          <br></br>
                                        </td>
                                        <td>
                                          Make sure to include a dot “.” for
                                          decimals.
                                        </td>
                                      </tr>
                                      <tr className="align-middle">
                                        <td>
                                          Multiple answers e.g.{" "}
                                          <span className="text-danger">
                                            1, 2, 4
                                          </span>
                                        </td>
                                        <td>
                                          <span className="text-danger">
                                            1, 2, 4
                                          </span>
                                        </td>
                                        <td>
                                          • 124<br></br>• 1.2.4<br></br>• 1_2_4
                                          <br></br>• 1&2&4
                                        </td>
                                        <td>
                                          • 3, 6<br></br>• 5, 10, 15, 20
                                          <br></br>• -3, -2, -1
                                        </td>
                                        <td>
                                          Make sure to include a comma, followed
                                          by a space for each answer.
                                        </td>
                                      </tr>
                                      <tr className="align-middle">
                                        <td>
                                          Ratio e.g.{" "}
                                          <span className="text-danger">
                                            2:3
                                          </span>
                                        </td>
                                        <td>
                                          <span className="text-danger">
                                            2:3
                                          </span>
                                        </td>
                                        <td>
                                          • 23<br></br>• 2.3<br></br>• 2,3
                                          <br></br>• 2_3
                                        </td>
                                        <td>
                                          • 3:2<br></br>• 7:10<br></br>• 12:5
                                          <br></br>• 1:4:9<br></br>• 6:3:8
                                        </td>
                                        <td>
                                          Make sure to include a colon “:” for
                                          ratios.
                                        </td>
                                      </tr>
                                      <tr className="align-middle">
                                        <td>
                                          Indices e.g.{" "}
                                          <span className="text-danger">
                                            2^3
                                          </span>
                                        </td>
                                        <td>
                                          <span className="text-danger">
                                            2^3
                                          </span>
                                        </td>
                                        <td>
                                          • 23<br></br>• 2.3<br></br>• 2,3
                                          <br></br>• 2_3
                                        </td>
                                        <td>
                                          • 3^4<br></br>• 10^2<br></br>• -5^3
                                          <br></br>• 8^(-5)
                                        </td>
                                        <td>
                                          Make sure to include “^” for indices.
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </AccordionBody>
                              </AccordionItem>
                              <AccordionItem>
                                <AccordionHeader targetId="2">
                                  <strong>Fractions</strong>
                                </AccordionHeader>
                                <AccordionBody
                                  accordionId="2"
                                  className="p-0 answerQuide"
                                >
                                  {/* Table inside Accordion */}
                                  <Table
                                    bordered
                                    size="sm"
                                    className="mb-0 text-start"
                                  >
                                    <thead>
                                      <tr className="align-middle fw-bold">
                                        <th>Math Expression</th>
                                        <th>How to Type</th>
                                        <th>Not Accepted</th>
                                        <th>Similar Expressions</th>
                                        <th>Tips</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr className="align-middle">
                                        <td>
                                          Proper fraction e.g.{" "}
                                          <span className="text-danger">
                                            3/5
                                          </span>
                                        </td>
                                        <td>
                                          <span className="text-danger">
                                            3/5
                                          </span>
                                        </td>
                                        <td>
                                          • 35<br></br>• 3 5 (with a space)
                                          <br></br>• 3.5<br></br>• 3,5<br></br>•
                                          3_5<br></br>• 3\5
                                        </td>
                                        <td>
                                          • 1/2<br></br>• 4/7<br></br>• -5/8
                                          <br></br>• 10/11<br></br>• -7/12
                                        </td>
                                        <td>
                                          Make sure to include a slash “/” for
                                          fractions.
                                        </td>
                                      </tr>
                                      <tr className="align-middle">
                                        <td>
                                          Improper fraction e.g.{" "}
                                          <span className="text-danger">
                                            9/2
                                          </span>
                                        </td>
                                        <td>
                                          <span className="text-danger">
                                            9/2
                                          </span>
                                        </td>
                                        <td>
                                          • 92<br></br>• 9 2 (with a space)
                                          <br></br>• 9.2<br></br>• 9,2<br></br>•
                                          9_2<br></br>• 9\2
                                        </td>
                                        <td>
                                          • 7/3<br></br>• 8/5<br></br>• -13/3
                                          <br></br>• 14/11<br></br>• -23/10
                                        </td>
                                        <td>
                                          If the question does not specify the
                                          answer to be an improper fraction, its
                                          equivalent mixed number is accepted as
                                          well.
                                        </td>
                                      </tr>
                                      <tr className="align-middle">
                                        <td>
                                          Mixed number e.g.{" "}
                                          <span className="text-danger">
                                            2 3/5
                                          </span>
                                        </td>
                                        <td>
                                          <span className="text-danger">
                                            2 3/5
                                          </span>
                                        </td>
                                        <td>
                                          • 23/5 (without a space)<br></br>•
                                          2.3/5<br></br>• 2,3/5<br></br>• 2_3/5
                                        </td>
                                        <td>
                                          • 4 1/3<br></br>• 7 5/8<br></br>• 10
                                          3/4<br></br>• -2 2/7<br></br>• -10
                                          4/11
                                        </td>
                                        <td>
                                          Make sure to include a space between
                                          the whole number and the proper
                                          fraction.
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </AccordionBody>
                              </AccordionItem>
                              <AccordionItem>
                                <AccordionHeader targetId="3">
                                  <strong>Time</strong>
                                </AccordionHeader>
                                <AccordionBody
                                  accordionId="3"
                                  className="p-0 answerQuide"
                                >
                                  {/* Table inside Accordion */}
                                  <Table
                                    bordered
                                    size="sm"
                                    className="mb-0 text-start"
                                  >
                                    <thead>
                                      <tr className="align-middle fw-bold">
                                        <th>Math Expression</th>
                                        <th>How to Type</th>
                                        <th>Not Accepted</th>
                                        <th>Similar Expressions</th>
                                        <th>Tips</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr className="align-middle">
                                        <td>
                                          12-hour clock e.g.{" "}
                                          <span className="text-danger">
                                            4:15
                                          </span>
                                        </td>
                                        <td>
                                          <span className="text-danger">
                                            4:15
                                          </span>
                                        </td>
                                        <td>
                                          • 415<br></br>• 4 15 (with a space)
                                          <br></br>• 4.15<br></br>• 04:15
                                          <br></br>• 4,15
                                        </td>
                                        <td>
                                          • 2:30<br></br>• 5:45<br></br>• 8:05
                                          <br></br>• 10:22<br></br>• 12:03
                                        </td>
                                        <td>
                                          Make sure to include a colon “:” for
                                          times on the 12-hour clock.<br></br>
                                          “am” or “pm” may be in the question;
                                          do not include the unit in the answer.
                                        </td>
                                      </tr>
                                      <tr className="align-middle">
                                        <td>
                                          24-hour time e.g.{" "}
                                          <span className="text-danger">
                                            16 15
                                          </span>
                                        </td>
                                        <td>
                                          <span className="text-danger">
                                            16 15
                                          </span>{" "}
                                          (with a space)
                                        </td>
                                        <td>
                                          • 1615<br></br>• 16.15<br></br>• 16:15
                                          <br></br>• 16,15
                                        </td>
                                        <td>
                                          • 02 30<br></br>• 17 45<br></br>• 20
                                          05<br></br>• 20 22<br></br>• 00 03
                                        </td>
                                        <td>
                                          Make sure to include a space between
                                          the hours and the minutes.
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </AccordionBody>
                              </AccordionItem>
                              <AccordionItem>
                                <AccordionHeader targetId="4">
                                  <strong>Algebra</strong>
                                </AccordionHeader>
                                <AccordionBody
                                  accordionId="4"
                                  className="p-0 answerQuide"
                                >
                                  {/* Table inside Accordion */}
                                  <Table
                                    bordered
                                    size="sm"
                                    className="mb-0 text-start"
                                  >
                                    <thead>
                                      <tr className="align-middle fw-bold">
                                        <th>Math Expression</th>
                                        <th>How to Type</th>
                                        <th>Not Accepted</th>
                                        <th>Similar Expressions</th>
                                        <th>Tips</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr className="align-middle">
                                        <td>
                                          12-hour clock e.g.{" "}
                                          <span className="text-danger">
                                            4:15
                                          </span>
                                        </td>
                                        <td>
                                          <span className="text-danger">
                                            4:15
                                          </span>
                                        </td>
                                        <td>
                                          • 415<br></br>• 4 15 (with a space)
                                          <br></br>• 4.15<br></br>• 04:15
                                          <br></br>• 4,15
                                        </td>
                                        <td>
                                          • 2:30<br></br>• 5:45<br></br>• 8:05
                                          <br></br>• 10:22<br></br>• 12:03
                                        </td>
                                        <td>
                                          Make sure to include a colon “:” for
                                          times on the 12-hour clock.<br></br>
                                          “am” or “pm” may be in the question;
                                          do not include the unit in the answer.
                                        </td>
                                      </tr>
                                      <tr className="align-middle">
                                        <td>
                                          24-hour time e.g.{" "}
                                          <span className="text-danger">
                                            16 15
                                          </span>
                                        </td>
                                        <td>
                                          <span className="text-danger">
                                            16 15
                                          </span>{" "}
                                          (with a space)
                                        </td>
                                        <td>
                                          • 1615<br></br>• 16.15<br></br>• 16:15
                                          <br></br>• 16,15
                                        </td>
                                        <td>
                                          • 02 30<br></br>• 17 45<br></br>• 20
                                          05<br></br>• 20 22<br></br>• 00 03
                                        </td>
                                        <td>
                                          Make sure to include a space between
                                          the hours and the minutes.
                                        </td>
                                      </tr>
                                      <tr className="align-middle">
                                        <td>
                                          Algebraic term e.g.{" "}
                                          <span className="text-danger">
                                            2x
                                          </span>
                                        </td>
                                        <td>
                                          <span className="text-danger">
                                            2x
                                          </span>
                                        </td>
                                        <td>
                                          • 2<br></br>• 2 x (with a space)
                                          <br></br>• 2xx<br></br>• xx<br></br>•
                                          x2
                                        </td>
                                        <td>
                                          • y<br></br>• 5k<br></br>• 10b
                                          <br></br>• -3p<br></br>• -12m
                                        </td>
                                        <td>
                                          Write 1y as y.<br></br>
                                          Make sure to include the negative sign
                                          “-” for negative algebraic terms.
                                        </td>
                                      </tr>
                                      <tr className="align-middle">
                                        <td>
                                          Algebraic term e.g.{" "}
                                          <span className="text-danger">
                                            4pq
                                          </span>
                                        </td>
                                        <td>
                                          <span className="text-danger">
                                            4pq
                                          </span>
                                        </td>
                                        <td>
                                          • 4qp<br></br>• pq4<br></br>• qp4
                                          <br></br>• p4q<br></br>• q4p
                                        </td>
                                        <td>
                                          • ab<br></br>• 3mn<br></br>• -cd
                                          <br></br>• -5yz
                                        </td>
                                        <td>
                                          Write 1ab as ab.<br></br>
                                          Make sure to include the negative sign
                                          “-” for negative algebraic terms.
                                        </td>
                                      </tr>
                                      <tr className="align-middle">
                                        <td>
                                          Algebraic term with power e.g.{" "}
                                          <span className="text-danger">
                                            3x²
                                          </span>
                                        </td>
                                        <td>
                                          <span className="text-danger">
                                            3x^2
                                          </span>
                                        </td>
                                        <td>
                                          • 3x2<br></br>• 3xx<br></br>• 3x_2
                                          <br></br>• (3x)^2
                                        </td>
                                        <td>
                                          • y^2<br></br>• 5k^3<br></br>• 10b^2
                                          <br></br>• -3p^2<br></br>• -12m^3
                                        </td>
                                        <td>
                                          Make sure to include “^” for indices.
                                          <br></br>
                                          To type “^”, type “Shift”, followed by
                                          “6” on the keyboard.
                                        </td>
                                      </tr>
                                      <tr className="align-middle">
                                        <td>
                                          Linear expression (positive terms
                                          only) e.g.{" "}
                                          <span className="text-danger">
                                            4x + 5
                                          </span>
                                        </td>
                                        <td>
                                          <span className="text-danger">
                                            4x + 5
                                          </span>
                                        </td>
                                        <td>
                                          • 5 + 4x (with a space before and
                                          after the +)<br></br>• x4 + 5<br></br>
                                          • 5 + x4<br></br>• xxxx + 5<br></br>•
                                          xxxx5<br></br>• 5xxxx
                                        </td>
                                        <td>
                                          • a + 1<br></br>• 2h + 3<br></br>• m +
                                          3n + 4<br></br>• 4p + 5q + 6
                                        </td>
                                        <td>
                                          Make sure to include a space before
                                          and after the “+” sign, after the
                                          first term.<br></br>
                                          Flag (⚐) the question if an equivalent
                                          expression is not accepted.
                                        </td>
                                      </tr>
                                      <tr className="align-middle">
                                        <td>
                                          Linear expression (positive and
                                          negative terms) e.g.{" "}
                                          <span className="text-danger">
                                            4x - 5
                                          </span>
                                        </td>
                                        <td>
                                          <span className="text-danger">
                                            4x - 5
                                          </span>
                                        </td>
                                        <td>
                                          • -5 + 4x (with a space before and
                                          after the -)<br></br>• x4 - 5<br></br>
                                          • -5 + x4<br></br>• xxxx - 5<br></br>•
                                          xxxx5<br></br>• 5xxxx
                                        </td>
                                        <td>
                                          • a - 1<br></br>• -1 + a<br></br>• 2h
                                          - 3<br></br>• -3 + 2h<br></br>• m - 3n
                                          + 4<br></br>• 4p - 5q - 6
                                        </td>
                                        <td>
                                          Make sure to include a space before
                                          and after the “+” or “-” sign, after
                                          the first term.<br></br>
                                          Flag (⚐) the question if an equivalent
                                          expression is not accepted.
                                        </td>
                                      </tr>
                                      <tr className="align-middle">
                                        <td>
                                          Linear expression (negative terms
                                          only) e.g.{" "}
                                          <span className="text-danger">
                                            -4x - 5
                                          </span>
                                        </td>
                                        <td>
                                          <span className="text-danger">
                                            -4x - 5
                                          </span>
                                        </td>
                                        <td>
                                          • -5 - 4x<br></br>• -x4 - 5<br></br>•
                                          -5 - x4<br></br>• -xxxx - 5<br></br>•
                                          -xxxx5<br></br>• -5xxxx
                                        </td>
                                        <td>
                                          • -a - 1<br></br>• -1 - a<br></br>•
                                          -2h - 3<br></br>• -3 - 2h<br></br>• -m
                                          - 3n - 4<br></br>• -4p - 5q - 6
                                        </td>
                                        <td>
                                          Make sure to include a space before
                                          and after the “-” sign, after the
                                          first term.
                                        </td>
                                      </tr>
                                      <tr className="align-middle">
                                        <td>
                                          Algebraic fraction e.g.{" "}
                                          <span className="text-danger">
                                            (3y)/4
                                          </span>
                                        </td>
                                        <td>
                                          <span className="text-danger">
                                            (3y)/4
                                          </span>
                                        </td>
                                        <td>
                                          • 3y/4<br></br>• 3/(4y)<br></br>•
                                          (3y/4)<br></br>• [3y]/4
                                        </td>
                                        <td>
                                          • a/4<br></br>• (2x)/3<br></br>•
                                          (2/3)x<br></br>• b^2/4<br></br>•
                                          (1/4)b^2<br></br>• (4x^2)/5<br></br>•
                                          (4/5)x^2<br></br>• (m + 3)/7<br></br>•
                                          (5n - 4)/6
                                        </td>
                                        <td>
                                          Note the placement of the round
                                          brackets.
                                        </td>
                                      </tr>
                                      <tr className="align-middle">
                                        <td>
                                          Algebraic fraction (with negative
                                          term) e.g.{" "}
                                          <span className="text-danger">
                                            -(3y)/4
                                          </span>
                                        </td>
                                        <td>
                                          <span className="text-danger">
                                            -(3y)/4
                                          </span>
                                        </td>
                                        <td>
                                          • -3y/4<br></br>• -3/(4y)<br></br>•
                                          -(3y/4)<br></br>• (-3y/4)<br></br>•
                                          -[3y]/4
                                        </td>
                                        <td>
                                          • -a/4<br></br>• -(2x)/3<br></br>•
                                          (-2x)/3<br></br>• -(2/3)x<br></br>•
                                          -(m + 3)/7<br></br>• (-m - 3)/7
                                          <br></br>• -(5n - 4)/6<br></br>• (-5n
                                          + 4)/6
                                        </td>
                                        <td>
                                          Note the placement of the round
                                          brackets.
                                        </td>
                                      </tr>
                                      <tr className="align-middle">
                                        <td>
                                          Quadratic expression e.g.{" "}
                                          <span className="text-danger">
                                            5x^2 + 7
                                          </span>
                                        </td>
                                        <td>
                                          <span className="text-danger">
                                            5x^2 + 7
                                          </span>
                                        </td>
                                        <td>
                                          • 5x2 + 7<br></br>• 7 + 5x2<br></br>•
                                          x^25 + 7<br></br>• 7 + x^25
                                        </td>
                                        <td>
                                          • y^2 + 4<br></br>• 4 + y^2<br></br>•
                                          k^2 - 5<br></br>• -5 + k^2<br></br>•
                                          4m^2 - 3<br></br>• -3 + 4m^2<br></br>•
                                          x^2 + 3x - 1<br></br>• 2n^2 - 5n + 4
                                        </td>
                                        <td>
                                          Make sure to include “^” for the
                                          quadratic term.<br></br>
                                          Make sure to include a space before
                                          and after the “+” or “-” sign, after
                                          the first term.
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </AccordionBody>
                              </AccordionItem>
                            </Accordion>
                          </PopoverBody>
                        </UncontrolledPopover>
                      </div>
                      {renderDarkModeToggle()}
                      {renderOverlayToggle()}
                    </div>
                    <div className="d-flex gap-3">
                      {ActivityData?.question_text &&
                        renderSpeakerToggle("q" + index, [
                          ActivityData?.question_text,
                        ])}
                      <div
                        className=" question_work"
                        dangerouslySetInnerHTML={{
                          __html: ActivityData?.question_text
                            ? ActivityData.question_text
                                .replace(/\[(\d+)Answer char=\d+\]/g, "")
                                .replace(/\[Answer char=\d+\]/g, "")
                            : null,
                        }}
                      ></div>
                    </div>

                    {/* Past question */}
                    {ActivityData.question_parts &&
                      ActivityData.question_parts.map((quspart, index) => {
                        const stuAnswersarray =
                          quspart.StudentAnsAttempts.map(stuAns => {
                            try {
                              return JSON.parse(stuAns.student_answer)
                            } catch (error) {
                              console.error("Error parsing JSON:", error)
                              return null // or handle the error in an appropriate way
                            }
                          }) || [] // Extracting session keys

                        // Assuming stuAnswersarray is a nested array
                        const flattenedStuAnswers = [].concat(
                          ...stuAnswersarray
                        )
                        let serialNumber = 0

                        return index + 1 <
                          ActivityData1.is_current_tab_current_part ? (
                          <div key={index}>
                            <div className="d-flex gap-2 flex-row ">
                              {quspart?.part_text &&
                                renderSpeakerToggle("pt" + index, [
                                  quspart?.part_text,
                                ])}
                              <div className="mr-3">
                                {index + 1}
                                {")"}
                              </div>
                              <div
                                className="question_work"
                                dangerouslySetInnerHTML={{
                                  __html: quspart.part_text
                                    ? quspart.part_text
                                        .replace(
                                          /\[(\d+)Answer char=\d+\]/g,
                                          ""
                                        )
                                        .replace(/\[Answer char=\d+\]/g, "")
                                    : null,
                                }}
                              ></div>
                            </div>
                            {/* Anse category statement Star */}
                            {quspart.part_answer_type === 2 ? (
                              <ul className="dg-selector width-controll list-unstyled mb-0">
                                {quspart.question_answers &&
                                  quspart.question_answers.map(
                                    (qusAns, index1) => {
                                      if (
                                        quspart.StudentAnsAttempts.length > 0
                                      ) {
                                        return quspart.StudentAnsAttempts.map(
                                          (qusStuAns, stuAnsindex) => {
                                            // Your logic for filtering student answers and determining status_color and border_color
                                            const stuAnswersarray =
                                              quspart.StudentAnsAttempts.filter(
                                                stuAns =>
                                                  stuAns.atempt_count ===
                                                  stuAnsindex + 1
                                              ).map(stuAns => {
                                                try {
                                                  return JSON.parse(
                                                    stuAns.student_answer
                                                  )
                                                } catch (error) {
                                                  console.error(
                                                    "Error parsing JSON:",
                                                    error
                                                  )
                                                  return null // or handle the error in an appropriate way
                                                }
                                              }) || []

                                            //console.log(stuAnswersarray);
                                            // Assuming stuAnswersarray is a nested array
                                            const flattenedStuAnswers =
                                              [].concat(...stuAnswersarray)
                                            //  let cleanedText = qusAns.answer_text.replace(/&nbsp;/g, '').replace(/`/g, '').replace(/<[^>]*>/g, '') || '';
                                            //  let resultTest = cleanedText.toLowerCase().trim();
                                            //  let answers = resultTest.split('|') || [];
                                            //  let firstAnswer = answers[0] ? answers[0].trim() : "";
                                            //  let secondAnswer = answers[1] ? answers[1].trim() : "";

                                            if (
                                              qusAns.answer_is_correct === 1
                                            ) {
                                              let filteredStuAns =
                                                flattenedStuAnswers.filter(
                                                  stuAns =>
                                                    parseInt(stuAns.part_id) ===
                                                      parseInt(
                                                        qusAns.answer_part_id
                                                      ) &&
                                                    parseInt(
                                                      qusStuAns.attempt_status
                                                    ) === 1 &&
                                                    parseInt(
                                                      stuAns.answer_id
                                                    ) ===
                                                      parseInt(qusAns.answer_id)
                                                ) || []

                                              let filteredAllStuAns =
                                                flattenedStuAnswers.filter(
                                                  stuAns =>
                                                    parseInt(stuAns.part_id) ===
                                                      parseInt(
                                                        qusAns.answer_part_id
                                                      ) &&
                                                    parseInt(
                                                      stuAns.answer_id
                                                    ) ===
                                                      parseInt(qusAns.answer_id)
                                                ) || []

                                              return (
                                                <li
                                                  key={index1}
                                                  className={
                                                    filteredStuAns.length > 0
                                                      ? " input_box m_input_box"
                                                      : "input_box m_input_box"
                                                  }
                                                >
                                                  <input
                                                    id={
                                                      index1 +
                                                      Math.floor(
                                                        Math.random() * 5
                                                      )
                                                    }
                                                    placeholder="Type your answer here..."
                                                    type="text"
                                                    className={
                                                      parseInt(
                                                        qusStuAns.attempt_status
                                                      ) === 1
                                                        ? "answersuccess"
                                                        : "answererror"
                                                    }
                                                    value={
                                                      filteredAllStuAns
                                                        .filter(
                                                          item =>
                                                            parseInt(
                                                              item.answer_id
                                                            ) ===
                                                            parseInt(
                                                              qusAns.answer_id
                                                            )
                                                        )
                                                        .map(item => item.text)
                                                        .find(
                                                          text =>
                                                            text !== undefined
                                                        ) || "" // Find the first non-undefined text value
                                                    }
                                                    disabled={true}
                                                    //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                    onChange={e =>
                                                      handletext(
                                                        e,
                                                        qusAns.answer_id,
                                                        qusAns.answer_part_id
                                                      )
                                                    }
                                                    // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                  />
                                                </li>
                                              )
                                            }
                                          }
                                        )
                                      } else {
                                        return (
                                          <li
                                            key={index1}
                                            className={"input_box m_input_box"}
                                          >
                                            <input
                                              id={
                                                index1 +
                                                Math.floor(Math.random() * 5)
                                              }
                                              type="text"
                                              className={"answereditor"}
                                              value={
                                                "" // Find the first non-undefined text value
                                              }
                                              disabled={true}
                                              //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                              //onChange={(e) => handletext(e, qusAns.answer_id, qusAns.answer_part_id)}
                                              // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                            />
                                          </li>
                                        )
                                      }
                                    }
                                  )}
                              </ul>
                            ) : quspart.part_answer_type === 4 ? (
                              //const stuAnswersarray = stuAnswersJson.length > 0 ? JSON.parse(stuAnswersJson) : [];
                              <ul className="dg-selector choose-it-question width-controll list-unstyled mb-0">
                                {quspart.question_answers &&
                                  rearrangeEvenOdd(
                                    quspart.question_answers
                                  ).map((qusAns, index1) => {
                                    const cleanText = qusAns.answer_text
                                      .replace(/&nbsp;/g, "")
                                      .replace(/`/g, "")
                                      .replace(/<[^>]*>/g, "")
                                      .trim()

                                    const hasImage = /<img\s+[^>]*>/gi.test(
                                      qusAns.answer_text
                                    )

                                    if (!cleanText && !hasImage) {
                                      return null // Skip rendering if english_answer_text is effectively empty and no image is present
                                    }
                                    serialNumber++
                                    let filteredStuAns =
                                      flattenedStuAnswers.filter(
                                        stuAns =>
                                          parseInt(stuAns.part_id) ===
                                            parseInt(qusAns.answer_part_id) &&
                                          parseInt(stuAns.answer_id) ===
                                            parseInt(qusAns.answer_id)
                                      ) || []

                                    var status_color =
                                      "selector-general cursor-pointer"
                                    var border_color = "border-start-secondary"
                                    if (filteredStuAns.length > 0) {
                                      if (
                                        parseInt(qusAns.answer_is_correct) === 1
                                      ) {
                                        status_color = "selector-success"
                                        border_color = "border-start-success"
                                      } else {
                                        status_color = "selector-wrong "
                                        border_color = "border-start-danger"
                                      }
                                    }
                                    //const sesKeys = quspart.StudentAnsAttempts.map(stuAns => stuAns.part_id); // Extracting session keys
                                    return (
                                      <li
                                        className={
                                          status_color + " choose m_choose"
                                        }
                                        key={index1}
                                      >
                                        
                                        <div
                                          style={{
                                            position: "absolute",
                                            left: "-40px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                          }}
                                          onClick={e =>
                                            e.stopPropagation()
                                          }
                                        >
                                          {renderSpeakerToggle(
                                            "ans-" + qusAns.answer_id,
                                            [qusAns.answer_text]
                                          )}
                                        </div>
                                        <div className="p-2 px-3 font-size-18 dg-serial-badge-wrap">
                                          <span className="dg-serial-badge">
                                            {serialNumber}
                                          </span>
                                        </div>
                                        <div
                                          className={
                                            "p-2 dg-media " + { border_color }
                                          }
                                          dangerouslySetInnerHTML={{
                                            __html: qusAns.answer_text
                                              ? qusAns.answer_text
                                              : null,
                                          }}
                                        ></div>
                                      </li>
                                    )
                                  })}
                              </ul>
                            ) : (
                              <p className="text-center">No option</p>
                            )}

                            {/* Anse category statement end */}
                          </div>
                        ) : null
                      })}
                    {/* Past question end */}
                    {ActivePartData &&
                      ActivePartData.map((quspart, index) => {
                        const stuAnswersarray =
                          quspart.StudentAnsAttempts.map(stuAns => {
                            try {
                              return JSON.parse(stuAns.student_answer)
                            } catch (error) {
                              console.error("Error parsing JSON:", error)
                              return null // or handle the error in an appropriate way
                            }
                          }) || [] // Extracting session keys
                        let correct_count = 0
                        // Assuming stuAnswersarray is a nested array
                        const flattenedStuAnswers = [].concat(
                          ...stuAnswersarray
                        )
                        let serialNumber = 0
                        return (
                          <div
                            key={quspart.part_id || quspart.question_part_id || index}
                          >
                            <div className="d-flex gap-2 flex-row ">
                              {renderSpeakerToggle(
                                "ptc" +
                                  (ActivityData1?.is_show_all_parts
                                    ? index + 1
                                    : ActivityData1.is_current_tab_current_part),
                                [quspart?.part_text]
                              )}
                              <div className="mr-3">
                                {ActivityData1?.is_show_all_parts
                                  ? index + 1
                                  : ActivityData1.is_current_tab_current_part}
                                {")"}
                              </div>
                              <div
                                className="question_work"
                                dangerouslySetInnerHTML={{
                                  __html: quspart.part_text
                                    ? quspart.part_text
                                        .replace(
                                          /\[(\d+)Answer char=\d+\]/g,
                                          ""
                                        )
                                        .replace(/\[Answer char=\d+\]/g, "")
                                    : null,
                                }}
                              ></div>
                            </div>
                            {/* Anse category statement Star */}
                            {quspart.part_answer_type === 2 ? (
                              <ul className="dg-selector width-controll list-unstyled mb-0 current-m-answer">
                                {quspart.question_answers &&
                                  quspart.question_answers.map(
                                    (qusAns, index1) => {
                                      if (
                                        quspart.StudentAnsAttempts.length > 0
                                      ) {
                                        return quspart.StudentAnsAttempts.map(
                                          (qusStuAns, stuAnsindex) => {
                                            // Your logic for filtering student answers and determining status_color and border_color
                                            const stuAnswersarray =
                                              quspart.StudentAnsAttempts.filter(
                                                stuAns =>
                                                  stuAns.atempt_count ===
                                                  stuAnsindex + 1
                                              ).map(stuAns => {
                                                try {
                                                  return JSON.parse(
                                                    stuAns.student_answer
                                                  )
                                                } catch (error) {
                                                  console.error(
                                                    "Error parsing JSON:",
                                                    error
                                                  )
                                                  return null // or handle the error in an appropriate way
                                                }
                                              }) || []
                                            // console.log(stuAnswersarray);

                                            // Assuming stuAnswersarray is a nested array
                                            const flattenedStuAnswers =
                                              [].concat(...stuAnswersarray)
                                            let cleanedText =
                                              qusAns.answer_text
                                                .replace(/&nbsp;/g, "")
                                                .replace(/`/g, "")
                                                .replace(/<[^>]*>/g, "") || ""

                                            //check "/" and any letters find logic start
                                            function cleanAnswer(answer) {
                                              let trimmed = answer
                                                .trim()
                                                .toLowerCase()
                                              return /^[a-zA-Z, ]+$/.test(
                                                trimmed
                                              ) ||
                                                /^-?\s?\d+\s+\d+\/\d+$/.test(
                                                  trimmed
                                                )
                                                ? trimmed
                                                : trimmed.replace(/\s+/g, "")
                                            }

                                            let resultTest = cleanAnswer(
                                              cleanedText.toLowerCase().trim()
                                            )
                                            let answers =
                                              resultTest.split("|") || []
                                            let firstAnswer = answers[0]
                                              ? cleanAnswer(answers[0].trim())
                                              : ""
                                            let secondAnswer = answers[1]
                                              ? cleanAnswer(answers[1].trim())
                                              : ""
                                            // Process alternative answers in LCMS
                                            let answersArray =
                                              cleanedText
                                                .split("|")
                                                .map(ans =>
                                                  cleanAnswer(ans)
                                                    .trim()
                                                    .toLowerCase()
                                                )
                                                .filter(Boolean) || []
                                            // Process alternative answers in LCMS ens

                                            //check "/" and any letters find logic end

                                            // //check "/" and any letters find logic start

                                            // // 1. (/^[a-zA-Z, ]+$/.test(answer)) --> Only words(e.g., test, world)
                                            // // 2. (/^-?\s?\d+\s+\d+\/\d+$/.test(answer)) --> Ensures at least one `/` is present

                                            //   let hasLetter =/^[a-zA-Z, ]+$/.test(cleanedText.trim().toLowerCase());
                                            //   let hasSlash =/^-?\s?\d+\s+\d+\/\d+$/.test(cleanedText.trim().toLowerCase());

                                            // if (hasLetter || hasSlash) {
                                            //      resultTest = cleanedText
                                            //       .toLowerCase()
                                            //       .trim()
                                            //      answers =
                                            //       resultTest.split("|") || []
                                            //      firstAnswer = answers[0]
                                            //       ? answers[0].trim()
                                            //       : ""
                                            //      secondAnswer = answers[1]
                                            //       ? answers[1].trim()
                                            //       : ""
                                            //      answersArray = cleanedText.split("|").map(ans => ans.trim().toLowerCase()).filter(Boolean) || [];
                                            // }else{
                                            //      resultTest = cleanedText
                                            //       .toLowerCase()
                                            //       .trim().replace(/\s+/g, "")
                                            //      answers =
                                            //       resultTest.split("|") || []
                                            //      firstAnswer = answers[0]
                                            //       ? answers[0].trim().replace(/\s+/g, "")
                                            //       : ""
                                            //      secondAnswer = answers[1]
                                            //       ? answers[1].trim().replace(/\s+/g, "")
                                            //       : ""
                                            //      answersArray = cleanedText.split("|").map(ans => ans.trim().toLowerCase().replace(/\s+/g, "")).filter(Boolean) || [];
                                            // }
                                            // //check "/" and any letters find logic end
                                            if (
                                              qusAns.answer_is_correct === 1
                                            ) {
                                              //check "/" and any letters find logic start

                                              let filteredStuAns =
                                                flattenedStuAnswers.filter(
                                                  stuAns =>
                                                    parseInt(stuAns.part_id) ===
                                                      parseInt(
                                                        qusAns.answer_part_id
                                                      ) &&
                                                    (cleanAnswer(
                                                      stuAns.text
                                                        .toLowerCase()
                                                        .trim()
                                                    ) == resultTest ||
                                                      cleanAnswer(
                                                        stuAns.text
                                                          .toLowerCase()
                                                          .trim()
                                                      ) == firstAnswer ||
                                                      cleanAnswer(
                                                        stuAns.text
                                                          .toLowerCase()
                                                          .trim()
                                                      ) == secondAnswer ||
                                                      answersArray.some(
                                                        answer =>
                                                          answer ==
                                                          cleanAnswer(
                                                            stuAns.text
                                                          )
                                                            .toLowerCase()
                                                            .trim()
                                                      )) &&
                                                    parseInt(
                                                      stuAns.answer_id
                                                    ) ===
                                                      parseInt(
                                                        qusAns.answer_id
                                                      ) &&
                                                    parseInt(
                                                      qusStuAns.attempt_status
                                                    ) === 1
                                                ) || []

                                              let filteredAllStuAns =
                                                flattenedStuAnswers.filter(
                                                  stuAns =>
                                                    parseInt(stuAns.part_id) ===
                                                      parseInt(
                                                        qusAns.answer_part_id
                                                      ) &&
                                                    parseInt(
                                                      stuAns.answer_id
                                                    ) ===
                                                      parseInt(qusAns.answer_id)
                                                ) || []

                                              return (
                                                <>
                                                  <li
                                                    key={stuAnsindex}
                                                    className={
                                                      quspart.StudentAnsAttempts
                                                        .length > 0 &&
                                                      filteredStuAns.length > 0
                                                        ? "input_box m_input_box"
                                                        : "input_box m_input_box"
                                                    }
                                                  >
                                                    <input
                                                      id={
                                                        stuAnsindex +
                                                        Math.floor(
                                                          Math.random() * 5
                                                        )
                                                      }
                                                      type="text"
                                                      className={
                                                        quspart
                                                          .StudentAnsAttempts
                                                          .length > 0
                                                          ? filteredStuAns.length >
                                                            0
                                                            ? "answersuccess"
                                                            : "answererror"
                                                          : "answereditor"
                                                      }
                                                      value={
                                                        filteredAllStuAns
                                                          .filter(
                                                            item =>
                                                              parseInt(
                                                                item.answer_id
                                                              ) ===
                                                              parseInt(
                                                                qusAns.answer_id
                                                              )
                                                          )
                                                          .map(
                                                            item => item.text
                                                          )
                                                          .find(
                                                            text =>
                                                              text !== undefined
                                                          ) || "" // Find the first non-undefined text value
                                                      }
                                                      disabled={
                                                        quspart
                                                          .StudentAnsAttempts
                                                          .length > 0
                                                          ? filteredStuAns.length >
                                                            0
                                                            ? true
                                                            : true
                                                          : false
                                                      }
                                                      autoComplete="off"
                                                      autoCorrect="off"
                                                      spellCheck="false"
                                                      //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                      onChange={e =>
                                                        handletext(
                                                          e,
                                                          qusAns.answer_id,
                                                          qusAns.answer_part_id
                                                        )
                                                      }
                                                      // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                    />
                                                  </li>

                                                  {quspart.StudentAnsAttempts
                                                    .length === 1 &&
                                                  filteredStuAns.length ===
                                                    0 ? (
                                                    <li
                                                      key={index1 + 1}
                                                      className={
                                                        quspart
                                                          .StudentAnsAttempts
                                                          .length > 1 &&
                                                        filteredStuAns.length >
                                                          0
                                                          ? "input_box m_input_box"
                                                          : "input_box m_input_box"
                                                      }
                                                    >
                                                      <input
                                                        id={
                                                          index1 +
                                                          1 +
                                                          Math.floor(
                                                            Math.random() * 5
                                                          )
                                                        }
                                                        placeholder="Type your answer here..."
                                                        type="text"
                                                        autoFocus={true}
                                                        className={
                                                          quspart
                                                            .StudentAnsAttempts
                                                            .length > 1
                                                            ? filteredStuAns.length >
                                                              0
                                                              ? "answersuccess"
                                                              : "answererror "
                                                            : "answereditor"
                                                        }
                                                        value={
                                                          selectedAnswerText
                                                            .filter(
                                                              item =>
                                                                parseInt(
                                                                  item.answer_id
                                                                ) ===
                                                                parseInt(
                                                                  qusAns.answer_id
                                                                )
                                                            )
                                                            .map(
                                                              item => item.text
                                                            )
                                                            .find(
                                                              text =>
                                                                text !==
                                                                undefined
                                                            ) || ""
                                                        }
                                                        autoComplete="off"
                                                        autoCorrect="off"
                                                        spellCheck="false"
                                                        disabled={
                                                          quspart
                                                            .StudentAnsAttempts
                                                            .length > 1
                                                            ? filteredStuAns.length >
                                                              0
                                                              ? true
                                                              : true
                                                            : false
                                                        }
                                                        //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                        onChange={e =>
                                                          handletext(
                                                            e,
                                                            qusAns.answer_id,
                                                            qusAns.answer_part_id
                                                          )
                                                        }
                                                        // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                      />
                                                    </li>
                                                  ) : null}
                                                  {nextQuestion &&
                                                  SummryView === false &&
                                                  qusAns &&
                                                  skipAnchorEl
                                                    ? createPortal(
                                                        <span
                                                          className="font-size-15 mt-1 text-danger fw-bold skip-button"
                                                          onClick={() =>
                                                            handletext(
                                                              ".",
                                                              qusAns.answer_id,
                                                              qusAns.answer_part_id,
                                                              1
                                                            )
                                                          }
                                                        >
                                                        <svg
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          version="1.1"
                                                          xmlnsXlink="http://www.w3.org/1999/xlink"
                                                          width={20}
                                                          height={20}
                                                          x={0}
                                                          y={0}
                                                          viewBox="0 0 24 25"
                                                          style={{
                                                            enableBackground:
                                                              "new 0 0 512 512",
                                                          }}
                                                          xmlSpace="preserve"
                                                          className=""
                                                        >
                                                          <g>
                                                            <path
                                                              fill="#ef0000"
                                                              fillRule="evenodd"
                                                              d="M9.676 8.205c0-2.256 2.568-3.553 4.383-2.212l6.822 5.037a2.75 2.75 0 0 1 0 4.424l-6.822 5.037c-1.815 1.34-4.383.044-4.383-2.212v-.035l-3.042 2.247c-1.816 1.34-4.384.044-4.384-2.212V8.205c0-2.256 2.568-3.553 4.384-2.212l3.042 2.246zm1.5 1.142 2.279 1.683a2.75 2.75 0 0 1 0 4.424l-2.28 1.683v1.142c0 1.025 1.168 1.615 1.993 1.005l6.821-5.036a1.25 1.25 0 0 0 0-2.012L13.17 7.2c-.826-.61-1.993-.02-1.993 1.005zM5.743 7.2c-.826-.61-1.993-.02-1.993 1.005V18.28c0 1.025 1.167 1.615 1.993 1.005l6.82-5.036a1.25 1.25 0 0 0 0-2.012z"
                                                              clipRule="evenodd"
                                                              opacity={1}
                                                              data-original="#000000"
                                                              className=""
                                                            />
                                                          </g>
                                                        </svg>{" "}
                                                        Skip Question
                                                      </span>,
                                                      skipAnchorEl
                                                    )
                                                  : null}
                                                </>
                                              )
                                            }
                                          }
                                        )
                                      } else {
                                        const stuAnswersarray =
                                          quspart.StudentAnsAttempts.map(
                                            stuAns => {
                                              try {
                                                return JSON.parse(
                                                  stuAns.student_answer
                                                )
                                              } catch (error) {
                                                console.error(
                                                  "Error parsing JSON:",
                                                  error
                                                )
                                                return null // or handle the error in an appropriate way
                                              }
                                            }
                                          ) || [] // Extracting session keys
                                        // console.log(stuAnswersarray);
                                        // Assuming stuAnswersarray is a nested array

                                        const flattenedStuAnswers = [].concat(
                                          ...stuAnswersarray
                                        )
                                        let cleanedText =
                                          qusAns.answer_text
                                            .replace(/&nbsp;/g, "")
                                            .replace(/`/g, "")
                                            .replace(/<[^>]*>/g, "") || ""

                                        //check "/" and any letters find logic start
                                        function cleanAnswer(answer) {
                                          let trimmed = answer
                                            .trim()
                                            .toLowerCase()
                                          return /^[a-zA-Z, ]+$/.test(
                                            trimmed
                                          ) ||
                                            /^-?\s?\d+\s+\d+\/\d+$/.test(
                                              trimmed
                                            )
                                            ? trimmed
                                            : trimmed.replace(/\s+/g, "")
                                        }

                                        let resultTest = cleanAnswer(
                                          cleanedText.toLowerCase().trim()
                                        )
                                        let answers =
                                          resultTest.split("|") || []
                                        let firstAnswer = answers[0]
                                          ? cleanAnswer(answers[0].trim())
                                          : ""
                                        let secondAnswer = answers[1]
                                          ? cleanAnswer(answers[1].trim())
                                          : ""
                                        // Process alternative answers in LCMS
                                        let answersArray =
                                          cleanedText
                                            .split("|")
                                            .map(ans =>
                                              cleanAnswer(ans)
                                                .trim()
                                                .toLowerCase()
                                            )
                                            .filter(Boolean) || []
                                        // Process alternative answers in LCMS ens

                                        //check "/" and any letters find logic end

                                        //   // let resultTest = cleanedText
                                        //   //   .toLowerCase()
                                        //   //   .trim().replace(/\s+/g, "")
                                        //   // let answers =
                                        //   //   resultTest.split("|") || []
                                        //   // let firstAnswer = answers[0]
                                        //   //   ? answers[0].trim().replace(/\s+/g, "")
                                        //   //   : ""
                                        //   // let secondAnswer = answers[1]
                                        //   //   ? answers[1].trim().replace(/\s+/g, "")
                                        //   //   : ""
                                        //   // let answersArray = cleanedText.split("|").map(ans => ans.trim().toLowerCase().replace(/\s+/g, "")).filter(Boolean) || [];
                                        //   let resultTest = '';
                                        //   let answers = [];
                                        //   let firstAnswer = '';
                                        //   let secondAnswer = '';
                                        //   let answersArray = [];
                                        // //check "/" and any letters find logic start
                                        // // 1. (/^[a-zA-Z, ]+$/.test(answer)) --> Only words(e.g., test, world)
                                        // // 2. (/^-?\s?\d+\s+\d+\/\d+$/.test(answer)) --> Ensures at least one `/` is present

                                        // let hasLetter =/^[a-zA-Z, ]+$/.test(cleanedText.trim().toLowerCase());
                                        // let hasSlash =/^-?\s?\d+\s+\d+\/\d+$/.test(cleanedText.trim().toLowerCase());
                                        //   // let hasLetter = /[a-zA-Z]/.test(cleanedText.trim().toLowerCase());
                                        //   // let hasSlash = /\//.test(cleanedText.trim().toLowerCase());

                                        // if (hasLetter || hasSlash) {
                                        //      resultTest = cleanedText
                                        //       .toLowerCase()
                                        //       .trim()
                                        //      answers =
                                        //       resultTest.split("|") || []
                                        //      firstAnswer = answers[0]
                                        //       ? answers[0].trim()
                                        //       : ""
                                        //      secondAnswer = answers[1]
                                        //       ? answers[1].trim()
                                        //       : ""
                                        //      answersArray = cleanedText.split("|").map(ans => ans.trim().toLowerCase()).filter(Boolean) || [];
                                        // }else{
                                        //      resultTest = cleanedText
                                        //       .toLowerCase()
                                        //       .trim().replace(/\s+/g, "")
                                        //      answers =
                                        //       resultTest.split("|") || []
                                        //      firstAnswer = answers[0]
                                        //       ? answers[0].trim().replace(/\s+/g, "")
                                        //       : ""
                                        //      secondAnswer = answers[1]
                                        //       ? answers[1].trim().replace(/\s+/g, "")
                                        //       : ""
                                        //      answersArray = cleanedText.split("|").map(ans => ans.trim().toLowerCase().replace(/\s+/g, "")).filter(Boolean) || [];
                                        // }
                                        //  //check "/" and any letters find logic end
                                        if (qusAns.answer_is_correct === 1) {
                                          let filteredStuAns =
                                            flattenedStuAnswers.filter(
                                              stuAns =>
                                                parseInt(stuAns.part_id) ===
                                                  parseInt(
                                                    qusAns.answer_part_id
                                                  ) &&
                                                (cleanAnswer(
                                                  stuAns.text
                                                    .toLowerCase()
                                                    .trim()
                                                ) == resultTest ||
                                                  cleanAnswer(
                                                    stuAns.text
                                                      .toLowerCase()
                                                      .trim()
                                                  ) == firstAnswer ||
                                                  cleanAnswer(
                                                    stuAns.text
                                                      .toLowerCase()
                                                      .trim()
                                                  ) == secondAnswer ||
                                                  answersArray.some(
                                                    answer =>
                                                      answer ==
                                                      cleanAnswer(stuAns.text)
                                                        .toLowerCase()
                                                        .trim()
                                                  )) &&
                                                parseInt(stuAns.answer_id) ===
                                                  parseInt(qusAns.answer_id) &&
                                                parseInt(
                                                  qusStuAns.attempt_status
                                                ) === 1
                                            ) || []

                                          let filteredAllStuAns =
                                            flattenedStuAnswers.filter(
                                              stuAns =>
                                                parseInt(stuAns.part_id) ===
                                                  parseInt(
                                                    qusAns.answer_part_id
                                                  ) &&
                                                parseInt(stuAns.answer_id) ===
                                                  parseInt(qusAns.answer_id)
                                            ) || []

                                          return (
                                            <>
                                              <li
                                                key={index1}
                                                className={
                                                  quspart.StudentAnsAttempts
                                                    .length > 0 &&
                                                  filteredStuAns.length > 0
                                                    ? "input_box m_input_box"
                                                    : "input_box m_input_box"
                                                }
                                              >
                                                <input
                                                  id={
                                                    index1 +
                                                    Math.floor(
                                                      Math.random() * 5
                                                    )
                                                  }
                                                  placeholder="Type your answer here..."
                                                  type="text"
                                                  autoFocus={true}
                                                  className={
                                                    quspart.StudentAnsAttempts
                                                      .length > 0
                                                      ? filteredStuAns.length >
                                                        0
                                                        ? "answersuccess"
                                                        : "answererror"
                                                      : "answereditor"
                                                  }
                                                  value={
                                                    resultData &&
                                                    resultData.is_correct &&
                                                    resultData.is_correct === 1
                                                      ? filteredAllStuAns
                                                          .filter(
                                                            item =>
                                                              parseInt(
                                                                item.answer_id
                                                              ) ===
                                                              parseInt(
                                                                qusAns.answer_id
                                                              )
                                                          )
                                                          .map(
                                                            item => item.text
                                                          )
                                                          .find(
                                                            text =>
                                                              text !== undefined
                                                          ) ||
                                                        selectedAnswerText
                                                          .filter(
                                                            item =>
                                                              parseInt(
                                                                item.answer_id
                                                              ) ===
                                                              parseInt(
                                                                qusAns.answer_id
                                                              )
                                                          )
                                                          .map(
                                                            item => item.text
                                                          )
                                                          .find(
                                                            text =>
                                                              text !== undefined
                                                          ) ||
                                                        "" // Find the first non-undefined text value
                                                      : selectedAnswerText
                                                          .filter(
                                                            item =>
                                                              parseInt(
                                                                item.answer_id
                                                              ) ===
                                                              parseInt(
                                                                qusAns.answer_id
                                                              )
                                                          )
                                                          .map(
                                                            item => item.text
                                                          )
                                                          .find(
                                                            text =>
                                                              text !== undefined
                                                          ) ||
                                                        filteredAllStuAns
                                                          .filter(
                                                            item =>
                                                              parseInt(
                                                                item.answer_id
                                                              ) ===
                                                              parseInt(
                                                                qusAns.answer_id
                                                              )
                                                          )
                                                          .map(
                                                            item => item.text
                                                          )
                                                          .find(
                                                            text =>
                                                              text !== undefined
                                                          ) ||
                                                        ""
                                                  }
                                                  autoComplete="off"
                                                  autoCorrect="off"
                                                  spellCheck="false"
                                                  disabled={
                                                    quspart.StudentAnsAttempts
                                                      .length > 0
                                                      ? filteredStuAns.length >
                                                        0
                                                        ? true
                                                        : true
                                                      : false
                                                  }
                                                  //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                  onChange={e =>
                                                    handletext(
                                                      e,
                                                      qusAns.answer_id,
                                                      qusAns.answer_part_id
                                                    )
                                                  }
                                                  // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                />
                                              </li>
                                              {nextQuestion &&
                                              SummryView === false &&
                                              qusAns &&
                                              skipAnchorEl
                                                ? createPortal(
                                                    <span
                                                      className="font-size-15 mt-1 text-danger fw-bold skip-button"
                                                      onClick={() =>
                                                        handletext(
                                                          ".",
                                                          qusAns.answer_id,
                                                          qusAns.answer_part_id,
                                                          1
                                                        )
                                                      }
                                                    >
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      version="1.1"
                                                      xmlnsXlink="http://www.w3.org/1999/xlink"
                                                      width={20}
                                                      height={20}
                                                      x={0}
                                                      y={0}
                                                      viewBox="0 0 24 25"
                                                      style={{
                                                        enableBackground:
                                                          "new 0 0 512 512",
                                                      }}
                                                      xmlSpace="preserve"
                                                      className=""
                                                    >
                                                      <g>
                                                        <path
                                                          fill="#ef0000"
                                                          fillRule="evenodd"
                                                          d="M9.676 8.205c0-2.256 2.568-3.553 4.383-2.212l6.822 5.037a2.75 2.75 0 0 1 0 4.424l-6.822 5.037c-1.815 1.34-4.383.044-4.383-2.212v-.035l-3.042 2.247c-1.816 1.34-4.384.044-4.384-2.212V8.205c0-2.256 2.568-3.553 4.384-2.212l3.042 2.246zm1.5 1.142 2.279 1.683a2.75 2.75 0 0 1 0 4.424l-2.28 1.683v1.142c0 1.025 1.168 1.615 1.993 1.005l6.821-5.036a1.25 1.25 0 0 0 0-2.012L13.17 7.2c-.826-.61-1.993-.02-1.993 1.005zM5.743 7.2c-.826-.61-1.993-.02-1.993 1.005V18.28c0 1.025 1.167 1.615 1.993 1.005l6.82-5.036a1.25 1.25 0 0 0 0-2.012z"
                                                          clipRule="evenodd"
                                                          opacity={1}
                                                          data-original="#000000"
                                                          className=""
                                                        />
                                                      </g>
                                                    </svg>{" "}
                                                    Skip Question
                                                  </span>,
                                                  skipAnchorEl
                                                )
                                              : null}
                                            </>
                                          )
                                        }
                                      }
                                    }
                                  )}
                              </ul>
                            ) : quspart.part_answer_type === 4 ? (
                              //const stuAnswersarray = stuAnswersJson.length > 0 ? JSON.parse(stuAnswersJson) : [];
                              <ul className="dg-selector choose-it-question width-controll list-unstyled mb-0">
                                {(
                                  shuffledAnswersMap[quspart.part_id] || []
                                ).map((qusAns, index1) => {
                                  const reorganizedAnswerArray = shuffleArray(
                                    rearrangeEvenOdd(quspart.question_answers)
                                  )
                                  console.log(reorganizedAnswerArray)
                                  const cleanText = qusAns.answer_text
                                    .replace(/&nbsp;/g, "")
                                    .replace(/`/g, "")
                                    .replace(/<[^>]*>/g, "")
                                    .trim()

                                  const hasImage = /<img\s+[^>]*>/gi.test(
                                    qusAns.answer_text
                                  )

                                  if (!cleanText && !hasImage) {
                                    return null // Skip rendering if english_answer_text is effectively empty and no image is present
                                  }

                                  serialNumber++

                                  let filteredStuAns =
                                    flattenedStuAnswers.filter(
                                      stuAns =>
                                        parseInt(stuAns.part_id) ===
                                          parseInt(qusAns.answer_part_id) &&
                                        parseInt(stuAns.answer_id) ===
                                          parseInt(qusAns.answer_id)
                                    ) || []

                                  var status_color =
                                    "selector-general cursor-pointer"
                                  var border_color = "border-start-secondary"
                                  if (filteredStuAns.length > 0) {
                                    if (
                                      parseInt(qusAns.answer_is_correct) === 1
                                    ) {
                                      status_color = "selector-success"
                                      border_color = "border-start-success"
                                      correct_count += 1
                                    } else {
                                      status_color = "selector-wrong "
                                      border_color = "border-start-danger"
                                    }
                                  }

                                  //console.log(selectedAnswer)
                                  //const sesKeys = quspart.StudentAnsAttempts.map(stuAns => stuAns.part_id); // Extracting session keys
                                  return (
                                    <>
                                      <li
                                        className={
                                          selectedAnswer &&
                                          Number(selectedAnswer) ===
                                            Number(qusAns.answer_id)
                                            ? `${status_color} active choose m_choose`
                                            : `${status_color} choose m_choose`
                                        }
                                        key={qusAns.answer_id}
                                        onClick={() =>
                                          selectedAnsOption(qusAns)
                                        }
                                      >
                                       <div
                                          style={{
                                            position: "absolute",
                                            left: "-40px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                          }}
                                          onClick={e =>
                                            e.stopPropagation()
                                          }
                                        >
                                          {renderSpeakerToggle(
                                            "ans-" + qusAns.answer_id,
                                            [qusAns.answer_text]
                                          )}
                                        </div>
                                        <div className="p-2 px-3 font-size-18 dg-serial-badge-wrap">
                                          <span className="dg-serial-badge">
                                            {serialNumber}
                                          </span>
                                        </div>

                                        <div
                                          className={`p-2 dg-media ${border_color}`}
                                          dangerouslySetInnerHTML={{
                                            __html: qusAns.answer_text || "",
                                          }}
                                        />
                                      </li>{" "}
                                      {index1 + 1 >=
                                        quspart.question_answers.length &&
                                      quspart.StudentAnsAttempts.length ===
                                        1 ? (
                                        correct_count > 0 ? null : (
                                          <div className="d-flex justify-content-end">
                                            <span className="text-danger font-size-14 mt-auto mb-2">
                                              Try again with a different answer.
                                            </span>
                                          </div>
                                        )
                                      ) : null}
                                      {nextQuestion &&
                                      SummryView === false &&
                                      index1 + 1 >=
                                        quspart.question_answers.length &&
                                      skipAnchorEl
                                        ? createPortal(
                                            <span
                                              className="font-size-15 mt-1 text-danger fw-bold skip-button"
                                              onClick={() =>
                                                selectedAnsOption(qusAns, 1)
                                              }
                                            >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              version="1.1"
                                              xmlnsXlink="http://www.w3.org/1999/xlink"
                                              width={20}
                                              height={20}
                                              x={0}
                                              y={0}
                                              viewBox="0 0 24 25"
                                              style={{
                                                enableBackground:
                                                  "new 0 0 512 512",
                                              }}
                                              xmlSpace="preserve"
                                              className=""
                                            >
                                              <g>
                                                <path
                                                  fill="#ef0000"
                                                  fillRule="evenodd"
                                                  d="M9.676 8.205c0-2.256 2.568-3.553 4.383-2.212l6.822 5.037a2.75 2.75 0 0 1 0 4.424l-6.822 5.037c-1.815 1.34-4.383.044-4.383-2.212v-.035l-3.042 2.247c-1.816 1.34-4.384.044-4.384-2.212V8.205c0-2.256 2.568-3.553 4.384-2.212l3.042 2.246zm1.5 1.142 2.279 1.683a2.75 2.75 0 0 1 0 4.424l-2.28 1.683v1.142c0 1.025 1.168 1.615 1.993 1.005l6.821-5.036a1.25 1.25 0 0 0 0-2.012L13.17 7.2c-.826-.61-1.993-.02-1.993 1.005zM5.743 7.2c-.826-.61-1.993-.02-1.993 1.005V18.28c0 1.025 1.167 1.615 1.993 1.005l6.82-5.036a1.25 1.25 0 0 0 0-2.012z"
                                                  clipRule="evenodd"
                                                  opacity={1}
                                                  data-original="#000000"
                                                  className=""
                                                />
                                              </g>
                                            </svg>{" "}
                                            Skip Question
                                          </span>,
                                          skipAnchorEl
                                        )
                                      : null}
                                    </>
                                  )
                                })}
                              </ul>
                            ) : (
                              <p className="text-center">No option</p>
                            )}
                            {/* Anse category statement end */}
                          </div>
                        )
                      })}
                  </li>
                </ul>
                <div className="d-flex justify-content-between align-items-center gap-3 mt-2 skip-submit-row">
                  <div className="skip-anchor" ref={setSkipAnchorEl}></div>
                  <div className="text-end">
                  {selectedAnswerText &&
                  selectedAnswerText != null &&
                  selectedAnswerText.length > 0 &&
                  nextQuestion &&
                  parseInt(IsSkipButton) !== 1 ? (
                    <Button
                      className="submit-btn-question btn btn-danger cs-btn-danger mt-1"
                      disabled={IsSubmited}
                      onClick={() => {
                        triggerSubmitFunction(selectedAnswerText)
                        setIsSubmited(true)
                      }}
                    >
                      Submit
                    </Button>
                  ) : null}
                  </div>
                </div>
                {renderNextButton()}

                {(!nextQuestion &&
                  parseInt(ActivityData1.is_current_tab_total_part) ===
                    parseInt(ActivityData1.is_current_tab_current_part)) ||
                SummryView === true ? (
                  <div className="navigator-wrapper position-relative pb-3 mt-4">
                    <div
                      style={getOverlayCardStyle()}
                      className={`nv-feedback-card feedback-${keyStage} ${
                        resultData && parseInt(resultData.is_correct) === 1
                          ? parseInt(resultData.attempCount) >= 2
                            ? "nv-feedback-card--warn"
                            : "nv-feedback-card--ok"
                          : resultData && !resultData.studentAnswer
                          ? "nv-feedback-card--skip"
                          : "nv-feedback-card--err"
                      }`}
                    >
                      {/* ── Main row: icon · status · coins + button ── */}
                      <div className="nv-feedback-card__main">
                        <div className="nv-feedback-card__icon">
                          {renderFeedbackIcon(resultData)}
                        </div>

                        <div className="nv-feedback-card__text">
                          <div className="nv-feedback-card__title-row">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                flexWrap: "wrap",
                              }}
                            >
                              <div className="nv-feedback-card__status-group">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <span
                                    className={`nv-feedback-card__title feedback-title-${keyStage} ${
                                      resultData &&
                                      parseInt(resultData.is_correct) === 1
                                        ? parseInt(resultData.attempCount) >= 2
                                          ? "nv-feedback-card__title--warn"
                                          : "nv-feedback-card__title--ok"
                                        : resultData &&
                                          !resultData.studentAnswer
                                        ? "nv-feedback-card__title--skip"
                                        : "nv-feedback-card__title--err"
                                    }`}
                                  >
                                    {resultData &&
                                    parseInt(resultData.is_correct) === 1
                                      ? "Correct!"
                                      : resultData && !resultData.studentAnswer
                                      ? "Skipped!"
                                      : "Incorrect"}
                                  </span>
                                  <ResultSpeakButton
                                    id={`result-${ActivityData?.question_id}`}
                                    activeId={activeId}
                                    speak={speak}
                                    resultData={resultData}
                                    parts={[
                                      resultData &&
                                      parseInt(resultData.is_correct) === 1
                                        ? "Correct! Great job!"
                                        : resultData &&
                                          !resultData.studentAnswer
                                        ? "Skipped! Give it a try!"
                                        : "Incorrect. Keep practising!",
                                      resultData?.studentAnswer
                                        ? `You answered: ${resultData.studentAnswer}`
                                        : null,
                                      ...mathFeedback.speechParts,
                                    ]}
                                  />
                                </div>
                                <p
                                  className={`nv-feedback-card__subtitle feedback-subtitle-${keyStage}`}
                                >
                                  {resultData &&
                                  parseInt(resultData.is_correct) === 1
                                    ? "Great job!"
                                    : resultData && !resultData.studentAnswer
                                    ? "Give it a try!"
                                    : "Keep practising!"}
                                </p>
                              </div>
                              <div className="nv-feedback-card__inline-stats">
                                <div className="nv-feedback-card__stat-item">
                                  <span className="nv-feedback-card__stat-label">
                                    ⏱ SUGGESTED TIME
                                  </span>
                                  <span className="nv-feedback-card__stat-value">
                                    {ActivityData.question_time_needed}
                                  </span>
                                </div>
                                <div className="nv-feedback-card__stat-sep" />
                                <div className="nv-feedback-card__stat-item">
                                  <span className="nv-feedback-card__stat-label">
                                    🎯 GOT IT RIGHT
                                  </span>
                                  <span className="nv-feedback-card__stat-value">
                                    {resultData
                                      ? parseInt(
                                          resultData.accuracyOfOtherStudents
                                        )
                                      : 0}
                                    %
                                  </span>
                                </div>
                              </div>
                              {resultData && resultData.studentAnswer ? (
                                <div
                                  className={`nv-answer-box answer-box-${keyStage} ${
                                    parseInt(resultData.is_correct) === 1
                                      ? parseInt(resultData.attempCount) >= 2
                                        ? "nv-answer-box--warn"
                                        : "nv-answer-box--ok"
                                      : "nv-answer-box--err"
                                  }`}
                                >
                                  <div className="nv-answer-box__col nv-answer-box__col--answer">
                                    <span className="nv-answer-box__label">
                                      You answered:
                                    </span>
                                    <p
                                      className={`nv-answer-box__value answer-value-${keyStage}`}
                                      dangerouslySetInnerHTML={{
                                        __html: resultData.studentAnswer,
                                      }}
                                    />
                                  </div>
                                  {!mathFeedback.allSkipped &&
                                  mathFeedback.hasContent ? (
                                    <>
                                      <div className="nv-answer-box__divider" />
                                      <div className="nv-answer-box__col nv-answer-box__col--explanation">
                                        <span className="nv-answer-box__label">
                                          Explanation:
                                        </span>
                                        <div
                                          className={`nv-answer-box__text answer-text-${keyStage}`}
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              mathFeedback.explanationHtml,
                                          }}
                                        />
                                      </div>
                                    </>
                                  ) : null}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        <div
                          className="nv-feedback-card__actions"
                          style={{ alignSelf: "flex-start", justifyContent: "flex-end", alignItems: "flex-end" }}
                          ref={navigatorRef}
                        >
                          {/* Coin badge */}
                          <div className="nv-feedback-card__coin-badge">
                            <img width={32} src={awicon} alt="coins" />
                            <div className="nv-feedback-card__coin-text">
                              <span className="nv-feedback-card__coin-num">
                                {resultData &&
                                parseInt(resultData.is_correct) === 1
                                  ? "+"
                                  : ""}
                                {resultData && resultData?.points && parseInt(resultData.is_correct) !== 3 ? resultData.points : 0}
                              </span>
                              <span className="nv-feedback-card__coin-lbl">
                                coins
                              </span>
                            </div>
                          </div>

                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                            {resultData &&
                            resultData.LastQuestion &&
                            parseInt(SkipQuestionCount) > 0 ? (
                              <>
                                <Button
                                  className="btn btn-danger cs-btn-danger mt-1 nv-feedback-card__btn"
                                  onClick={() => trySkipQuestion()}
                                >
                                  Attempt {SkipQuestionCount} skipped questions
                                </Button>
                                <p className="font-size-16 d-flex align-items-center gap-2" style={{ margin: 0 }}>
                                  OR
                                </p>
                              </>
                            ) : null}

                            {resultData ? (
                              !resultData.LastQuestion ? (
                                <Button
                                  className="next-btn-question btn btn-danger cs-btn-danger mt-1 nv-feedback-card__btn"
                                  onClick={() => {
                                    //window.location.reload();
                                    triggerFunction()
                                    setnextQuestion(false)
                                    setActivePartData([])
                                    setIsSubmited(false)
                                    setresultData(null)
                                  }}
                                >
                                  Next Question&nbsp;
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-fast-forward-icon lucide-fast-forward"
                                  >
                                    <path d="M12 6a2 2 0 0 1 3.414-1.414l6 6a2 2 0 0 1 0 2.828l-6 6A2 2 0 0 1 12 18z" />
                                    <path d="M2 6a2 2 0 0 1 3.414-1.414l6 6a2 2 0 0 1 0 2.828l-6 6A2 2 0 0 1 2 18z" />
                                  </svg>
                                </Button>
                              ) : (
                                <Button
                                  className="summary-btn-question btn btn-danger cs-btn-danger mt-1 nv-feedback-card__btn"
                                  onClick={() => assessementSummary()}
                                >
                                  Finish
                                </Button>
                              )
                            ) : null}
                          </div>
                        </div>
                      </div>
                      {/* Marked incorrectly link */}
                      {resultData &&
                      resultData.attempCount &&
                      parseInt(resultData.attempCount) >= 2 ? (
                        <span
                          className="font-size-15 text-dark fw-bold"
                          onClick={tog_standard1}
                          style={{
                            fontStyle: "italic",
                            textDecoration: "underline",
                            cursor: "pointer",
                            display: "block",
                            textAlign: "center",
                          }}
                        >
                          It was marked incorrectly
                        </span>
                      ) : null}
                    </div>
                  </div>
                ) : null}
              </div>
            )
          } else {
            //return <p className="text-center">No question</p>
            return (
              <div
                style={getOverlayCardStyle()}
                className={`hw-list mt-2 ${
                  localStorage.getItem("is_fontsize") == 1
                    ? "stu-custom-font-size"
                    : ""
                }`}
              >
                <div className="d-flex justify-content-end">
                  {renderOverlayToggle()}
                </div>
                <div className="navigator-wrapper position-relative pb-3 mt-4">
                  {/* <div className="nv-dg-smile">
                          <img width={400} src={dsmile} alt="" /> 
                        </div> */}
                  <div className="nv-dg-smile-avatar">
                    {/* <img width={400} src={dsmile} alt="" /> */}
                    <div className="avatar-wrapper">
                      {/* student avatar start */}
                      <div className="super-profile_wrapper img-consolidate-display">
                        <div className="content-left">
                          <div className="super-avatar-display">
                            {/* <Slide
                                  autoplay={false}
                                  infinite={false}
                                  onStartChange={togAvatarGendar}
                                  {...properties}
                                > */}
                            {/* male functionality start */}
                            {!AvatarGendar ? (
                              <div className="each-slide-effect cursor-pointer">
                                <div className="pirate-media male position-relative">
                                  <div className="avatar-display text-center position-relative">
                                    <div className="avatar-default">
                                      <img
                                        width={450}
                                        className=""
                                        src={piratemale}
                                        alt=""
                                      />
                                    </div>
                                    <div className="avatar-attachments">
                                      {maleAvatarHeadData &&
                                      maleAvatarHeadData != "" &&
                                      maleAvatarHeadData.image ? (
                                        <div className="head-float position-absolute">
                                          <img
                                            className=""
                                            src={modifyUrl(
                                              maleAvatarHeadData.image
                                            )}
                                            alt=""
                                          />
                                        </div>
                                      ) : null}

                                      {maleAvatarArmourData &&
                                      maleAvatarArmourData != "" &&
                                      maleAvatarArmourData.image ? (
                                        <div className="dress-float position-absolute">
                                          <img
                                            className=""
                                            src={maleAvatarArmourData.image}
                                            alt=""
                                          />
                                        </div>
                                      ) : null}

                                      {maleAvatarPetData &&
                                      maleAvatarPetData != "" &&
                                      maleAvatarPetData.image ? (
                                        <div className="companion-float position-absolute">
                                          <img
                                            className=""
                                            src={maleAvatarPetData.image}
                                            alt=""
                                          />
                                        </div>
                                      ) : null}

                                      {maleAvatarHandData &&
                                      maleAvatarHandData != "" &&
                                      maleAvatarHandData.image ? (
                                        <>
                                          <div className="hand-float position-absolute">
                                            <img
                                              className=""
                                              src={maleAvatarHandData.image}
                                              alt=""
                                            />
                                          </div>

                                          <div className="hand-float-revert position-absolute">
                                            <img
                                              className=""
                                              src={maleAvatarHandData.image}
                                              alt=""
                                            />
                                          </div>
                                        </>
                                      ) : null}

                                      {maleAvatarWeaponData &&
                                      maleAvatarWeaponData != "" &&
                                      maleAvatarWeaponData.image ? (
                                        <div className="weapon-float position-absolute">
                                          <img
                                            className=""
                                            src={maleAvatarWeaponData.image}
                                            alt=""
                                          />
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className="each-slide-effect cursor-pointer">
                                <div className="pirate-media female position-relative">
                                  <div className="avatar-display text-center position-relative">
                                    <div className="avatar-default">
                                      <img
                                        width={450}
                                        className=""
                                        src={piratefemale}
                                        alt=""
                                      />
                                    </div>
                                    <div className="avatar-attachments">
                                      {femaleAvatarHeadData &&
                                      femaleAvatarHeadData != "" &&
                                      femaleAvatarHeadData.image ? (
                                        <div className="head-float female-hd position-absolute">
                                          <img
                                            className=""
                                            src={modifyUrl(
                                              femaleAvatarHeadData.image
                                            )}
                                            alt=""
                                          />
                                        </div>
                                      ) : null}

                                      {femaleAvatarArmourData &&
                                      femaleAvatarArmourData != "" &&
                                      femaleAvatarArmourData.image ? (
                                        <div className="dress-float position-absolute">
                                          <img
                                            className=""
                                            src={femaleAvatarArmourData.image}
                                            alt=""
                                          />
                                        </div>
                                      ) : null}

                                      {femaleAvatarPetData &&
                                      femaleAvatarPetData != "" &&
                                      femaleAvatarPetData.image ? (
                                        <div className="companion-float position-absolute">
                                          <img
                                            className=""
                                            src={femaleAvatarPetData.image}
                                            alt=""
                                          />
                                        </div>
                                      ) : null}

                                      {femaleAvatarHandData &&
                                      femaleAvatarHandData != "" &&
                                      femaleAvatarHandData.image ? (
                                        <>
                                          <div className="hand-float position-absolute">
                                            <img
                                              className=""
                                              src={femaleAvatarHandData.image}
                                              alt=""
                                            />
                                          </div>
                                          <div className="hand-float-revert position-absolute">
                                            <img
                                              className=""
                                              src={femaleAvatarHandData.image}
                                              alt=""
                                            />
                                          </div>
                                        </>
                                      ) : null}

                                      {femaleAvatarWeaponData &&
                                      femaleAvatarWeaponData != "" &&
                                      femaleAvatarWeaponData.image ? (
                                        <div className="weapon-float position-absolute">
                                          <img
                                            className=""
                                            src={femaleAvatarWeaponData.image}
                                            alt=""
                                          />
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Female functionality end */}
                            {/* </Slide> */}
                          </div>
                        </div>
                      </div>

                      {/* student avatar end */}
                    </div>
                  </div>
                  <div className="navigator-nxt" ref={navigatorRef}>
                    <p className="opacity-75">No questions are available.</p>
                    {/* <p className="font-size-16 d-flex align-items-center gap-2">
                            <img width={24} src={awicon} />{" "}
                            {resultData ? resultData.points : 0} /{" "}
                            {resultData && resultData.question_length
                              ? resultData.question_length * 2
                              : 0}{" "}
                            coins
                          </p> */}
                    {parseInt(SkipQuestionCount) > 0 ? (
                      <>
                        <div className="p-3">
                          <Button
                            className="btn btn-danger cs-btn-danger mt-1 nv-feedback-card__btn"
                            onClick={() => trySkipQuestion()}
                          >
                            Attempt {SkipQuestionCount} skipped questions
                          </Button>
                        </div>
                        <p className="font-size-16 d-flex align-items-center gap-2">
                          OR
                        </p>
                      </>
                    ) : null}
                    {/* <p className="opacity-75">{parseInt(resultData.accuracyOfOtherStudents)}% OF STUDENTS GOT IT RIGHT</p> */}

                    <Button
                      className="summary-btn-question btn btn-danger cs-btn-danger mt-1 nv-feedback-card__btn"
                      onClick={() => finishQuestion()}
                    >
                      Finish
                    </Button>
                  </div>
                </div>
              </div>
            )
          }
        }
      })
    ) : (
      // <p>No Question</p>
      <div
        style={getOverlayCardStyle()}
        className={`hw-list mt-2 ${
          localStorage.getItem("is_fontsize") == 1 ? "stu-custom-font-size" : ""
        }`}
      >
        <div className="d-flex justify-content-end">
          {renderOverlayToggle()}
        </div>
        <div className="navigator-wrapper position-relative pb-3 mt-4">
          <div className="nv-dg-smile-avatar">
            {/* <img width={400} src={dsmile} alt="" /> */}
            <div className="avatar-wrapper">
              {/* student avatar start */}
              <div className="super-profile_wrapper img-consolidate-display">
                <div className="content-left">
                  <div className="super-avatar-display">
                    {/* male functionality start */}
                    {!AvatarGendar ? (
                      <div className="each-slide-effect cursor-pointer">
                        <div className="pirate-media male position-relative">
                          <div className="avatar-display text-center position-relative">
                            <div className="avatar-default">
                              <img
                                width={450}
                                className=""
                                src={piratemale}
                                alt=""
                              />
                            </div>
                            <div className="avatar-attachments">
                              {maleAvatarHeadData &&
                              maleAvatarHeadData != "" &&
                              maleAvatarHeadData.image ? (
                                <div className="head-float position-absolute">
                                  <img
                                    className=""
                                    src={modifyUrl(maleAvatarHeadData.image)}
                                    alt=""
                                  />
                                </div>
                              ) : null}

                              {maleAvatarArmourData &&
                              maleAvatarArmourData != "" &&
                              maleAvatarArmourData.image ? (
                                <div className="dress-float position-absolute">
                                  <img
                                    className=""
                                    src={maleAvatarArmourData.image}
                                    alt=""
                                  />
                                </div>
                              ) : null}

                              {maleAvatarPetData &&
                              maleAvatarPetData != "" &&
                              maleAvatarPetData.image ? (
                                <div className="companion-float position-absolute">
                                  <img
                                    className=""
                                    src={maleAvatarPetData.image}
                                    alt=""
                                  />
                                </div>
                              ) : null}

                              {maleAvatarHandData &&
                              maleAvatarHandData != "" &&
                              maleAvatarHandData.image ? (
                                <>
                                  <div className="hand-float position-absolute">
                                    <img
                                      className=""
                                      src={maleAvatarHandData.image}
                                      alt=""
                                    />
                                  </div>

                                  <div className="hand-float-revert position-absolute">
                                    <img
                                      className=""
                                      src={maleAvatarHandData.image}
                                      alt=""
                                    />
                                  </div>
                                </>
                              ) : null}

                              {maleAvatarWeaponData &&
                              maleAvatarWeaponData != "" &&
                              maleAvatarWeaponData.image ? (
                                <div className="weapon-float position-absolute">
                                  <img
                                    className=""
                                    src={maleAvatarWeaponData.image}
                                    alt=""
                                  />
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="each-slide-effect cursor-pointer">
                        <div className="pirate-media female position-relative">
                          <div className="avatar-display text-center position-relative">
                            <div className="avatar-default">
                              <img
                                width={450}
                                className=""
                                src={piratefemale}
                                alt=""
                              />
                            </div>
                            <div className="avatar-attachments">
                              {femaleAvatarHeadData &&
                              femaleAvatarHeadData != "" &&
                              femaleAvatarHeadData.image ? (
                                <div className="head-float female-hd position-absolute">
                                  <img
                                    className=""
                                    src={modifyUrl(femaleAvatarHeadData.image)}
                                    alt=""
                                  />
                                </div>
                              ) : null}

                              {femaleAvatarArmourData &&
                              femaleAvatarArmourData != "" &&
                              femaleAvatarArmourData.image ? (
                                <div className="dress-float position-absolute">
                                  <img
                                    className=""
                                    src={femaleAvatarArmourData.image}
                                    alt=""
                                  />
                                </div>
                              ) : null}

                              {femaleAvatarPetData &&
                              femaleAvatarPetData != "" &&
                              femaleAvatarPetData.image ? (
                                <div className="companion-float position-absolute">
                                  <img
                                    className=""
                                    src={femaleAvatarPetData.image}
                                    alt=""
                                  />
                                </div>
                              ) : null}

                              {femaleAvatarHandData &&
                              femaleAvatarHandData != "" &&
                              femaleAvatarHandData.image ? (
                                <>
                                  <div className="hand-float position-absolute">
                                    <img
                                      className=""
                                      src={femaleAvatarHandData.image}
                                      alt=""
                                    />
                                  </div>
                                  <div className="hand-float-revert position-absolute">
                                    <img
                                      className=""
                                      src={femaleAvatarHandData.image}
                                      alt=""
                                    />
                                  </div>
                                </>
                              ) : null}

                              {femaleAvatarWeaponData &&
                              femaleAvatarWeaponData != "" &&
                              femaleAvatarWeaponData.image ? (
                                <div className="weapon-float position-absolute">
                                  <img
                                    className=""
                                    src={femaleAvatarWeaponData.image}
                                    alt=""
                                  />
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Female functionality end */}
                  </div>
                </div>
              </div>

              {/* student avatar end */}
            </div>
          </div>
          <div className="navigator-nxt" ref={navigatorRef}>
            <p className="opacity-75">No questions are available.</p>

            {parseInt(SkipQuestionCount) > 0 ? (
              <>
                <div className="p-3">
                  <Button
                    className="btn btn-danger cs-btn-danger mt-1 nv-feedback-card__btn"
                    onClick={() => trySkipQuestion()}
                  >
                    Attempt {SkipQuestionCount} skipped questions
                  </Button>
                </div>
                <p className="font-size-16 d-flex align-items-center gap-2">
                  OR
                </p>
              </>
            ) : null}

            <Button
              className="summary-btn-question btn btn-danger cs-btn-danger mt-1"
              onClick={() => finishQuestion()}
            >
              Finish
            </Button>
          </div>
        </div>
      </div>
    )
  }
)

export default Comprehension
